package com.github.jangalinski.tabweb.icon

import androidx.compose.runtime.Composable
import com.github.jangalinski.tabweb._foundation.css.CssClass
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames

/**
 * Generated from Tabweb Icons CSS 3.46.0. Do not edit manually.
 */
enum class TabwebIcon(
  val value: String
) : CssClass, Icon {
  TI_12_HOURS("ti-12-hours"),
  TI_123("ti-123"),
  TI_24_HOURS("ti-24-hours"),
  TI_2FA("ti-2fa"),
  TI_360("ti-360"),
  TI_360_VIEW("ti-360-view"),
  TI_3D_CUBE_SPHERE("ti-3d-cube-sphere"),
  TI_3D_CUBE_SPHERE_OFF("ti-3d-cube-sphere-off"),
  TI_3D_ROTATE("ti-3d-rotate"),
  TI_A_B("ti-a-b"),
  TI_A_B_2("ti-a-b-2"),
  TI_A_B_OFF("ti-a-b-off"),
  TI_ABACUS("ti-abacus"),
  TI_ABACUS_OFF("ti-abacus-off"),
  TI_ABC("ti-abc"),
  TI_ACCESS_POINT("ti-access-point"),
  TI_ACCESS_POINT_OFF("ti-access-point-off"),
  TI_ACCESSIBLE("ti-accessible"),
  TI_ACCESSIBLE_OFF("ti-accessible-off"),
  TI_ACORN("ti-acorn"),
  TI_ACROBATIC("ti-acrobatic"),
  TI_ACTIVITY("ti-activity"),
  TI_ACTIVITY_HEARTBEAT("ti-activity-heartbeat"),
  TI_AD("ti-ad"),
  TI_AD_2("ti-ad-2"),
  TI_AD_CIRCLE("ti-ad-circle"),
  TI_AD_CIRCLE_OFF("ti-ad-circle-off"),
  TI_AD_OFF("ti-ad-off"),
  TI_ADDRESS_BOOK("ti-address-book"),
  TI_ADDRESS_BOOK_OFF("ti-address-book-off"),
  TI_ADJUSTMENTS("ti-adjustments"),
  TI_ADJUSTMENTS_ALT("ti-adjustments-alt"),
  TI_ADJUSTMENTS_BOLT("ti-adjustments-bolt"),
  TI_ADJUSTMENTS_CANCEL("ti-adjustments-cancel"),
  TI_ADJUSTMENTS_CHECK("ti-adjustments-check"),
  TI_ADJUSTMENTS_CODE("ti-adjustments-code"),
  TI_ADJUSTMENTS_COG("ti-adjustments-cog"),
  TI_ADJUSTMENTS_DOLLAR("ti-adjustments-dollar"),
  TI_ADJUSTMENTS_DOWN("ti-adjustments-down"),
  TI_ADJUSTMENTS_EXCLAMATION("ti-adjustments-exclamation"),
  TI_ADJUSTMENTS_HEART("ti-adjustments-heart"),
  TI_ADJUSTMENTS_HORIZONTAL("ti-adjustments-horizontal"),
  TI_ADJUSTMENTS_MINUS("ti-adjustments-minus"),
  TI_ADJUSTMENTS_OFF("ti-adjustments-off"),
  TI_ADJUSTMENTS_PAUSE("ti-adjustments-pause"),
  TI_ADJUSTMENTS_PIN("ti-adjustments-pin"),
  TI_ADJUSTMENTS_PLUS("ti-adjustments-plus"),
  TI_ADJUSTMENTS_QUESTION("ti-adjustments-question"),
  TI_ADJUSTMENTS_SEARCH("ti-adjustments-search"),
  TI_ADJUSTMENTS_SHARE("ti-adjustments-share"),
  TI_ADJUSTMENTS_SPARK("ti-adjustments-spark"),
  TI_ADJUSTMENTS_STAR("ti-adjustments-star"),
  TI_ADJUSTMENTS_UP("ti-adjustments-up"),
  TI_ADJUSTMENTS_X("ti-adjustments-x"),
  TI_AERIAL_LIFT("ti-aerial-lift"),
  TI_AFFILIATE("ti-affiliate"),
  TI_AI("ti-ai"),
  TI_AI_AGENT("ti-ai-agent"),
  TI_AI_AGENTS("ti-ai-agents"),
  TI_AI_GATEWAY("ti-ai-gateway"),
  TI_AIR_BALLOON("ti-air-balloon"),
  TI_AIR_CONDITIONING("ti-air-conditioning"),
  TI_AIR_CONDITIONING_DISABLED("ti-air-conditioning-disabled"),
  TI_AIR_TRAFFIC_CONTROL("ti-air-traffic-control"),
  TI_ALARM("ti-alarm"),
  TI_ALARM_AVERAGE("ti-alarm-average"),
  TI_ALARM_MINUS("ti-alarm-minus"),
  TI_ALARM_OFF("ti-alarm-off"),
  TI_ALARM_PLUS("ti-alarm-plus"),
  TI_ALARM_SMOKE("ti-alarm-smoke"),
  TI_ALARM_SNOOZE("ti-alarm-snooze"),
  TI_ALBUM("ti-album"),
  TI_ALBUM_OFF("ti-album-off"),
  TI_ALERT_CIRCLE("ti-alert-circle"),
  TI_ALERT_CIRCLE_OFF("ti-alert-circle-off"),
  TI_ALERT_HEXAGON("ti-alert-hexagon"),
  TI_ALERT_HEXAGON_OFF("ti-alert-hexagon-off"),
  TI_ALERT_OCTAGON("ti-alert-octagon"),
  TI_ALERT_SMALL("ti-alert-small"),
  TI_ALERT_SMALL_OFF("ti-alert-small-off"),
  TI_ALERT_SQUARE("ti-alert-square"),
  TI_ALERT_SQUARE_ROUNDED("ti-alert-square-rounded"),
  TI_ALERT_SQUARE_ROUNDED_OFF("ti-alert-square-rounded-off"),
  TI_ALERT_TRIANGLE("ti-alert-triangle"),
  TI_ALERT_TRIANGLE_OFF("ti-alert-triangle-off"),
  TI_ALIEN("ti-alien"),
  TI_ALIGN_BOX_BOTTOM_CENTER("ti-align-box-bottom-center"),
  TI_ALIGN_BOX_BOTTOM_LEFT("ti-align-box-bottom-left"),
  TI_ALIGN_BOX_BOTTOM_RIGHT("ti-align-box-bottom-right"),
  TI_ALIGN_BOX_CENTER_BOTTOM("ti-align-box-center-bottom"),
  TI_ALIGN_BOX_CENTER_MIDDLE("ti-align-box-center-middle"),
  TI_ALIGN_BOX_CENTER_STRETCH("ti-align-box-center-stretch"),
  TI_ALIGN_BOX_CENTER_TOP("ti-align-box-center-top"),
  TI_ALIGN_BOX_LEFT_BOTTOM("ti-align-box-left-bottom"),
  TI_ALIGN_BOX_LEFT_MIDDLE("ti-align-box-left-middle"),
  TI_ALIGN_BOX_LEFT_STRETCH("ti-align-box-left-stretch"),
  TI_ALIGN_BOX_LEFT_TOP("ti-align-box-left-top"),
  TI_ALIGN_BOX_RIGHT_BOTTOM("ti-align-box-right-bottom"),
  TI_ALIGN_BOX_RIGHT_MIDDLE("ti-align-box-right-middle"),
  TI_ALIGN_BOX_RIGHT_STRETCH("ti-align-box-right-stretch"),
  TI_ALIGN_BOX_RIGHT_TOP("ti-align-box-right-top"),
  TI_ALIGN_BOX_TOP_CENTER("ti-align-box-top-center"),
  TI_ALIGN_BOX_TOP_LEFT("ti-align-box-top-left"),
  TI_ALIGN_BOX_TOP_RIGHT("ti-align-box-top-right"),
  TI_ALIGN_CENTER("ti-align-center"),
  TI_ALIGN_JUSTIFIED("ti-align-justified"),
  TI_ALIGN_LEFT("ti-align-left"),
  TI_ALIGN_LEFT_2("ti-align-left-2"),
  TI_ALIGN_RIGHT("ti-align-right"),
  TI_ALIGN_RIGHT_2("ti-align-right-2"),
  TI_ALPHA("ti-alpha"),
  TI_ALPHABET_ARABIC("ti-alphabet-arabic"),
  TI_ALPHABET_BANGLA("ti-alphabet-bangla"),
  TI_ALPHABET_CYRILLIC("ti-alphabet-cyrillic"),
  TI_ALPHABET_GREEK("ti-alphabet-greek"),
  TI_ALPHABET_HEBREW("ti-alphabet-hebrew"),
  TI_ALPHABET_KOREAN("ti-alphabet-korean"),
  TI_ALPHABET_LATIN("ti-alphabet-latin"),
  TI_ALPHABET_POLISH("ti-alphabet-polish"),
  TI_ALPHABET_RUNES("ti-alphabet-runes"),
  TI_ALPHABET_THAI("ti-alphabet-thai"),
  TI_ALT("ti-alt"),
  TI_AMBULANCE("ti-ambulance"),
  TI_AMPERSAND("ti-ampersand"),
  TI_ANALYZE("ti-analyze"),
  TI_ANALYZE_OFF("ti-analyze-off"),
  TI_ANCHOR("ti-anchor"),
  TI_ANCHOR_OFF("ti-anchor-off"),
  TI_ANGLE("ti-angle"),
  TI_ANKH("ti-ankh"),
  TI_ANTENNA("ti-antenna"),
  TI_ANTENNA_BARS_1("ti-antenna-bars-1"),
  TI_ANTENNA_BARS_2("ti-antenna-bars-2"),
  TI_ANTENNA_BARS_3("ti-antenna-bars-3"),
  TI_ANTENNA_BARS_4("ti-antenna-bars-4"),
  TI_ANTENNA_BARS_5("ti-antenna-bars-5"),
  TI_ANTENNA_BARS_OFF("ti-antenna-bars-off"),
  TI_ANTENNA_OFF("ti-antenna-off"),
  TI_APERTURE("ti-aperture"),
  TI_APERTURE_OFF("ti-aperture-off"),
  TI_API("ti-api"),
  TI_API_APP("ti-api-app"),
  TI_API_APP_OFF("ti-api-app-off"),
  TI_API_BOOK("ti-api-book"),
  TI_API_OFF("ti-api-off"),
  TI_APP_WINDOW("ti-app-window"),
  TI_APP_WINDOW_BOTTOM("ti-app-window-bottom"),
  TI_APP_WINDOW_BOTTOM_LEFT("ti-app-window-bottom-left"),
  TI_APP_WINDOW_BOTTOM_RIGHT("ti-app-window-bottom-right"),
  TI_APP_WINDOW_CENTER("ti-app-window-center"),
  TI_APPLE("ti-apple"),
  TI_APPS("ti-apps"),
  TI_APPS_OFF("ti-apps-off"),
  TI_ARCHERY_ARROW("ti-archery-arrow"),
  TI_ARCHIVE("ti-archive"),
  TI_ARCHIVE_OFF("ti-archive-off"),
  TI_ARMCHAIR("ti-armchair"),
  TI_ARMCHAIR_2("ti-armchair-2"),
  TI_ARMCHAIR_2_OFF("ti-armchair-2-off"),
  TI_ARMCHAIR_OFF("ti-armchair-off"),
  TI_ARROW_AUTOFIT_CONTENT("ti-arrow-autofit-content"),
  TI_ARROW_AUTOFIT_DOWN("ti-arrow-autofit-down"),
  TI_ARROW_AUTOFIT_HEIGHT("ti-arrow-autofit-height"),
  TI_ARROW_AUTOFIT_LEFT("ti-arrow-autofit-left"),
  TI_ARROW_AUTOFIT_RIGHT("ti-arrow-autofit-right"),
  TI_ARROW_AUTOFIT_UP("ti-arrow-autofit-up"),
  TI_ARROW_AUTOFIT_WIDTH("ti-arrow-autofit-width"),
  TI_ARROW_BACK("ti-arrow-back"),
  TI_ARROW_BACK_UP("ti-arrow-back-up"),
  TI_ARROW_BACK_UP_DOUBLE("ti-arrow-back-up-double"),
  TI_ARROW_BADGE_DOWN("ti-arrow-badge-down"),
  TI_ARROW_BADGE_LEFT("ti-arrow-badge-left"),
  TI_ARROW_BADGE_RIGHT("ti-arrow-badge-right"),
  TI_ARROW_BADGE_UP("ti-arrow-badge-up"),
  TI_ARROW_BAR_BOTH("ti-arrow-bar-both"),
  TI_ARROW_BAR_DOWN("ti-arrow-bar-down"),
  TI_ARROW_BAR_LEFT("ti-arrow-bar-left"),
  TI_ARROW_BAR_RIGHT("ti-arrow-bar-right"),
  TI_ARROW_BAR_TO_DOWN("ti-arrow-bar-to-down"),
  TI_ARROW_BAR_TO_DOWN_DASHED("ti-arrow-bar-to-down-dashed"),
  TI_ARROW_BAR_TO_LEFT("ti-arrow-bar-to-left"),
  TI_ARROW_BAR_TO_LEFT_DASHED("ti-arrow-bar-to-left-dashed"),
  TI_ARROW_BAR_TO_RIGHT("ti-arrow-bar-to-right"),
  TI_ARROW_BAR_TO_RIGHT_DASHED("ti-arrow-bar-to-right-dashed"),
  TI_ARROW_BAR_TO_UP("ti-arrow-bar-to-up"),
  TI_ARROW_BAR_TO_UP_DASHED("ti-arrow-bar-to-up-dashed"),
  TI_ARROW_BAR_UP("ti-arrow-bar-up"),
  TI_ARROW_BEAR_LEFT("ti-arrow-bear-left"),
  TI_ARROW_BEAR_LEFT_2("ti-arrow-bear-left-2"),
  TI_ARROW_BEAR_RIGHT("ti-arrow-bear-right"),
  TI_ARROW_BEAR_RIGHT_2("ti-arrow-bear-right-2"),
  TI_ARROW_BIG_DOWN("ti-arrow-big-down"),
  TI_ARROW_BIG_DOWN_LINE("ti-arrow-big-down-line"),
  TI_ARROW_BIG_DOWN_LINES("ti-arrow-big-down-lines"),
  TI_ARROW_BIG_LEFT("ti-arrow-big-left"),
  TI_ARROW_BIG_LEFT_LINE("ti-arrow-big-left-line"),
  TI_ARROW_BIG_LEFT_LINES("ti-arrow-big-left-lines"),
  TI_ARROW_BIG_RIGHT("ti-arrow-big-right"),
  TI_ARROW_BIG_RIGHT_LINE("ti-arrow-big-right-line"),
  TI_ARROW_BIG_RIGHT_LINES("ti-arrow-big-right-lines"),
  TI_ARROW_BIG_UP("ti-arrow-big-up"),
  TI_ARROW_BIG_UP_LINE("ti-arrow-big-up-line"),
  TI_ARROW_BIG_UP_LINES("ti-arrow-big-up-lines"),
  TI_ARROW_BOUNCE("ti-arrow-bounce"),
  TI_ARROW_CAPSULE("ti-arrow-capsule"),
  TI_ARROW_CURVE_LEFT("ti-arrow-curve-left"),
  TI_ARROW_CURVE_RIGHT("ti-arrow-curve-right"),
  TI_ARROW_DOWN("ti-arrow-down"),
  TI_ARROW_DOWN_BAR("ti-arrow-down-bar"),
  TI_ARROW_DOWN_CIRCLE("ti-arrow-down-circle"),
  TI_ARROW_DOWN_DASHED("ti-arrow-down-dashed"),
  TI_ARROW_DOWN_FROM_ARC("ti-arrow-down-from-arc"),
  TI_ARROW_DOWN_LEFT("ti-arrow-down-left"),
  TI_ARROW_DOWN_LEFT_CIRCLE("ti-arrow-down-left-circle"),
  TI_ARROW_DOWN_RHOMBUS("ti-arrow-down-rhombus"),
  TI_ARROW_DOWN_RIGHT("ti-arrow-down-right"),
  TI_ARROW_DOWN_RIGHT_CIRCLE("ti-arrow-down-right-circle"),
  TI_ARROW_DOWN_SQUARE("ti-arrow-down-square"),
  TI_ARROW_DOWN_TAIL("ti-arrow-down-tail"),
  TI_ARROW_DOWN_TO_ARC("ti-arrow-down-to-arc"),
  TI_ARROW_ELBOW_LEFT("ti-arrow-elbow-left"),
  TI_ARROW_ELBOW_RIGHT("ti-arrow-elbow-right"),
  TI_ARROW_FORK("ti-arrow-fork"),
  TI_ARROW_FORK_TRIPLE("ti-arrow-fork-triple"),
  TI_ARROW_FORWARD("ti-arrow-forward"),
  TI_ARROW_FORWARD_UP("ti-arrow-forward-up"),
  TI_ARROW_FORWARD_UP_DOUBLE("ti-arrow-forward-up-double"),
  TI_ARROW_GUIDE("ti-arrow-guide"),
  TI_ARROW_ITERATION("ti-arrow-iteration"),
  TI_ARROW_LEFT("ti-arrow-left"),
  TI_ARROW_LEFT_BAR("ti-arrow-left-bar"),
  TI_ARROW_LEFT_CIRCLE("ti-arrow-left-circle"),
  TI_ARROW_LEFT_DASHED("ti-arrow-left-dashed"),
  TI_ARROW_LEFT_FROM_ARC("ti-arrow-left-from-arc"),
  TI_ARROW_LEFT_RHOMBUS("ti-arrow-left-rhombus"),
  TI_ARROW_LEFT_RIGHT("ti-arrow-left-right"),
  TI_ARROW_LEFT_SQUARE("ti-arrow-left-square"),
  TI_ARROW_LEFT_TAIL("ti-arrow-left-tail"),
  TI_ARROW_LEFT_TO_ARC("ti-arrow-left-to-arc"),
  TI_ARROW_LOOP_LEFT("ti-arrow-loop-left"),
  TI_ARROW_LOOP_LEFT_2("ti-arrow-loop-left-2"),
  TI_ARROW_LOOP_RIGHT("ti-arrow-loop-right"),
  TI_ARROW_LOOP_RIGHT_2("ti-arrow-loop-right-2"),
  TI_ARROW_MERGE("ti-arrow-merge"),
  TI_ARROW_MERGE_ALT_LEFT("ti-arrow-merge-alt-left"),
  TI_ARROW_MERGE_ALT_RIGHT("ti-arrow-merge-alt-right"),
  TI_ARROW_MERGE_BOTH("ti-arrow-merge-both"),
  TI_ARROW_MERGE_LEFT("ti-arrow-merge-left"),
  TI_ARROW_MERGE_RIGHT("ti-arrow-merge-right"),
  TI_ARROW_MOVE_DOWN("ti-arrow-move-down"),
  TI_ARROW_MOVE_LEFT("ti-arrow-move-left"),
  TI_ARROW_MOVE_RIGHT("ti-arrow-move-right"),
  TI_ARROW_MOVE_UP("ti-arrow-move-up"),
  TI_ARROW_NARROW_DOWN("ti-arrow-narrow-down"),
  TI_ARROW_NARROW_DOWN_DASHED("ti-arrow-narrow-down-dashed"),
  TI_ARROW_NARROW_LEFT("ti-arrow-narrow-left"),
  TI_ARROW_NARROW_LEFT_DASHED("ti-arrow-narrow-left-dashed"),
  TI_ARROW_NARROW_RIGHT("ti-arrow-narrow-right"),
  TI_ARROW_NARROW_RIGHT_DASHED("ti-arrow-narrow-right-dashed"),
  TI_ARROW_NARROW_UP("ti-arrow-narrow-up"),
  TI_ARROW_NARROW_UP_DASHED("ti-arrow-narrow-up-dashed"),
  TI_ARROW_RAMP_LEFT("ti-arrow-ramp-left"),
  TI_ARROW_RAMP_LEFT_2("ti-arrow-ramp-left-2"),
  TI_ARROW_RAMP_LEFT_3("ti-arrow-ramp-left-3"),
  TI_ARROW_RAMP_RIGHT("ti-arrow-ramp-right"),
  TI_ARROW_RAMP_RIGHT_2("ti-arrow-ramp-right-2"),
  TI_ARROW_RAMP_RIGHT_3("ti-arrow-ramp-right-3"),
  TI_ARROW_RIGHT("ti-arrow-right"),
  TI_ARROW_RIGHT_BAR("ti-arrow-right-bar"),
  TI_ARROW_RIGHT_CIRCLE("ti-arrow-right-circle"),
  TI_ARROW_RIGHT_DASHED("ti-arrow-right-dashed"),
  TI_ARROW_RIGHT_FROM_ARC("ti-arrow-right-from-arc"),
  TI_ARROW_RIGHT_RHOMBUS("ti-arrow-right-rhombus"),
  TI_ARROW_RIGHT_SQUARE("ti-arrow-right-square"),
  TI_ARROW_RIGHT_TAIL("ti-arrow-right-tail"),
  TI_ARROW_RIGHT_TO_ARC("ti-arrow-right-to-arc"),
  TI_ARROW_ROTARY_FIRST_LEFT("ti-arrow-rotary-first-left"),
  TI_ARROW_ROTARY_FIRST_RIGHT("ti-arrow-rotary-first-right"),
  TI_ARROW_ROTARY_LAST_LEFT("ti-arrow-rotary-last-left"),
  TI_ARROW_ROTARY_LAST_RIGHT("ti-arrow-rotary-last-right"),
  TI_ARROW_ROTARY_LEFT("ti-arrow-rotary-left"),
  TI_ARROW_ROTARY_RIGHT("ti-arrow-rotary-right"),
  TI_ARROW_ROTARY_STRAIGHT("ti-arrow-rotary-straight"),
  TI_ARROW_ROUNDABOUT_LEFT("ti-arrow-roundabout-left"),
  TI_ARROW_ROUNDABOUT_RIGHT("ti-arrow-roundabout-right"),
  TI_ARROW_SHARP_TURN_LEFT("ti-arrow-sharp-turn-left"),
  TI_ARROW_SHARP_TURN_RIGHT("ti-arrow-sharp-turn-right"),
  TI_ARROW_UP("ti-arrow-up"),
  TI_ARROW_UP_BAR("ti-arrow-up-bar"),
  TI_ARROW_UP_CIRCLE("ti-arrow-up-circle"),
  TI_ARROW_UP_DASHED("ti-arrow-up-dashed"),
  TI_ARROW_UP_FROM_ARC("ti-arrow-up-from-arc"),
  TI_ARROW_UP_LEFT("ti-arrow-up-left"),
  TI_ARROW_UP_LEFT_CIRCLE("ti-arrow-up-left-circle"),
  TI_ARROW_UP_RHOMBUS("ti-arrow-up-rhombus"),
  TI_ARROW_UP_RIGHT("ti-arrow-up-right"),
  TI_ARROW_UP_RIGHT_CIRCLE("ti-arrow-up-right-circle"),
  TI_ARROW_UP_SQUARE("ti-arrow-up-square"),
  TI_ARROW_UP_TAIL("ti-arrow-up-tail"),
  TI_ARROW_UP_TO_ARC("ti-arrow-up-to-arc"),
  TI_ARROW_WAVE_LEFT_DOWN("ti-arrow-wave-left-down"),
  TI_ARROW_WAVE_LEFT_UP("ti-arrow-wave-left-up"),
  TI_ARROW_WAVE_RIGHT_DOWN("ti-arrow-wave-right-down"),
  TI_ARROW_WAVE_RIGHT_UP("ti-arrow-wave-right-up"),
  TI_ARROW_ZIG_ZAG("ti-arrow-zig-zag"),
  TI_ARROWS_CROSS("ti-arrows-cross"),
  TI_ARROWS_DIAGONAL("ti-arrows-diagonal"),
  TI_ARROWS_DIAGONAL_2("ti-arrows-diagonal-2"),
  TI_ARROWS_DIAGONAL_MINIMIZE("ti-arrows-diagonal-minimize"),
  TI_ARROWS_DIAGONAL_MINIMIZE_2("ti-arrows-diagonal-minimize-2"),
  TI_ARROWS_DIFF("ti-arrows-diff"),
  TI_ARROWS_DOUBLE_NE_SW("ti-arrows-double-ne-sw"),
  TI_ARROWS_DOUBLE_NW_SE("ti-arrows-double-nw-se"),
  TI_ARROWS_DOUBLE_SE_NW("ti-arrows-double-se-nw"),
  TI_ARROWS_DOUBLE_SW_NE("ti-arrows-double-sw-ne"),
  TI_ARROWS_DOWN("ti-arrows-down"),
  TI_ARROWS_DOWN_UP("ti-arrows-down-up"),
  TI_ARROWS_EXCHANGE("ti-arrows-exchange"),
  TI_ARROWS_EXCHANGE_2("ti-arrows-exchange-2"),
  TI_ARROWS_HORIZONTAL("ti-arrows-horizontal"),
  TI_ARROWS_JOIN("ti-arrows-join"),
  TI_ARROWS_JOIN_2("ti-arrows-join-2"),
  TI_ARROWS_LEFT("ti-arrows-left"),
  TI_ARROWS_LEFT_DOWN("ti-arrows-left-down"),
  TI_ARROWS_LEFT_RIGHT("ti-arrows-left-right"),
  TI_ARROWS_MAXIMIZE("ti-arrows-maximize"),
  TI_ARROWS_MINIMIZE("ti-arrows-minimize"),
  TI_ARROWS_MOVE("ti-arrows-move"),
  TI_ARROWS_MOVE_HORIZONTAL("ti-arrows-move-horizontal"),
  TI_ARROWS_MOVE_VERTICAL("ti-arrows-move-vertical"),
  TI_ARROWS_RANDOM("ti-arrows-random"),
  TI_ARROWS_RIGHT("ti-arrows-right"),
  TI_ARROWS_RIGHT_DOWN("ti-arrows-right-down"),
  TI_ARROWS_RIGHT_LEFT("ti-arrows-right-left"),
  TI_ARROWS_SHUFFLE("ti-arrows-shuffle"),
  TI_ARROWS_SHUFFLE_2("ti-arrows-shuffle-2"),
  TI_ARROWS_SORT("ti-arrows-sort"),
  TI_ARROWS_SPLIT("ti-arrows-split"),
  TI_ARROWS_SPLIT_2("ti-arrows-split-2"),
  TI_ARROWS_TRANSFER_DOWN("ti-arrows-transfer-down"),
  TI_ARROWS_TRANSFER_UP("ti-arrows-transfer-up"),
  TI_ARROWS_TRANSFER_UP_DOWN("ti-arrows-transfer-up-down"),
  TI_ARROWS_UP("ti-arrows-up"),
  TI_ARROWS_UP_DOWN("ti-arrows-up-down"),
  TI_ARROWS_UP_LEFT("ti-arrows-up-left"),
  TI_ARROWS_UP_RIGHT("ti-arrows-up-right"),
  TI_ARROWS_VERTICAL("ti-arrows-vertical"),
  TI_ARTBOARD("ti-artboard"),
  TI_ARTBOARD_OFF("ti-artboard-off"),
  TI_ARTICLE("ti-article"),
  TI_ARTICLE_OFF("ti-article-off"),
  TI_ASPECT_RATIO("ti-aspect-ratio"),
  TI_ASPECT_RATIO_OFF("ti-aspect-ratio-off"),
  TI_ASSEMBLY("ti-assembly"),
  TI_ASSEMBLY_OFF("ti-assembly-off"),
  TI_ASSET("ti-asset"),
  TI_ASTERISK("ti-asterisk"),
  TI_ASTERISK_SIMPLE("ti-asterisk-simple"),
  TI_AT("ti-at"),
  TI_AT_OFF("ti-at-off"),
  TI_ATOM("ti-atom"),
  TI_ATOM_2("ti-atom-2"),
  TI_ATOM_OFF("ti-atom-off"),
  TI_AUGMENTED_REALITY("ti-augmented-reality"),
  TI_AUGMENTED_REALITY_2("ti-augmented-reality-2"),
  TI_AUGMENTED_REALITY_OFF("ti-augmented-reality-off"),
  TI_AUTH_2FA("ti-auth-2fa"),
  TI_AUTOMATIC_GEARBOX("ti-automatic-gearbox"),
  TI_AUTOMATION("ti-automation"),
  TI_AVOCADO("ti-avocado"),
  TI_AWARD("ti-award"),
  TI_AWARD_OFF("ti-award-off"),
  TI_AXE("ti-axe"),
  TI_AXIS_X("ti-axis-x"),
  TI_AXIS_Y("ti-axis-y"),
  TI_BABY_BOTTLE("ti-baby-bottle"),
  TI_BABY_CARRIAGE("ti-baby-carriage"),
  TI_BACKGROUND("ti-background"),
  TI_BACKHOE("ti-backhoe"),
  TI_BACKPACK("ti-backpack"),
  TI_BACKPACK_OFF("ti-backpack-off"),
  TI_BACKSLASH("ti-backslash"),
  TI_BACKSPACE("ti-backspace"),
  TI_BADGE("ti-badge"),
  TI_BADGE_2K("ti-badge-2k"),
  TI_BADGE_3D("ti-badge-3d"),
  TI_BADGE_3K("ti-badge-3k"),
  TI_BADGE_4K("ti-badge-4k"),
  TI_BADGE_5K("ti-badge-5k"),
  TI_BADGE_8K("ti-badge-8k"),
  TI_BADGE_AD("ti-badge-ad"),
  TI_BADGE_AD_OFF("ti-badge-ad-off"),
  TI_BADGE_AR("ti-badge-ar"),
  TI_BADGE_CC("ti-badge-cc"),
  TI_BADGE_HD("ti-badge-hd"),
  TI_BADGE_OFF("ti-badge-off"),
  TI_BADGE_SD("ti-badge-sd"),
  TI_BADGE_TM("ti-badge-tm"),
  TI_BADGE_VO("ti-badge-vo"),
  TI_BADGE_VR("ti-badge-vr"),
  TI_BADGE_WC("ti-badge-wc"),
  TI_BADGES("ti-badges"),
  TI_BADGES_OFF("ti-badges-off"),
  TI_BAGUETTE("ti-baguette"),
  TI_BALL_AMERICAN_FOOTBALL("ti-ball-american-football"),
  TI_BALL_AMERICAN_FOOTBALL_OFF("ti-ball-american-football-off"),
  TI_BALL_BASEBALL("ti-ball-baseball"),
  TI_BALL_BASKETBALL("ti-ball-basketball"),
  TI_BALL_BOWLING("ti-ball-bowling"),
  TI_BALL_FOOTBALL("ti-ball-football"),
  TI_BALL_FOOTBALL_OFF("ti-ball-football-off"),
  TI_BALL_TENNIS("ti-ball-tennis"),
  TI_BALL_VOLLEYBALL("ti-ball-volleyball"),
  TI_BALLOON("ti-balloon"),
  TI_BALLOON_OFF("ti-balloon-off"),
  TI_BALLPEN("ti-ballpen"),
  TI_BALLPEN_OFF("ti-ballpen-off"),
  TI_BAN("ti-ban"),
  TI_BANANA("ti-banana"),
  TI_BANDAGE("ti-bandage"),
  TI_BANDAGE_OFF("ti-bandage-off"),
  TI_BARBELL("ti-barbell"),
  TI_BARBELL_OFF("ti-barbell-off"),
  TI_BARCODE("ti-barcode"),
  TI_BARCODE_OFF("ti-barcode-off"),
  TI_BARREL("ti-barrel"),
  TI_BARREL_OFF("ti-barrel-off"),
  TI_BARRIER_BLOCK("ti-barrier-block"),
  TI_BARRIER_BLOCK_OFF("ti-barrier-block-off"),
  TI_BASELINE("ti-baseline"),
  TI_BASELINE_DENSITY_LARGE("ti-baseline-density-large"),
  TI_BASELINE_DENSITY_MEDIUM("ti-baseline-density-medium"),
  TI_BASELINE_DENSITY_SMALL("ti-baseline-density-small"),
  TI_BASKET("ti-basket"),
  TI_BASKET_BOLT("ti-basket-bolt"),
  TI_BASKET_CANCEL("ti-basket-cancel"),
  TI_BASKET_CHECK("ti-basket-check"),
  TI_BASKET_CODE("ti-basket-code"),
  TI_BASKET_COG("ti-basket-cog"),
  TI_BASKET_DISCOUNT("ti-basket-discount"),
  TI_BASKET_DOLLAR("ti-basket-dollar"),
  TI_BASKET_DOWN("ti-basket-down"),
  TI_BASKET_EXCLAMATION("ti-basket-exclamation"),
  TI_BASKET_HEART("ti-basket-heart"),
  TI_BASKET_MINUS("ti-basket-minus"),
  TI_BASKET_OFF("ti-basket-off"),
  TI_BASKET_PAUSE("ti-basket-pause"),
  TI_BASKET_PIN("ti-basket-pin"),
  TI_BASKET_PLUS("ti-basket-plus"),
  TI_BASKET_QUESTION("ti-basket-question"),
  TI_BASKET_SEARCH("ti-basket-search"),
  TI_BASKET_SHARE("ti-basket-share"),
  TI_BASKET_STAR("ti-basket-star"),
  TI_BASKET_UP("ti-basket-up"),
  TI_BASKET_X("ti-basket-x"),
  TI_BAT("ti-bat"),
  TI_BATH("ti-bath"),
  TI_BATH_OFF("ti-bath-off"),
  TI_BATTERY("ti-battery"),
  TI_BATTERY_1("ti-battery-1"),
  TI_BATTERY_2("ti-battery-2"),
  TI_BATTERY_3("ti-battery-3"),
  TI_BATTERY_4("ti-battery-4"),
  TI_BATTERY_AUTOMOTIVE("ti-battery-automotive"),
  TI_BATTERY_CHARGING("ti-battery-charging"),
  TI_BATTERY_CHARGING_2("ti-battery-charging-2"),
  TI_BATTERY_ECO("ti-battery-eco"),
  TI_BATTERY_EXCLAMATION("ti-battery-exclamation"),
  TI_BATTERY_OFF("ti-battery-off"),
  TI_BATTERY_SPARK("ti-battery-spark"),
  TI_BATTERY_VERTICAL("ti-battery-vertical"),
  TI_BATTERY_VERTICAL_1("ti-battery-vertical-1"),
  TI_BATTERY_VERTICAL_2("ti-battery-vertical-2"),
  TI_BATTERY_VERTICAL_3("ti-battery-vertical-3"),
  TI_BATTERY_VERTICAL_4("ti-battery-vertical-4"),
  TI_BATTERY_VERTICAL_CHARGING("ti-battery-vertical-charging"),
  TI_BATTERY_VERTICAL_CHARGING_2("ti-battery-vertical-charging-2"),
  TI_BATTERY_VERTICAL_ECO("ti-battery-vertical-eco"),
  TI_BATTERY_VERTICAL_EXCLAMATION("ti-battery-vertical-exclamation"),
  TI_BATTERY_VERTICAL_OFF("ti-battery-vertical-off"),
  TI_BEACH("ti-beach"),
  TI_BEACH_OFF("ti-beach-off"),
  TI_BED("ti-bed"),
  TI_BED_FLAT("ti-bed-flat"),
  TI_BED_OFF("ti-bed-off"),
  TI_BEER("ti-beer"),
  TI_BEER_OFF("ti-beer-off"),
  TI_BELL("ti-bell"),
  TI_BELL_BOLT("ti-bell-bolt"),
  TI_BELL_CANCEL("ti-bell-cancel"),
  TI_BELL_CHECK("ti-bell-check"),
  TI_BELL_CODE("ti-bell-code"),
  TI_BELL_COG("ti-bell-cog"),
  TI_BELL_DOLLAR("ti-bell-dollar"),
  TI_BELL_DOWN("ti-bell-down"),
  TI_BELL_EXCLAMATION("ti-bell-exclamation"),
  TI_BELL_HEART("ti-bell-heart"),
  TI_BELL_MINUS("ti-bell-minus"),
  TI_BELL_OFF("ti-bell-off"),
  TI_BELL_PAUSE("ti-bell-pause"),
  TI_BELL_PIN("ti-bell-pin"),
  TI_BELL_PLUS("ti-bell-plus"),
  TI_BELL_QUESTION("ti-bell-question"),
  TI_BELL_RINGING("ti-bell-ringing"),
  TI_BELL_RINGING_2("ti-bell-ringing-2"),
  TI_BELL_SCHOOL("ti-bell-school"),
  TI_BELL_SEARCH("ti-bell-search"),
  TI_BELL_SHARE("ti-bell-share"),
  TI_BELL_STAR("ti-bell-star"),
  TI_BELL_UP("ti-bell-up"),
  TI_BELL_X("ti-bell-x"),
  TI_BELL_Z("ti-bell-z"),
  TI_BETA("ti-beta"),
  TI_BIBLE("ti-bible"),
  TI_BIKE("ti-bike"),
  TI_BIKE_OFF("ti-bike-off"),
  TI_BINARY("ti-binary"),
  TI_BINARY_OFF("ti-binary-off"),
  TI_BINARY_TREE("ti-binary-tree"),
  TI_BINARY_TREE_2("ti-binary-tree-2"),
  TI_BINOCULARS("ti-binoculars"),
  TI_BIOHAZARD("ti-biohazard"),
  TI_BIOHAZARD_OFF("ti-biohazard-off"),
  TI_BLADE("ti-blade"),
  TI_BLEACH("ti-bleach"),
  TI_BLEACH_CHLORINE("ti-bleach-chlorine"),
  TI_BLEACH_NO_CHLORINE("ti-bleach-no-chlorine"),
  TI_BLEACH_OFF("ti-bleach-off"),
  TI_BLEND_MODE("ti-blend-mode"),
  TI_BLENDER("ti-blender"),
  TI_BLIND("ti-blind"),
  TI_BLOB("ti-blob"),
  TI_BLOCKQUOTE("ti-blockquote"),
  TI_BLOCKS("ti-blocks"),
  TI_BLUETOOTH("ti-bluetooth"),
  TI_BLUETOOTH_CONNECTED("ti-bluetooth-connected"),
  TI_BLUETOOTH_OFF("ti-bluetooth-off"),
  TI_BLUETOOTH_X("ti-bluetooth-x"),
  TI_BLUR("ti-blur"),
  TI_BLUR_OFF("ti-blur-off"),
  TI_BMP("ti-bmp"),
  TI_BODY_SCAN("ti-body-scan"),
  TI_BOLD("ti-bold"),
  TI_BOLD_OFF("ti-bold-off"),
  TI_BOLT("ti-bolt"),
  TI_BOLT_OFF("ti-bolt-off"),
  TI_BOMB("ti-bomb"),
  TI_BONE("ti-bone"),
  TI_BONE_OFF("ti-bone-off"),
  TI_BONG("ti-bong"),
  TI_BONG_OFF("ti-bong-off"),
  TI_BOOK("ti-book"),
  TI_BOOK_2("ti-book-2"),
  TI_BOOK_DOWNLOAD("ti-book-download"),
  TI_BOOK_OFF("ti-book-off"),
  TI_BOOK_UPLOAD("ti-book-upload"),
  TI_BOOKMARK("ti-bookmark"),
  TI_BOOKMARK_AI("ti-bookmark-ai"),
  TI_BOOKMARK_EDIT("ti-bookmark-edit"),
  TI_BOOKMARK_MINUS("ti-bookmark-minus"),
  TI_BOOKMARK_OFF("ti-bookmark-off"),
  TI_BOOKMARK_PLUS("ti-bookmark-plus"),
  TI_BOOKMARK_QUESTION("ti-bookmark-question"),
  TI_BOOKMARKS("ti-bookmarks"),
  TI_BOOKMARKS_OFF("ti-bookmarks-off"),
  TI_BOOKS("ti-books"),
  TI_BOOKS_OFF("ti-books-off"),
  TI_BOOM("ti-boom"),
  TI_BORDER_ALL("ti-border-all"),
  TI_BORDER_BOTTOM("ti-border-bottom"),
  TI_BORDER_BOTTOM_PLUS("ti-border-bottom-plus"),
  TI_BORDER_CORNER_IOS("ti-border-corner-ios"),
  TI_BORDER_CORNER_PILL("ti-border-corner-pill"),
  TI_BORDER_CORNER_ROUNDED("ti-border-corner-rounded"),
  TI_BORDER_CORNER_SQUARE("ti-border-corner-square"),
  TI_BORDER_CORNERS("ti-border-corners"),
  TI_BORDER_HORIZONTAL("ti-border-horizontal"),
  TI_BORDER_INNER("ti-border-inner"),
  TI_BORDER_LEFT("ti-border-left"),
  TI_BORDER_LEFT_PLUS("ti-border-left-plus"),
  TI_BORDER_NONE("ti-border-none"),
  TI_BORDER_OUTER("ti-border-outer"),
  TI_BORDER_RADIUS("ti-border-radius"),
  TI_BORDER_RIGHT("ti-border-right"),
  TI_BORDER_RIGHT_PLUS("ti-border-right-plus"),
  TI_BORDER_SIDES("ti-border-sides"),
  TI_BORDER_STYLE("ti-border-style"),
  TI_BORDER_STYLE_2("ti-border-style-2"),
  TI_BORDER_TOP("ti-border-top"),
  TI_BORDER_TOP_PLUS("ti-border-top-plus"),
  TI_BORDER_VERTICAL("ti-border-vertical"),
  TI_BOT_ID("ti-bot-id"),
  TI_BOTTLE("ti-bottle"),
  TI_BOTTLE_OFF("ti-bottle-off"),
  TI_BOUNCE_LEFT("ti-bounce-left"),
  TI_BOUNCE_RIGHT("ti-bounce-right"),
  TI_BOW("ti-bow"),
  TI_BOWL("ti-bowl"),
  TI_BOWL_CHOPSTICKS("ti-bowl-chopsticks"),
  TI_BOWL_SPOON("ti-bowl-spoon"),
  TI_BOWLING("ti-bowling"),
  TI_BOX("ti-box"),
  TI_BOX_ALIGN_BOTTOM("ti-box-align-bottom"),
  TI_BOX_ALIGN_BOTTOM_LEFT("ti-box-align-bottom-left"),
  TI_BOX_ALIGN_BOTTOM_RIGHT("ti-box-align-bottom-right"),
  TI_BOX_ALIGN_LEFT("ti-box-align-left"),
  TI_BOX_ALIGN_RIGHT("ti-box-align-right"),
  TI_BOX_ALIGN_TOP("ti-box-align-top"),
  TI_BOX_ALIGN_TOP_LEFT("ti-box-align-top-left"),
  TI_BOX_ALIGN_TOP_RIGHT("ti-box-align-top-right"),
  TI_BOX_MARGIN("ti-box-margin"),
  TI_BOX_MODEL("ti-box-model"),
  TI_BOX_MODEL_2("ti-box-model-2"),
  TI_BOX_MODEL_2_OFF("ti-box-model-2-off"),
  TI_BOX_MODEL_OFF("ti-box-model-off"),
  TI_BOX_MULTIPLE("ti-box-multiple"),
  TI_BOX_MULTIPLE_0("ti-box-multiple-0"),
  TI_BOX_MULTIPLE_1("ti-box-multiple-1"),
  TI_BOX_MULTIPLE_2("ti-box-multiple-2"),
  TI_BOX_MULTIPLE_3("ti-box-multiple-3"),
  TI_BOX_MULTIPLE_4("ti-box-multiple-4"),
  TI_BOX_MULTIPLE_5("ti-box-multiple-5"),
  TI_BOX_MULTIPLE_6("ti-box-multiple-6"),
  TI_BOX_MULTIPLE_7("ti-box-multiple-7"),
  TI_BOX_MULTIPLE_8("ti-box-multiple-8"),
  TI_BOX_MULTIPLE_9("ti-box-multiple-9"),
  TI_BOX_OFF("ti-box-off"),
  TI_BOX_PADDING("ti-box-padding"),
  TI_BOX_SEAM("ti-box-seam"),
  TI_BRACES("ti-braces"),
  TI_BRACES_OFF("ti-braces-off"),
  TI_BRACKETS("ti-brackets"),
  TI_BRACKETS_ANGLE("ti-brackets-angle"),
  TI_BRACKETS_ANGLE_OFF("ti-brackets-angle-off"),
  TI_BRACKETS_CONTAIN("ti-brackets-contain"),
  TI_BRACKETS_CONTAIN_END("ti-brackets-contain-end"),
  TI_BRACKETS_CONTAIN_START("ti-brackets-contain-start"),
  TI_BRACKETS_OFF("ti-brackets-off"),
  TI_BRAILLE("ti-braille"),
  TI_BRAIN("ti-brain"),
  TI_BRAND_4CHAN("ti-brand-4chan"),
  TI_BRAND_ABSTRACT("ti-brand-abstract"),
  TI_BRAND_ADOBE("ti-brand-adobe"),
  TI_BRAND_ADOBE_AFTER_EFFECT("ti-brand-adobe-after-effect"),
  TI_BRAND_ADOBE_AFTER_EFFECTS("ti-brand-adobe-after-effects"),
  TI_BRAND_ADOBE_ILLUSTRATOR("ti-brand-adobe-illustrator"),
  TI_BRAND_ADOBE_INDESIGN("ti-brand-adobe-indesign"),
  TI_BRAND_ADOBE_PHOTOSHOP("ti-brand-adobe-photoshop"),
  TI_BRAND_ADOBE_PREMIER("ti-brand-adobe-premier"),
  TI_BRAND_ADOBE_PREMIERE("ti-brand-adobe-premiere"),
  TI_BRAND_ADOBE_XD("ti-brand-adobe-xd"),
  TI_BRAND_ADONIS_JS("ti-brand-adonis-js"),
  TI_BRAND_AIRBNB("ti-brand-airbnb"),
  TI_BRAND_AIRTABLE("ti-brand-airtable"),
  TI_BRAND_ALGOLIA("ti-brand-algolia"),
  TI_BRAND_ALIPAY("ti-brand-alipay"),
  TI_BRAND_ALPINE_JS("ti-brand-alpine-js"),
  TI_BRAND_AMAZON("ti-brand-amazon"),
  TI_BRAND_AMD("ti-brand-amd"),
  TI_BRAND_AMIE("ti-brand-amie"),
  TI_BRAND_AMIGO("ti-brand-amigo"),
  TI_BRAND_AMONG_US("ti-brand-among-us"),
  TI_BRAND_ANDROID("ti-brand-android"),
  TI_BRAND_ANGULAR("ti-brand-angular"),
  TI_BRAND_ANSIBLE("ti-brand-ansible"),
  TI_BRAND_AO3("ti-brand-ao3"),
  TI_BRAND_APPGALLERY("ti-brand-appgallery"),
  TI_BRAND_APPLE("ti-brand-apple"),
  TI_BRAND_APPLE_ARCADE("ti-brand-apple-arcade"),
  TI_BRAND_APPLE_NEWS("ti-brand-apple-news"),
  TI_BRAND_APPLE_PODCAST("ti-brand-apple-podcast"),
  TI_BRAND_APPSTORE("ti-brand-appstore"),
  TI_BRAND_ARC("ti-brand-arc"),
  TI_BRAND_ASANA("ti-brand-asana"),
  TI_BRAND_ASTRO("ti-brand-astro"),
  TI_BRAND_AUDIBLE("ti-brand-audible"),
  TI_BRAND_AUTH0("ti-brand-auth0"),
  TI_BRAND_AWS("ti-brand-aws"),
  TI_BRAND_AZURE("ti-brand-azure"),
  TI_BRAND_BACKBONE("ti-brand-backbone"),
  TI_BRAND_BADOO("ti-brand-badoo"),
  TI_BRAND_BAIDU("ti-brand-baidu"),
  TI_BRAND_BANDCAMP("ti-brand-bandcamp"),
  TI_BRAND_BANDLAB("ti-brand-bandlab"),
  TI_BRAND_BEATS("ti-brand-beats"),
  TI_BRAND_BEBO("ti-brand-bebo"),
  TI_BRAND_BEHANCE("ti-brand-behance"),
  TI_BRAND_BILIBILI("ti-brand-bilibili"),
  TI_BRAND_BINANCE("ti-brand-binance"),
  TI_BRAND_BING("ti-brand-bing"),
  TI_BRAND_BITBUCKET("ti-brand-bitbucket"),
  TI_BRAND_BLACKBERRY("ti-brand-blackberry"),
  TI_BRAND_BLENDER("ti-brand-blender"),
  TI_BRAND_BLOGGER("ti-brand-blogger"),
  TI_BRAND_BLUESKY("ti-brand-bluesky"),
  TI_BRAND_BOOKING("ti-brand-booking"),
  TI_BRAND_BOOTSTRAP("ti-brand-bootstrap"),
  TI_BRAND_BULMA("ti-brand-bulma"),
  TI_BRAND_BUMBLE("ti-brand-bumble"),
  TI_BRAND_BUNPO("ti-brand-bunpo"),
  TI_BRAND_C_SHARP("ti-brand-c-sharp"),
  TI_BRAND_CAKE("ti-brand-cake"),
  TI_BRAND_CAKEPHP("ti-brand-cakephp"),
  TI_BRAND_CAMPAIGNMONITOR("ti-brand-campaignmonitor"),
  TI_BRAND_CARBON("ti-brand-carbon"),
  TI_BRAND_CASHAPP("ti-brand-cashapp"),
  TI_BRAND_CHROME("ti-brand-chrome"),
  TI_BRAND_CINEMA_4D("ti-brand-cinema-4d"),
  TI_BRAND_CITYMAPPER("ti-brand-citymapper"),
  TI_BRAND_CLOUDFLARE("ti-brand-cloudflare"),
  TI_BRAND_CODECOV("ti-brand-codecov"),
  TI_BRAND_CODEPEN("ti-brand-codepen"),
  TI_BRAND_CODESANDBOX("ti-brand-codesandbox"),
  TI_BRAND_COHOST("ti-brand-cohost"),
  TI_BRAND_COINBASE("ti-brand-coinbase"),
  TI_BRAND_COMEDY_CENTRAL("ti-brand-comedy-central"),
  TI_BRAND_COREOS("ti-brand-coreos"),
  TI_BRAND_COUCHDB("ti-brand-couchdb"),
  TI_BRAND_COUCHSURFING("ti-brand-couchsurfing"),
  TI_BRAND_CPP("ti-brand-cpp"),
  TI_BRAND_CRAFT("ti-brand-craft"),
  TI_BRAND_CRUNCHBASE("ti-brand-crunchbase"),
  TI_BRAND_CSS3("ti-brand-css3"),
  TI_BRAND_CTEMPLAR("ti-brand-ctemplar"),
  TI_BRAND_CUCUMBER("ti-brand-cucumber"),
  TI_BRAND_CUPRA("ti-brand-cupra"),
  TI_BRAND_CYPRESS("ti-brand-cypress"),
  TI_BRAND_D3("ti-brand-d3"),
  TI_BRAND_DATABRICKS("ti-brand-databricks"),
  TI_BRAND_DAYS_COUNTER("ti-brand-days-counter"),
  TI_BRAND_DCOS("ti-brand-dcos"),
  TI_BRAND_DEBIAN("ti-brand-debian"),
  TI_BRAND_DEEZER("ti-brand-deezer"),
  TI_BRAND_DELIVEROO("ti-brand-deliveroo"),
  TI_BRAND_DENO("ti-brand-deno"),
  TI_BRAND_DENODO("ti-brand-denodo"),
  TI_BRAND_DEVIANTART("ti-brand-deviantart"),
  TI_BRAND_DIGG("ti-brand-digg"),
  TI_BRAND_DINGTALK("ti-brand-dingtalk"),
  TI_BRAND_DISCORD("ti-brand-discord"),
  TI_BRAND_DISNEY("ti-brand-disney"),
  TI_BRAND_DISQUS("ti-brand-disqus"),
  TI_BRAND_DJANGO("ti-brand-django"),
  TI_BRAND_DOCKER("ti-brand-docker"),
  TI_BRAND_DOCTRINE("ti-brand-doctrine"),
  TI_BRAND_DOLBY_DIGITAL("ti-brand-dolby-digital"),
  TI_BRAND_DOUBAN("ti-brand-douban"),
  TI_BRAND_DRIBBBLE("ti-brand-dribbble"),
  TI_BRAND_DROPBOX("ti-brand-dropbox"),
  TI_BRAND_DROPS("ti-brand-drops"),
  TI_BRAND_DRUPAL("ti-brand-drupal"),
  TI_BRAND_EDGE("ti-brand-edge"),
  TI_BRAND_ELASTIC("ti-brand-elastic"),
  TI_BRAND_ELECTRONIC_ARTS("ti-brand-electronic-arts"),
  TI_BRAND_EMBER("ti-brand-ember"),
  TI_BRAND_ENVATO("ti-brand-envato"),
  TI_BRAND_ETSY("ti-brand-etsy"),
  TI_BRAND_EVERNOTE("ti-brand-evernote"),
  TI_BRAND_FACEBOOK("ti-brand-facebook"),
  TI_BRAND_FEEDLY("ti-brand-feedly"),
  TI_BRAND_FIGMA("ti-brand-figma"),
  TI_BRAND_FILEZILLA("ti-brand-filezilla"),
  TI_BRAND_FINDER("ti-brand-finder"),
  TI_BRAND_FIREBASE("ti-brand-firebase"),
  TI_BRAND_FIREFOX("ti-brand-firefox"),
  TI_BRAND_FIVERR("ti-brand-fiverr"),
  TI_BRAND_FLICKR("ti-brand-flickr"),
  TI_BRAND_FLIGHTRADAR24("ti-brand-flightradar24"),
  TI_BRAND_FLIPBOARD("ti-brand-flipboard"),
  TI_BRAND_FLUTTER("ti-brand-flutter"),
  TI_BRAND_FORTNITE("ti-brand-fortnite"),
  TI_BRAND_FOURSQUARE("ti-brand-foursquare"),
  TI_BRAND_FRAMER("ti-brand-framer"),
  TI_BRAND_FRAMER_MOTION("ti-brand-framer-motion"),
  TI_BRAND_FUNIMATION("ti-brand-funimation"),
  TI_BRAND_GATSBY("ti-brand-gatsby"),
  TI_BRAND_GIT("ti-brand-git"),
  TI_BRAND_GITHUB("ti-brand-github"),
  TI_BRAND_GITHUB_COPILOT("ti-brand-github-copilot"),
  TI_BRAND_GITLAB("ti-brand-gitlab"),
  TI_BRAND_GMAIL("ti-brand-gmail"),
  TI_BRAND_GOLANG("ti-brand-golang"),
  TI_BRAND_GOOGLE("ti-brand-google"),
  TI_BRAND_GOOGLE_ANALYTICS("ti-brand-google-analytics"),
  TI_BRAND_GOOGLE_BIG_QUERY("ti-brand-google-big-query"),
  TI_BRAND_GOOGLE_DRIVE("ti-brand-google-drive"),
  TI_BRAND_GOOGLE_FIT("ti-brand-google-fit"),
  TI_BRAND_GOOGLE_HOME("ti-brand-google-home"),
  TI_BRAND_GOOGLE_MAPS("ti-brand-google-maps"),
  TI_BRAND_GOOGLE_ONE("ti-brand-google-one"),
  TI_BRAND_GOOGLE_PHOTOS("ti-brand-google-photos"),
  TI_BRAND_GOOGLE_PLAY("ti-brand-google-play"),
  TI_BRAND_GOOGLE_PODCASTS("ti-brand-google-podcasts"),
  TI_BRAND_GRAMMARLY("ti-brand-grammarly"),
  TI_BRAND_GRAPHQL("ti-brand-graphql"),
  TI_BRAND_GRAVATAR("ti-brand-gravatar"),
  TI_BRAND_GRINDR("ti-brand-grindr"),
  TI_BRAND_GUARDIAN("ti-brand-guardian"),
  TI_BRAND_GUMROAD("ti-brand-gumroad"),
  TI_BRAND_HACKERRANK("ti-brand-hackerrank"),
  TI_BRAND_HBO("ti-brand-hbo"),
  TI_BRAND_HEADLESSUI("ti-brand-headlessui"),
  TI_BRAND_HEXO("ti-brand-hexo"),
  TI_BRAND_HIPCHAT("ti-brand-hipchat"),
  TI_BRAND_HTML5("ti-brand-html5"),
  TI_BRAND_INERTIA("ti-brand-inertia"),
  TI_BRAND_INFAKT("ti-brand-infakt"),
  TI_BRAND_INSTAGRAM("ti-brand-instagram"),
  TI_BRAND_INTERCOM("ti-brand-intercom"),
  TI_BRAND_ITCH("ti-brand-itch"),
  TI_BRAND_JAVASCRIPT("ti-brand-javascript"),
  TI_BRAND_JIRA("ti-brand-jira"),
  TI_BRAND_JUEJIN("ti-brand-juejin"),
  TI_BRAND_KAKAO_TALK("ti-brand-kakao-talk"),
  TI_BRAND_KAKO_TALK("ti-brand-kako-talk"),
  TI_BRAND_KBIN("ti-brand-kbin"),
  TI_BRAND_KICK("ti-brand-kick"),
  TI_BRAND_KICKSTARTER("ti-brand-kickstarter"),
  TI_BRAND_KOTLIN("ti-brand-kotlin"),
  TI_BRAND_LARAVEL("ti-brand-laravel"),
  TI_BRAND_LASTFM("ti-brand-lastfm"),
  TI_BRAND_LEETCODE("ti-brand-leetcode"),
  TI_BRAND_LETTERBOXD("ti-brand-letterboxd"),
  TI_BRAND_LINE("ti-brand-line"),
  TI_BRAND_LINKEDIN("ti-brand-linkedin"),
  TI_BRAND_LINKTREE("ti-brand-linktree"),
  TI_BRAND_LINQPAD("ti-brand-linqpad"),
  TI_BRAND_LIVEWIRE("ti-brand-livewire"),
  TI_BRAND_LOOM("ti-brand-loom"),
  TI_BRAND_MAILGUN("ti-brand-mailgun"),
  TI_BRAND_MANTINE("ti-brand-mantine"),
  TI_BRAND_MASTERCARD("ti-brand-mastercard"),
  TI_BRAND_MASTODON("ti-brand-mastodon"),
  TI_BRAND_MATRIX("ti-brand-matrix"),
  TI_BRAND_MCDONALDS("ti-brand-mcdonalds"),
  TI_BRAND_MEDIUM("ti-brand-medium"),
  TI_BRAND_MEETUP("ti-brand-meetup"),
  TI_BRAND_MERCEDES("ti-brand-mercedes"),
  TI_BRAND_MESSENGER("ti-brand-messenger"),
  TI_BRAND_META("ti-brand-meta"),
  TI_BRAND_METABRAINZ("ti-brand-metabrainz"),
  TI_BRAND_MINECRAFT("ti-brand-minecraft"),
  TI_BRAND_MINIPROGRAM("ti-brand-miniprogram"),
  TI_BRAND_MIXPANEL("ti-brand-mixpanel"),
  TI_BRAND_MONDAY("ti-brand-monday"),
  TI_BRAND_MONGODB("ti-brand-mongodb"),
  TI_BRAND_MY_OPPO("ti-brand-my-oppo"),
  TI_BRAND_MYSQL("ti-brand-mysql"),
  TI_BRAND_NATIONAL_GEOGRAPHIC("ti-brand-national-geographic"),
  TI_BRAND_NEM("ti-brand-nem"),
  TI_BRAND_NETBEANS("ti-brand-netbeans"),
  TI_BRAND_NETEASE_MUSIC("ti-brand-netease-music"),
  TI_BRAND_NETFLIX("ti-brand-netflix"),
  TI_BRAND_NEXO("ti-brand-nexo"),
  TI_BRAND_NEXTCLOUD("ti-brand-nextcloud"),
  TI_BRAND_NEXTJS("ti-brand-nextjs"),
  TI_BRAND_NODEJS("ti-brand-nodejs"),
  TI_BRAND_NORD_VPN("ti-brand-nord-vpn"),
  TI_BRAND_NOTION("ti-brand-notion"),
  TI_BRAND_NPM("ti-brand-npm"),
  TI_BRAND_NUXT("ti-brand-nuxt"),
  TI_BRAND_NYTIMES("ti-brand-nytimes"),
  TI_BRAND_OAUTH("ti-brand-oauth"),
  TI_BRAND_OFFICE("ti-brand-office"),
  TI_BRAND_OK_RU("ti-brand-ok-ru"),
  TI_BRAND_ONEDRIVE("ti-brand-onedrive"),
  TI_BRAND_ONLYFANS("ti-brand-onlyfans"),
  TI_BRAND_OPEN_SOURCE("ti-brand-open-source"),
  TI_BRAND_OPENAI("ti-brand-openai"),
  TI_BRAND_OPENVPN("ti-brand-openvpn"),
  TI_BRAND_OPERA("ti-brand-opera"),
  TI_BRAND_PAGEKIT("ti-brand-pagekit"),
  TI_BRAND_PARSINTA("ti-brand-parsinta"),
  TI_BRAND_PATREON("ti-brand-patreon"),
  TI_BRAND_PAYPAL("ti-brand-paypal"),
  TI_BRAND_PAYPAY("ti-brand-paypay"),
  TI_BRAND_PEANUT("ti-brand-peanut"),
  TI_BRAND_PEPSI("ti-brand-pepsi"),
  TI_BRAND_PHP("ti-brand-php"),
  TI_BRAND_PICSART("ti-brand-picsart"),
  TI_BRAND_PINTEREST("ti-brand-pinterest"),
  TI_BRAND_PLANETSCALE("ti-brand-planetscale"),
  TI_BRAND_PNPM("ti-brand-pnpm"),
  TI_BRAND_POCKET("ti-brand-pocket"),
  TI_BRAND_POLYMER("ti-brand-polymer"),
  TI_BRAND_POWERSHELL("ti-brand-powershell"),
  TI_BRAND_PRINTABLES("ti-brand-printables"),
  TI_BRAND_PRISMA("ti-brand-prisma"),
  TI_BRAND_PRODUCTHUNT("ti-brand-producthunt"),
  TI_BRAND_PUSHBULLET("ti-brand-pushbullet"),
  TI_BRAND_PUSHOVER("ti-brand-pushover"),
  TI_BRAND_PYTHON("ti-brand-python"),
  TI_BRAND_QQ("ti-brand-qq"),
  TI_BRAND_RADIX_UI("ti-brand-radix-ui"),
  TI_BRAND_REACT("ti-brand-react"),
  TI_BRAND_REACT_NATIVE("ti-brand-react-native"),
  TI_BRAND_REASON("ti-brand-reason"),
  TI_BRAND_REDDIT("ti-brand-reddit"),
  TI_BRAND_REDHAT("ti-brand-redhat"),
  TI_BRAND_REDUX("ti-brand-redux"),
  TI_BRAND_REVOLUT("ti-brand-revolut"),
  TI_BRAND_RUMBLE("ti-brand-rumble"),
  TI_BRAND_RUST("ti-brand-rust"),
  TI_BRAND_SAFARI("ti-brand-safari"),
  TI_BRAND_SAMSUNGPASS("ti-brand-samsungpass"),
  TI_BRAND_SASS("ti-brand-sass"),
  TI_BRAND_SENTRY("ti-brand-sentry"),
  TI_BRAND_SHARIK("ti-brand-sharik"),
  TI_BRAND_SHAZAM("ti-brand-shazam"),
  TI_BRAND_SHOPEE("ti-brand-shopee"),
  TI_BRAND_SIGNAL("ti-brand-signal"),
  TI_BRAND_SKETCH("ti-brand-sketch"),
  TI_BRAND_SKYPE("ti-brand-skype"),
  TI_BRAND_SLACK("ti-brand-slack"),
  TI_BRAND_SNAPCHAT("ti-brand-snapchat"),
  TI_BRAND_SNAPSEED("ti-brand-snapseed"),
  TI_BRAND_SNOWFLAKE("ti-brand-snowflake"),
  TI_BRAND_SOCKET_IO("ti-brand-socket-io"),
  TI_BRAND_SOLIDJS("ti-brand-solidjs"),
  TI_BRAND_SOUNDCLOUD("ti-brand-soundcloud"),
  TI_BRAND_SPACEHEY("ti-brand-spacehey"),
  TI_BRAND_SPEEDTEST("ti-brand-speedtest"),
  TI_BRAND_SPOTIFY("ti-brand-spotify"),
  TI_BRAND_STACKOVERFLOW("ti-brand-stackoverflow"),
  TI_BRAND_STACKSHARE("ti-brand-stackshare"),
  TI_BRAND_STEAM("ti-brand-steam"),
  TI_BRAND_STELLAR("ti-brand-stellar"),
  TI_BRAND_STOCKTWITS("ti-brand-stocktwits"),
  TI_BRAND_STORJ("ti-brand-storj"),
  TI_BRAND_STORYBOOK("ti-brand-storybook"),
  TI_BRAND_STORYTEL("ti-brand-storytel"),
  TI_BRAND_STRAVA("ti-brand-strava"),
  TI_BRAND_STRIPE("ti-brand-stripe"),
  TI_BRAND_SUBLIME_TEXT("ti-brand-sublime-text"),
  TI_BRAND_SUGARIZER("ti-brand-sugarizer"),
  TI_BRAND_SUPABASE("ti-brand-supabase"),
  TI_BRAND_SUPERHUMAN("ti-brand-superhuman"),
  TI_BRAND_SUPERNOVA("ti-brand-supernova"),
  TI_BRAND_SURFSHARK("ti-brand-surfshark"),
  TI_BRAND_SVELTE("ti-brand-svelte"),
  TI_BRAND_SWIFT("ti-brand-swift"),
  TI_BRAND_SYMFONY("ti-brand-symfony"),
  TI_BRAND_TABLER("ti-brand-tabler"),
  TI_BRAND_TABNINE("ti-brand-tabnine"),
  TI_BRAND_TAILWIND("ti-brand-tailwind"),
  TI_BRAND_TAOBAO("ti-brand-taobao"),
  TI_BRAND_TEAMS("ti-brand-teams"),
  TI_BRAND_TED("ti-brand-ted"),
  TI_BRAND_TELEGRAM("ti-brand-telegram"),
  TI_BRAND_TERRAFORM("ti-brand-terraform"),
  TI_BRAND_TESLA("ti-brand-tesla"),
  TI_BRAND_TETHER("ti-brand-tether"),
  TI_BRAND_THINGIVERSE("ti-brand-thingiverse"),
  TI_BRAND_THREADS("ti-brand-threads"),
  TI_BRAND_THREEJS("ti-brand-threejs"),
  TI_BRAND_TIDAL("ti-brand-tidal"),
  TI_BRAND_TIKTOK("ti-brand-tiktok"),
  TI_BRAND_TINDER("ti-brand-tinder"),
  TI_BRAND_TOPBUZZ("ti-brand-topbuzz"),
  TI_BRAND_TORCHAIN("ti-brand-torchain"),
  TI_BRAND_TOYOTA("ti-brand-toyota"),
  TI_BRAND_TRELLO("ti-brand-trello"),
  TI_BRAND_TRIPADVISOR("ti-brand-tripadvisor"),
  TI_BRAND_TUMBLR("ti-brand-tumblr"),
  TI_BRAND_TWILIO("ti-brand-twilio"),
  TI_BRAND_TWITCH("ti-brand-twitch"),
  TI_BRAND_TWITTER("ti-brand-twitter"),
  TI_BRAND_TYPESCRIPT("ti-brand-typescript"),
  TI_BRAND_UBER("ti-brand-uber"),
  TI_BRAND_UBUNTU("ti-brand-ubuntu"),
  TI_BRAND_UNITY("ti-brand-unity"),
  TI_BRAND_UNSPLASH("ti-brand-unsplash"),
  TI_BRAND_UPWORK("ti-brand-upwork"),
  TI_BRAND_VALORANT("ti-brand-valorant"),
  TI_BRAND_VECHAIN("ti-brand-vechain"),
  TI_BRAND_VERCEL("ti-brand-vercel"),
  TI_BRAND_VIMEO("ti-brand-vimeo"),
  TI_BRAND_VINTED("ti-brand-vinted"),
  TI_BRAND_VISA("ti-brand-visa"),
  TI_BRAND_VISUAL_STUDIO("ti-brand-visual-studio"),
  TI_BRAND_VITE("ti-brand-vite"),
  TI_BRAND_VIVALDI("ti-brand-vivaldi"),
  TI_BRAND_VK("ti-brand-vk"),
  TI_BRAND_VLC("ti-brand-vlc"),
  TI_BRAND_VOLKSWAGEN("ti-brand-volkswagen"),
  TI_BRAND_VSCO("ti-brand-vsco"),
  TI_BRAND_VSCODE("ti-brand-vscode"),
  TI_BRAND_VUE("ti-brand-vue"),
  TI_BRAND_WALMART("ti-brand-walmart"),
  TI_BRAND_WAZE("ti-brand-waze"),
  TI_BRAND_WEBFLOW("ti-brand-webflow"),
  TI_BRAND_WECHAT("ti-brand-wechat"),
  TI_BRAND_WEIBO("ti-brand-weibo"),
  TI_BRAND_WHATSAPP("ti-brand-whatsapp"),
  TI_BRAND_WIKIPEDIA("ti-brand-wikipedia"),
  TI_BRAND_WINDOWS("ti-brand-windows"),
  TI_BRAND_WINDY("ti-brand-windy"),
  TI_BRAND_WISH("ti-brand-wish"),
  TI_BRAND_WIX("ti-brand-wix"),
  TI_BRAND_WORDPRESS("ti-brand-wordpress"),
  TI_BRAND_X("ti-brand-x"),
  TI_BRAND_XAMARIN("ti-brand-xamarin"),
  TI_BRAND_XBOX("ti-brand-xbox"),
  TI_BRAND_XDEEP("ti-brand-xdeep"),
  TI_BRAND_XING("ti-brand-xing"),
  TI_BRAND_YAHOO("ti-brand-yahoo"),
  TI_BRAND_YANDEX("ti-brand-yandex"),
  TI_BRAND_YARN("ti-brand-yarn"),
  TI_BRAND_YATSE("ti-brand-yatse"),
  TI_BRAND_YCOMBINATOR("ti-brand-ycombinator"),
  TI_BRAND_YOUTUBE("ti-brand-youtube"),
  TI_BRAND_YOUTUBE_KIDS("ti-brand-youtube-kids"),
  TI_BRAND_ZALANDO("ti-brand-zalando"),
  TI_BRAND_ZAPIER("ti-brand-zapier"),
  TI_BRAND_ZEIT("ti-brand-zeit"),
  TI_BRAND_ZHIHU("ti-brand-zhihu"),
  TI_BRAND_ZOOM("ti-brand-zoom"),
  TI_BRAND_ZULIP("ti-brand-zulip"),
  TI_BRAND_ZWIFT("ti-brand-zwift"),
  TI_BREAD("ti-bread"),
  TI_BREAD_OFF("ti-bread-off"),
  TI_BRIEFCASE("ti-briefcase"),
  TI_BRIEFCASE_2("ti-briefcase-2"),
  TI_BRIEFCASE_OFF("ti-briefcase-off"),
  TI_BRIGHTNESS("ti-brightness"),
  TI_BRIGHTNESS_2("ti-brightness-2"),
  TI_BRIGHTNESS_AUTO("ti-brightness-auto"),
  TI_BRIGHTNESS_DOWN("ti-brightness-down"),
  TI_BRIGHTNESS_HALF("ti-brightness-half"),
  TI_BRIGHTNESS_OFF("ti-brightness-off"),
  TI_BRIGHTNESS_UP("ti-brightness-up"),
  TI_BROADCAST("ti-broadcast"),
  TI_BROADCAST_OFF("ti-broadcast-off"),
  TI_BROWSER("ti-browser"),
  TI_BROWSER_CHECK("ti-browser-check"),
  TI_BROWSER_MAXIMIZE("ti-browser-maximize"),
  TI_BROWSER_MINUS("ti-browser-minus"),
  TI_BROWSER_OFF("ti-browser-off"),
  TI_BROWSER_PLUS("ti-browser-plus"),
  TI_BROWSER_SHARE("ti-browser-share"),
  TI_BROWSER_X("ti-browser-x"),
  TI_BRUSH("ti-brush"),
  TI_BRUSH_OFF("ti-brush-off"),
  TI_BUBBLE("ti-bubble"),
  TI_BUBBLE_MINUS("ti-bubble-minus"),
  TI_BUBBLE_PLUS("ti-bubble-plus"),
  TI_BUBBLE_TEA("ti-bubble-tea"),
  TI_BUBBLE_TEA_2("ti-bubble-tea-2"),
  TI_BUBBLE_TEXT("ti-bubble-text"),
  TI_BUBBLE_X("ti-bubble-x"),
  TI_BUCKET("ti-bucket"),
  TI_BUCKET_DROPLET("ti-bucket-droplet"),
  TI_BUCKET_OFF("ti-bucket-off"),
  TI_BUG("ti-bug"),
  TI_BUG_OFF("ti-bug-off"),
  TI_BUILDING("ti-building"),
  TI_BUILDING_AIRPORT("ti-building-airport"),
  TI_BUILDING_ARCH("ti-building-arch"),
  TI_BUILDING_BANK("ti-building-bank"),
  TI_BUILDING_BRIDGE("ti-building-bridge"),
  TI_BUILDING_BRIDGE_2("ti-building-bridge-2"),
  TI_BUILDING_BROADCAST_TOWER("ti-building-broadcast-tower"),
  TI_BUILDING_BURJ_AL_ARAB("ti-building-burj-al-arab"),
  TI_BUILDING_CAROUSEL("ti-building-carousel"),
  TI_BUILDING_CASTLE("ti-building-castle"),
  TI_BUILDING_CHURCH("ti-building-church"),
  TI_BUILDING_CIRCUS("ti-building-circus"),
  TI_BUILDING_COG("ti-building-cog"),
  TI_BUILDING_COMMUNITY("ti-building-community"),
  TI_BUILDING_COTTAGE("ti-building-cottage"),
  TI_BUILDING_EIFFEL_TOWER("ti-building-eiffel-tower"),
  TI_BUILDING_ESTATE("ti-building-estate"),
  TI_BUILDING_FACTORY("ti-building-factory"),
  TI_BUILDING_FACTORY_2("ti-building-factory-2"),
  TI_BUILDING_FORTRESS("ti-building-fortress"),
  TI_BUILDING_HOSPITAL("ti-building-hospital"),
  TI_BUILDING_LIGHTHOUSE("ti-building-lighthouse"),
  TI_BUILDING_MINUS("ti-building-minus"),
  TI_BUILDING_MONUMENT("ti-building-monument"),
  TI_BUILDING_MOSQUE("ti-building-mosque"),
  TI_BUILDING_OFF("ti-building-off"),
  TI_BUILDING_PAVILION("ti-building-pavilion"),
  TI_BUILDING_PLUS("ti-building-plus"),
  TI_BUILDING_SKYSCRAPER("ti-building-skyscraper"),
  TI_BUILDING_STADIUM("ti-building-stadium"),
  TI_BUILDING_STORE("ti-building-store"),
  TI_BUILDING_TUNNEL("ti-building-tunnel"),
  TI_BUILDING_WAREHOUSE("ti-building-warehouse"),
  TI_BUILDING_WIND_TURBINE("ti-building-wind-turbine"),
  TI_BUILDINGS("ti-buildings"),
  TI_BULB("ti-bulb"),
  TI_BULB_OFF("ti-bulb-off"),
  TI_BULLDOZER("ti-bulldozer"),
  TI_BURGER("ti-burger"),
  TI_BUS("ti-bus"),
  TI_BUS_OFF("ti-bus-off"),
  TI_BUS_STOP("ti-bus-stop"),
  TI_BUSINESSPLAN("ti-businessplan"),
  TI_BUTTERFLY("ti-butterfly"),
  TI_CACTUS("ti-cactus"),
  TI_CACTUS_OFF("ti-cactus-off"),
  TI_CAKE("ti-cake"),
  TI_CAKE_OFF("ti-cake-off"),
  TI_CAKE_ROLL("ti-cake-roll"),
  TI_CALCULATOR("ti-calculator"),
  TI_CALCULATOR_OFF("ti-calculator-off"),
  TI_CALENDAR("ti-calendar"),
  TI_CALENDAR_BOLT("ti-calendar-bolt"),
  TI_CALENDAR_CANCEL("ti-calendar-cancel"),
  TI_CALENDAR_CHECK("ti-calendar-check"),
  TI_CALENDAR_CLOCK("ti-calendar-clock"),
  TI_CALENDAR_CODE("ti-calendar-code"),
  TI_CALENDAR_COG("ti-calendar-cog"),
  TI_CALENDAR_DOLLAR("ti-calendar-dollar"),
  TI_CALENDAR_DOT("ti-calendar-dot"),
  TI_CALENDAR_DOWN("ti-calendar-down"),
  TI_CALENDAR_DUE("ti-calendar-due"),
  TI_CALENDAR_EVENT("ti-calendar-event"),
  TI_CALENDAR_EXCLAMATION("ti-calendar-exclamation"),
  TI_CALENDAR_HEART("ti-calendar-heart"),
  TI_CALENDAR_MINUS("ti-calendar-minus"),
  TI_CALENDAR_MONTH("ti-calendar-month"),
  TI_CALENDAR_OFF("ti-calendar-off"),
  TI_CALENDAR_PAUSE("ti-calendar-pause"),
  TI_CALENDAR_PIN("ti-calendar-pin"),
  TI_CALENDAR_PLUS("ti-calendar-plus"),
  TI_CALENDAR_QUESTION("ti-calendar-question"),
  TI_CALENDAR_REPEAT("ti-calendar-repeat"),
  TI_CALENDAR_SAD("ti-calendar-sad"),
  TI_CALENDAR_SEARCH("ti-calendar-search"),
  TI_CALENDAR_SHARE("ti-calendar-share"),
  TI_CALENDAR_SMILE("ti-calendar-smile"),
  TI_CALENDAR_STAR("ti-calendar-star"),
  TI_CALENDAR_STATS("ti-calendar-stats"),
  TI_CALENDAR_TIME("ti-calendar-time"),
  TI_CALENDAR_UP("ti-calendar-up"),
  TI_CALENDAR_USER("ti-calendar-user"),
  TI_CALENDAR_WEEK("ti-calendar-week"),
  TI_CALENDAR_X("ti-calendar-x"),
  TI_CAMERA("ti-camera"),
  TI_CAMERA_AI("ti-camera-ai"),
  TI_CAMERA_BITCOIN("ti-camera-bitcoin"),
  TI_CAMERA_BOLT("ti-camera-bolt"),
  TI_CAMERA_CANCEL("ti-camera-cancel"),
  TI_CAMERA_CHECK("ti-camera-check"),
  TI_CAMERA_CODE("ti-camera-code"),
  TI_CAMERA_COG("ti-camera-cog"),
  TI_CAMERA_DOLLAR("ti-camera-dollar"),
  TI_CAMERA_DOWN("ti-camera-down"),
  TI_CAMERA_EXCLAMATION("ti-camera-exclamation"),
  TI_CAMERA_HEART("ti-camera-heart"),
  TI_CAMERA_MINUS("ti-camera-minus"),
  TI_CAMERA_MOON("ti-camera-moon"),
  TI_CAMERA_OFF("ti-camera-off"),
  TI_CAMERA_PAUSE("ti-camera-pause"),
  TI_CAMERA_PIN("ti-camera-pin"),
  TI_CAMERA_PLUS("ti-camera-plus"),
  TI_CAMERA_QUESTION("ti-camera-question"),
  TI_CAMERA_ROTATE("ti-camera-rotate"),
  TI_CAMERA_SEARCH("ti-camera-search"),
  TI_CAMERA_SELFIE("ti-camera-selfie"),
  TI_CAMERA_SHARE("ti-camera-share"),
  TI_CAMERA_SPARK("ti-camera-spark"),
  TI_CAMERA_STAR("ti-camera-star"),
  TI_CAMERA_UP("ti-camera-up"),
  TI_CAMERA_X("ti-camera-x"),
  TI_CAMPER("ti-camper"),
  TI_CAMPFIRE("ti-campfire"),
  TI_CANARY("ti-canary"),
  TI_CANCEL("ti-cancel"),
  TI_CANDLE("ti-candle"),
  TI_CANDY("ti-candy"),
  TI_CANDY_OFF("ti-candy-off"),
  TI_CANE("ti-cane"),
  TI_CANNABIS("ti-cannabis"),
  TI_CAP_PROJECTING("ti-cap-projecting"),
  TI_CAP_ROUNDED("ti-cap-rounded"),
  TI_CAP_STRAIGHT("ti-cap-straight"),
  TI_CAPSULE("ti-capsule"),
  TI_CAPSULE_HORIZONTAL("ti-capsule-horizontal"),
  TI_CAPTURE("ti-capture"),
  TI_CAPTURE_OFF("ti-capture-off"),
  TI_CAR("ti-car"),
  TI_CAR_4WD("ti-car-4wd"),
  TI_CAR_CRANE("ti-car-crane"),
  TI_CAR_CRASH("ti-car-crash"),
  TI_CAR_DOOR("ti-car-door"),
  TI_CAR_FAN("ti-car-fan"),
  TI_CAR_FAN_1("ti-car-fan-1"),
  TI_CAR_FAN_2("ti-car-fan-2"),
  TI_CAR_FAN_3("ti-car-fan-3"),
  TI_CAR_FAN_AUTO("ti-car-fan-auto"),
  TI_CAR_GARAGE("ti-car-garage"),
  TI_CAR_LIFTER("ti-car-lifter"),
  TI_CAR_OFF("ti-car-off"),
  TI_CAR_OFF_ROAD("ti-car-off-road"),
  TI_CAR_SUSPENSION("ti-car-suspension"),
  TI_CAR_SUV("ti-car-suv"),
  TI_CAR_TURBINE("ti-car-turbine"),
  TI_CARAMBOLA("ti-carambola"),
  TI_CARAVAN("ti-caravan"),
  TI_CARDBOARDS("ti-cardboards"),
  TI_CARDBOARDS_OFF("ti-cardboards-off"),
  TI_CARDS("ti-cards"),
  TI_CARET_DOWN("ti-caret-down"),
  TI_CARET_LEFT("ti-caret-left"),
  TI_CARET_LEFT_RIGHT("ti-caret-left-right"),
  TI_CARET_RIGHT("ti-caret-right"),
  TI_CARET_UP("ti-caret-up"),
  TI_CARET_UP_DOWN("ti-caret-up-down"),
  TI_CAROUSEL_HORIZONTAL("ti-carousel-horizontal"),
  TI_CAROUSEL_VERTICAL("ti-carousel-vertical"),
  TI_CARROT("ti-carrot"),
  TI_CARROT_OFF("ti-carrot-off"),
  TI_CASH("ti-cash"),
  TI_CASH_BANKNOTE("ti-cash-banknote"),
  TI_CASH_BANKNOTE_EDIT("ti-cash-banknote-edit"),
  TI_CASH_BANKNOTE_HEART("ti-cash-banknote-heart"),
  TI_CASH_BANKNOTE_MINUS("ti-cash-banknote-minus"),
  TI_CASH_BANKNOTE_MOVE("ti-cash-banknote-move"),
  TI_CASH_BANKNOTE_MOVE_BACK("ti-cash-banknote-move-back"),
  TI_CASH_BANKNOTE_OFF("ti-cash-banknote-off"),
  TI_CASH_BANKNOTE_PLUS("ti-cash-banknote-plus"),
  TI_CASH_EDIT("ti-cash-edit"),
  TI_CASH_HEART("ti-cash-heart"),
  TI_CASH_MINUS("ti-cash-minus"),
  TI_CASH_MOVE("ti-cash-move"),
  TI_CASH_MOVE_BACK("ti-cash-move-back"),
  TI_CASH_OFF("ti-cash-off"),
  TI_CASH_PLUS("ti-cash-plus"),
  TI_CASH_REGISTER("ti-cash-register"),
  TI_CAST("ti-cast"),
  TI_CAST_OFF("ti-cast-off"),
  TI_CAT("ti-cat"),
  TI_CATEGORY("ti-category"),
  TI_CATEGORY_2("ti-category-2"),
  TI_CATEGORY_MINUS("ti-category-minus"),
  TI_CATEGORY_PLUS("ti-category-plus"),
  TI_CE("ti-ce"),
  TI_CE_OFF("ti-ce-off"),
  TI_CELL("ti-cell"),
  TI_CELL_SIGNAL_1("ti-cell-signal-1"),
  TI_CELL_SIGNAL_2("ti-cell-signal-2"),
  TI_CELL_SIGNAL_3("ti-cell-signal-3"),
  TI_CELL_SIGNAL_4("ti-cell-signal-4"),
  TI_CELL_SIGNAL_5("ti-cell-signal-5"),
  TI_CELL_SIGNAL_OFF("ti-cell-signal-off"),
  TI_CERTIFICATE("ti-certificate"),
  TI_CERTIFICATE_2("ti-certificate-2"),
  TI_CERTIFICATE_2_OFF("ti-certificate-2-off"),
  TI_CERTIFICATE_OFF("ti-certificate-off"),
  TI_CHAIR_DIRECTOR("ti-chair-director"),
  TI_CHALKBOARD("ti-chalkboard"),
  TI_CHALKBOARD_OFF("ti-chalkboard-off"),
  TI_CHALKBOARD_TEACHER("ti-chalkboard-teacher"),
  TI_CHARGING_PILE("ti-charging-pile"),
  TI_CHART_ARCS("ti-chart-arcs"),
  TI_CHART_ARCS_3("ti-chart-arcs-3"),
  TI_CHART_AREA("ti-chart-area"),
  TI_CHART_AREA_LINE("ti-chart-area-line"),
  TI_CHART_ARROWS("ti-chart-arrows"),
  TI_CHART_ARROWS_VERTICAL("ti-chart-arrows-vertical"),
  TI_CHART_BAR("ti-chart-bar"),
  TI_CHART_BAR_OFF("ti-chart-bar-off"),
  TI_CHART_BAR_POPULAR("ti-chart-bar-popular"),
  TI_CHART_BUBBLE("ti-chart-bubble"),
  TI_CHART_CANDLE("ti-chart-candle"),
  TI_CHART_CIRCLES("ti-chart-circles"),
  TI_CHART_COHORT("ti-chart-cohort"),
  TI_CHART_COLUMN("ti-chart-column"),
  TI_CHART_COVARIATE("ti-chart-covariate"),
  TI_CHART_DONUT("ti-chart-donut"),
  TI_CHART_DONUT_2("ti-chart-donut-2"),
  TI_CHART_DONUT_3("ti-chart-donut-3"),
  TI_CHART_DONUT_4("ti-chart-donut-4"),
  TI_CHART_DOTS("ti-chart-dots"),
  TI_CHART_DOTS_2("ti-chart-dots-2"),
  TI_CHART_DOTS_3("ti-chart-dots-3"),
  TI_CHART_FUNNEL("ti-chart-funnel"),
  TI_CHART_GRID_DOTS("ti-chart-grid-dots"),
  TI_CHART_HISTOGRAM("ti-chart-histogram"),
  TI_CHART_INFOGRAPHIC("ti-chart-infographic"),
  TI_CHART_LINE("ti-chart-line"),
  TI_CHART_PIE("ti-chart-pie"),
  TI_CHART_PIE_2("ti-chart-pie-2"),
  TI_CHART_PIE_3("ti-chart-pie-3"),
  TI_CHART_PIE_4("ti-chart-pie-4"),
  TI_CHART_PIE_OFF("ti-chart-pie-off"),
  TI_CHART_PPF("ti-chart-ppf"),
  TI_CHART_RADAR("ti-chart-radar"),
  TI_CHART_SANKEY("ti-chart-sankey"),
  TI_CHART_SCATTER("ti-chart-scatter"),
  TI_CHART_SCATTER_3D("ti-chart-scatter-3d"),
  TI_CHART_TREEMAP("ti-chart-treemap"),
  TI_CHECK("ti-check"),
  TI_CHECKBOX("ti-checkbox"),
  TI_CHECKLIST("ti-checklist"),
  TI_CHECKS("ti-checks"),
  TI_CHECKUP_LIST("ti-checkup-list"),
  TI_CHEESE("ti-cheese"),
  TI_CHEF_HAT("ti-chef-hat"),
  TI_CHEF_HAT_OFF("ti-chef-hat-off"),
  TI_CHERRY("ti-cherry"),
  TI_CHESS("ti-chess"),
  TI_CHESS_BISHOP("ti-chess-bishop"),
  TI_CHESS_KING("ti-chess-king"),
  TI_CHESS_KNIGHT("ti-chess-knight"),
  TI_CHESS_QUEEN("ti-chess-queen"),
  TI_CHESS_ROOK("ti-chess-rook"),
  TI_CHEVRON_COMPACT_DOWN("ti-chevron-compact-down"),
  TI_CHEVRON_COMPACT_LEFT("ti-chevron-compact-left"),
  TI_CHEVRON_COMPACT_RIGHT("ti-chevron-compact-right"),
  TI_CHEVRON_COMPACT_UP("ti-chevron-compact-up"),
  TI_CHEVRON_DOWN("ti-chevron-down"),
  TI_CHEVRON_DOWN_LEFT("ti-chevron-down-left"),
  TI_CHEVRON_DOWN_RIGHT("ti-chevron-down-right"),
  TI_CHEVRON_LEFT("ti-chevron-left"),
  TI_CHEVRON_LEFT_PIPE("ti-chevron-left-pipe"),
  TI_CHEVRON_RIGHT("ti-chevron-right"),
  TI_CHEVRON_RIGHT_PIPE("ti-chevron-right-pipe"),
  TI_CHEVRON_UP("ti-chevron-up"),
  TI_CHEVRON_UP_LEFT("ti-chevron-up-left"),
  TI_CHEVRON_UP_RIGHT("ti-chevron-up-right"),
  TI_CHEVRONS_DOWN("ti-chevrons-down"),
  TI_CHEVRONS_DOWN_LEFT("ti-chevrons-down-left"),
  TI_CHEVRONS_DOWN_RIGHT("ti-chevrons-down-right"),
  TI_CHEVRONS_LEFT("ti-chevrons-left"),
  TI_CHEVRONS_RIGHT("ti-chevrons-right"),
  TI_CHEVRONS_UP("ti-chevrons-up"),
  TI_CHEVRONS_UP_LEFT("ti-chevrons-up-left"),
  TI_CHEVRONS_UP_RIGHT("ti-chevrons-up-right"),
  TI_CHISEL("ti-chisel"),
  TI_CHOCOLATE("ti-chocolate"),
  TI_CHRISTMAS_BALL("ti-christmas-ball"),
  TI_CHRISTMAS_TREE("ti-christmas-tree"),
  TI_CHRISTMAS_TREE_OFF("ti-christmas-tree-off"),
  TI_CIRCLE("ti-circle"),
  TI_CIRCLE_0("ti-circle-0"),
  TI_CIRCLE_1("ti-circle-1"),
  TI_CIRCLE_2("ti-circle-2"),
  TI_CIRCLE_3("ti-circle-3"),
  TI_CIRCLE_4("ti-circle-4"),
  TI_CIRCLE_5("ti-circle-5"),
  TI_CIRCLE_6("ti-circle-6"),
  TI_CIRCLE_7("ti-circle-7"),
  TI_CIRCLE_8("ti-circle-8"),
  TI_CIRCLE_9("ti-circle-9"),
  TI_CIRCLE_ARROW_DOWN("ti-circle-arrow-down"),
  TI_CIRCLE_ARROW_DOWN_LEFT("ti-circle-arrow-down-left"),
  TI_CIRCLE_ARROW_DOWN_RIGHT("ti-circle-arrow-down-right"),
  TI_CIRCLE_ARROW_LEFT("ti-circle-arrow-left"),
  TI_CIRCLE_ARROW_RIGHT("ti-circle-arrow-right"),
  TI_CIRCLE_ARROW_UP("ti-circle-arrow-up"),
  TI_CIRCLE_ARROW_UP_LEFT("ti-circle-arrow-up-left"),
  TI_CIRCLE_ARROW_UP_RIGHT("ti-circle-arrow-up-right"),
  TI_CIRCLE_ASTERISK("ti-circle-asterisk"),
  TI_CIRCLE_CARET_DOWN("ti-circle-caret-down"),
  TI_CIRCLE_CARET_LEFT("ti-circle-caret-left"),
  TI_CIRCLE_CARET_RIGHT("ti-circle-caret-right"),
  TI_CIRCLE_CARET_UP("ti-circle-caret-up"),
  TI_CIRCLE_CHECK("ti-circle-check"),
  TI_CIRCLE_CHEVRON_DOWN("ti-circle-chevron-down"),
  TI_CIRCLE_CHEVRON_LEFT("ti-circle-chevron-left"),
  TI_CIRCLE_CHEVRON_RIGHT("ti-circle-chevron-right"),
  TI_CIRCLE_CHEVRON_UP("ti-circle-chevron-up"),
  TI_CIRCLE_CHEVRONS_DOWN("ti-circle-chevrons-down"),
  TI_CIRCLE_CHEVRONS_LEFT("ti-circle-chevrons-left"),
  TI_CIRCLE_CHEVRONS_RIGHT("ti-circle-chevrons-right"),
  TI_CIRCLE_CHEVRONS_UP("ti-circle-chevrons-up"),
  TI_CIRCLE_DASHED("ti-circle-dashed"),
  TI_CIRCLE_DASHED_CHECK("ti-circle-dashed-check"),
  TI_CIRCLE_DASHED_LETTER_A("ti-circle-dashed-letter-a"),
  TI_CIRCLE_DASHED_LETTER_B("ti-circle-dashed-letter-b"),
  TI_CIRCLE_DASHED_LETTER_C("ti-circle-dashed-letter-c"),
  TI_CIRCLE_DASHED_LETTER_D("ti-circle-dashed-letter-d"),
  TI_CIRCLE_DASHED_LETTER_E("ti-circle-dashed-letter-e"),
  TI_CIRCLE_DASHED_LETTER_F("ti-circle-dashed-letter-f"),
  TI_CIRCLE_DASHED_LETTER_G("ti-circle-dashed-letter-g"),
  TI_CIRCLE_DASHED_LETTER_H("ti-circle-dashed-letter-h"),
  TI_CIRCLE_DASHED_LETTER_I("ti-circle-dashed-letter-i"),
  TI_CIRCLE_DASHED_LETTER_J("ti-circle-dashed-letter-j"),
  TI_CIRCLE_DASHED_LETTER_K("ti-circle-dashed-letter-k"),
  TI_CIRCLE_DASHED_LETTER_L("ti-circle-dashed-letter-l"),
  TI_CIRCLE_DASHED_LETTER_LETTER_V("ti-circle-dashed-letter-letter-v"),
  TI_CIRCLE_DASHED_LETTER_M("ti-circle-dashed-letter-m"),
  TI_CIRCLE_DASHED_LETTER_N("ti-circle-dashed-letter-n"),
  TI_CIRCLE_DASHED_LETTER_O("ti-circle-dashed-letter-o"),
  TI_CIRCLE_DASHED_LETTER_P("ti-circle-dashed-letter-p"),
  TI_CIRCLE_DASHED_LETTER_Q("ti-circle-dashed-letter-q"),
  TI_CIRCLE_DASHED_LETTER_R("ti-circle-dashed-letter-r"),
  TI_CIRCLE_DASHED_LETTER_S("ti-circle-dashed-letter-s"),
  TI_CIRCLE_DASHED_LETTER_T("ti-circle-dashed-letter-t"),
  TI_CIRCLE_DASHED_LETTER_U("ti-circle-dashed-letter-u"),
  TI_CIRCLE_DASHED_LETTER_V("ti-circle-dashed-letter-v"),
  TI_CIRCLE_DASHED_LETTER_W("ti-circle-dashed-letter-w"),
  TI_CIRCLE_DASHED_LETTER_X("ti-circle-dashed-letter-x"),
  TI_CIRCLE_DASHED_LETTER_Y("ti-circle-dashed-letter-y"),
  TI_CIRCLE_DASHED_LETTER_Z("ti-circle-dashed-letter-z"),
  TI_CIRCLE_DASHED_MINUS("ti-circle-dashed-minus"),
  TI_CIRCLE_DASHED_NUMBER_0("ti-circle-dashed-number-0"),
  TI_CIRCLE_DASHED_NUMBER_1("ti-circle-dashed-number-1"),
  TI_CIRCLE_DASHED_NUMBER_2("ti-circle-dashed-number-2"),
  TI_CIRCLE_DASHED_NUMBER_3("ti-circle-dashed-number-3"),
  TI_CIRCLE_DASHED_NUMBER_4("ti-circle-dashed-number-4"),
  TI_CIRCLE_DASHED_NUMBER_5("ti-circle-dashed-number-5"),
  TI_CIRCLE_DASHED_NUMBER_6("ti-circle-dashed-number-6"),
  TI_CIRCLE_DASHED_NUMBER_7("ti-circle-dashed-number-7"),
  TI_CIRCLE_DASHED_NUMBER_8("ti-circle-dashed-number-8"),
  TI_CIRCLE_DASHED_NUMBER_9("ti-circle-dashed-number-9"),
  TI_CIRCLE_DASHED_PERCENTAGE("ti-circle-dashed-percentage"),
  TI_CIRCLE_DASHED_PLUS("ti-circle-dashed-plus"),
  TI_CIRCLE_DASHED_X("ti-circle-dashed-x"),
  TI_CIRCLE_DOT("ti-circle-dot"),
  TI_CIRCLE_DOTTED("ti-circle-dotted"),
  TI_CIRCLE_DOTTED_LETTER_A("ti-circle-dotted-letter-a"),
  TI_CIRCLE_DOTTED_LETTER_B("ti-circle-dotted-letter-b"),
  TI_CIRCLE_DOTTED_LETTER_C("ti-circle-dotted-letter-c"),
  TI_CIRCLE_DOTTED_LETTER_D("ti-circle-dotted-letter-d"),
  TI_CIRCLE_DOTTED_LETTER_E("ti-circle-dotted-letter-e"),
  TI_CIRCLE_DOTTED_LETTER_F("ti-circle-dotted-letter-f"),
  TI_CIRCLE_DOTTED_LETTER_G("ti-circle-dotted-letter-g"),
  TI_CIRCLE_DOTTED_LETTER_H("ti-circle-dotted-letter-h"),
  TI_CIRCLE_DOTTED_LETTER_I("ti-circle-dotted-letter-i"),
  TI_CIRCLE_DOTTED_LETTER_J("ti-circle-dotted-letter-j"),
  TI_CIRCLE_DOTTED_LETTER_K("ti-circle-dotted-letter-k"),
  TI_CIRCLE_DOTTED_LETTER_L("ti-circle-dotted-letter-l"),
  TI_CIRCLE_DOTTED_LETTER_M("ti-circle-dotted-letter-m"),
  TI_CIRCLE_DOTTED_LETTER_N("ti-circle-dotted-letter-n"),
  TI_CIRCLE_DOTTED_LETTER_O("ti-circle-dotted-letter-o"),
  TI_CIRCLE_DOTTED_LETTER_P("ti-circle-dotted-letter-p"),
  TI_CIRCLE_DOTTED_LETTER_Q("ti-circle-dotted-letter-q"),
  TI_CIRCLE_DOTTED_LETTER_R("ti-circle-dotted-letter-r"),
  TI_CIRCLE_DOTTED_LETTER_S("ti-circle-dotted-letter-s"),
  TI_CIRCLE_DOTTED_LETTER_T("ti-circle-dotted-letter-t"),
  TI_CIRCLE_DOTTED_LETTER_U("ti-circle-dotted-letter-u"),
  TI_CIRCLE_DOTTED_LETTER_V("ti-circle-dotted-letter-v"),
  TI_CIRCLE_DOTTED_LETTER_W("ti-circle-dotted-letter-w"),
  TI_CIRCLE_DOTTED_LETTER_X("ti-circle-dotted-letter-x"),
  TI_CIRCLE_DOTTED_LETTER_Y("ti-circle-dotted-letter-y"),
  TI_CIRCLE_DOTTED_LETTER_Z("ti-circle-dotted-letter-z"),
  TI_CIRCLE_HALF("ti-circle-half"),
  TI_CIRCLE_HALF_2("ti-circle-half-2"),
  TI_CIRCLE_HALF_VERTICAL("ti-circle-half-vertical"),
  TI_CIRCLE_KEY("ti-circle-key"),
  TI_CIRCLE_LETTER_A("ti-circle-letter-a"),
  TI_CIRCLE_LETTER_B("ti-circle-letter-b"),
  TI_CIRCLE_LETTER_C("ti-circle-letter-c"),
  TI_CIRCLE_LETTER_D("ti-circle-letter-d"),
  TI_CIRCLE_LETTER_E("ti-circle-letter-e"),
  TI_CIRCLE_LETTER_F("ti-circle-letter-f"),
  TI_CIRCLE_LETTER_G("ti-circle-letter-g"),
  TI_CIRCLE_LETTER_H("ti-circle-letter-h"),
  TI_CIRCLE_LETTER_I("ti-circle-letter-i"),
  TI_CIRCLE_LETTER_J("ti-circle-letter-j"),
  TI_CIRCLE_LETTER_K("ti-circle-letter-k"),
  TI_CIRCLE_LETTER_L("ti-circle-letter-l"),
  TI_CIRCLE_LETTER_M("ti-circle-letter-m"),
  TI_CIRCLE_LETTER_N("ti-circle-letter-n"),
  TI_CIRCLE_LETTER_O("ti-circle-letter-o"),
  TI_CIRCLE_LETTER_P("ti-circle-letter-p"),
  TI_CIRCLE_LETTER_Q("ti-circle-letter-q"),
  TI_CIRCLE_LETTER_R("ti-circle-letter-r"),
  TI_CIRCLE_LETTER_S("ti-circle-letter-s"),
  TI_CIRCLE_LETTER_T("ti-circle-letter-t"),
  TI_CIRCLE_LETTER_U("ti-circle-letter-u"),
  TI_CIRCLE_LETTER_V("ti-circle-letter-v"),
  TI_CIRCLE_LETTER_W("ti-circle-letter-w"),
  TI_CIRCLE_LETTER_X("ti-circle-letter-x"),
  TI_CIRCLE_LETTER_Y("ti-circle-letter-y"),
  TI_CIRCLE_LETTER_Z("ti-circle-letter-z"),
  TI_CIRCLE_MINUS("ti-circle-minus"),
  TI_CIRCLE_MINUS_2("ti-circle-minus-2"),
  TI_CIRCLE_NUMBER_0("ti-circle-number-0"),
  TI_CIRCLE_NUMBER_1("ti-circle-number-1"),
  TI_CIRCLE_NUMBER_2("ti-circle-number-2"),
  TI_CIRCLE_NUMBER_3("ti-circle-number-3"),
  TI_CIRCLE_NUMBER_4("ti-circle-number-4"),
  TI_CIRCLE_NUMBER_5("ti-circle-number-5"),
  TI_CIRCLE_NUMBER_6("ti-circle-number-6"),
  TI_CIRCLE_NUMBER_7("ti-circle-number-7"),
  TI_CIRCLE_NUMBER_8("ti-circle-number-8"),
  TI_CIRCLE_NUMBER_9("ti-circle-number-9"),
  TI_CIRCLE_OFF("ti-circle-off"),
  TI_CIRCLE_OPEN_ARROW_DOWN("ti-circle-open-arrow-down"),
  TI_CIRCLE_OPEN_ARROW_LEFT("ti-circle-open-arrow-left"),
  TI_CIRCLE_OPEN_ARROW_RIGHT("ti-circle-open-arrow-right"),
  TI_CIRCLE_OPEN_ARROW_UP("ti-circle-open-arrow-up"),
  TI_CIRCLE_PERCENTAGE("ti-circle-percentage"),
  TI_CIRCLE_PLUS("ti-circle-plus"),
  TI_CIRCLE_PLUS_2("ti-circle-plus-2"),
  TI_CIRCLE_PLUS_MINUS("ti-circle-plus-minus"),
  TI_CIRCLE_RECTANGLE("ti-circle-rectangle"),
  TI_CIRCLE_RECTANGLE_OFF("ti-circle-rectangle-off"),
  TI_CIRCLE_SQUARE("ti-circle-square"),
  TI_CIRCLE_TRIANGLE("ti-circle-triangle"),
  TI_CIRCLE_X("ti-circle-x"),
  TI_CIRCLES("ti-circles"),
  TI_CIRCLES_RELATION("ti-circles-relation"),
  TI_CIRCUIT_AMMETER("ti-circuit-ammeter"),
  TI_CIRCUIT_BATTERY("ti-circuit-battery"),
  TI_CIRCUIT_BULB("ti-circuit-bulb"),
  TI_CIRCUIT_CAPACITOR("ti-circuit-capacitor"),
  TI_CIRCUIT_CAPACITOR_POLARIZED("ti-circuit-capacitor-polarized"),
  TI_CIRCUIT_CELL("ti-circuit-cell"),
  TI_CIRCUIT_CELL_PLUS("ti-circuit-cell-plus"),
  TI_CIRCUIT_CHANGEOVER("ti-circuit-changeover"),
  TI_CIRCUIT_DIODE("ti-circuit-diode"),
  TI_CIRCUIT_DIODE_ZENER("ti-circuit-diode-zener"),
  TI_CIRCUIT_GROUND("ti-circuit-ground"),
  TI_CIRCUIT_GROUND_DIGITAL("ti-circuit-ground-digital"),
  TI_CIRCUIT_INDUCTOR("ti-circuit-inductor"),
  TI_CIRCUIT_MOTOR("ti-circuit-motor"),
  TI_CIRCUIT_PUSHBUTTON("ti-circuit-pushbutton"),
  TI_CIRCUIT_RESISTOR("ti-circuit-resistor"),
  TI_CIRCUIT_SWITCH_CLOSED("ti-circuit-switch-closed"),
  TI_CIRCUIT_SWITCH_OPEN("ti-circuit-switch-open"),
  TI_CIRCUIT_VOLTMETER("ti-circuit-voltmeter"),
  TI_CLEAR_ALL("ti-clear-all"),
  TI_CLEAR_FORMATTING("ti-clear-formatting"),
  TI_CLEF("ti-clef"),
  TI_CLEF_STAFF("ti-clef-staff"),
  TI_CLICK("ti-click"),
  TI_CLIFF_JUMPING("ti-cliff-jumping"),
  TI_CLIPBOARD("ti-clipboard"),
  TI_CLIPBOARD_CHECK("ti-clipboard-check"),
  TI_CLIPBOARD_COPY("ti-clipboard-copy"),
  TI_CLIPBOARD_DATA("ti-clipboard-data"),
  TI_CLIPBOARD_HEART("ti-clipboard-heart"),
  TI_CLIPBOARD_LIST("ti-clipboard-list"),
  TI_CLIPBOARD_OFF("ti-clipboard-off"),
  TI_CLIPBOARD_PLUS("ti-clipboard-plus"),
  TI_CLIPBOARD_SEARCH("ti-clipboard-search"),
  TI_CLIPBOARD_SMILE("ti-clipboard-smile"),
  TI_CLIPBOARD_TEXT("ti-clipboard-text"),
  TI_CLIPBOARD_TYPOGRAPHY("ti-clipboard-typography"),
  TI_CLIPBOARD_X("ti-clipboard-x"),
  TI_CLOCK("ti-clock"),
  TI_CLOCK_12("ti-clock-12"),
  TI_CLOCK_2("ti-clock-2"),
  TI_CLOCK_24("ti-clock-24"),
  TI_CLOCK_BITCOIN("ti-clock-bitcoin"),
  TI_CLOCK_BOLT("ti-clock-bolt"),
  TI_CLOCK_CANCEL("ti-clock-cancel"),
  TI_CLOCK_CHECK("ti-clock-check"),
  TI_CLOCK_CODE("ti-clock-code"),
  TI_CLOCK_COG("ti-clock-cog"),
  TI_CLOCK_DOLLAR("ti-clock-dollar"),
  TI_CLOCK_DOWN("ti-clock-down"),
  TI_CLOCK_EDIT("ti-clock-edit"),
  TI_CLOCK_EXCLAMATION("ti-clock-exclamation"),
  TI_CLOCK_HEART("ti-clock-heart"),
  TI_CLOCK_HOUR_1("ti-clock-hour-1"),
  TI_CLOCK_HOUR_10("ti-clock-hour-10"),
  TI_CLOCK_HOUR_11("ti-clock-hour-11"),
  TI_CLOCK_HOUR_12("ti-clock-hour-12"),
  TI_CLOCK_HOUR_2("ti-clock-hour-2"),
  TI_CLOCK_HOUR_3("ti-clock-hour-3"),
  TI_CLOCK_HOUR_4("ti-clock-hour-4"),
  TI_CLOCK_HOUR_5("ti-clock-hour-5"),
  TI_CLOCK_HOUR_6("ti-clock-hour-6"),
  TI_CLOCK_HOUR_7("ti-clock-hour-7"),
  TI_CLOCK_HOUR_8("ti-clock-hour-8"),
  TI_CLOCK_HOUR_9("ti-clock-hour-9"),
  TI_CLOCK_MINUS("ti-clock-minus"),
  TI_CLOCK_OFF("ti-clock-off"),
  TI_CLOCK_PAUSE("ti-clock-pause"),
  TI_CLOCK_PIN("ti-clock-pin"),
  TI_CLOCK_PLAY("ti-clock-play"),
  TI_CLOCK_PLUS("ti-clock-plus"),
  TI_CLOCK_QUESTION("ti-clock-question"),
  TI_CLOCK_RECORD("ti-clock-record"),
  TI_CLOCK_SEARCH("ti-clock-search"),
  TI_CLOCK_SHARE("ti-clock-share"),
  TI_CLOCK_SHIELD("ti-clock-shield"),
  TI_CLOCK_STAR("ti-clock-star"),
  TI_CLOCK_STOP("ti-clock-stop"),
  TI_CLOCK_UP("ti-clock-up"),
  TI_CLOCK_X("ti-clock-x"),
  TI_CLOTHES_RACK("ti-clothes-rack"),
  TI_CLOTHES_RACK_OFF("ti-clothes-rack-off"),
  TI_CLOUD("ti-cloud"),
  TI_CLOUD_BITCOIN("ti-cloud-bitcoin"),
  TI_CLOUD_BOLT("ti-cloud-bolt"),
  TI_CLOUD_CANCEL("ti-cloud-cancel"),
  TI_CLOUD_CHECK("ti-cloud-check"),
  TI_CLOUD_CODE("ti-cloud-code"),
  TI_CLOUD_COG("ti-cloud-cog"),
  TI_CLOUD_COMPUTING("ti-cloud-computing"),
  TI_CLOUD_DATA_CONNECTION("ti-cloud-data-connection"),
  TI_CLOUD_DOLLAR("ti-cloud-dollar"),
  TI_CLOUD_DOWN("ti-cloud-down"),
  TI_CLOUD_DOWNLOAD("ti-cloud-download"),
  TI_CLOUD_EXCLAMATION("ti-cloud-exclamation"),
  TI_CLOUD_FOG("ti-cloud-fog"),
  TI_CLOUD_HEART("ti-cloud-heart"),
  TI_CLOUD_LOCK("ti-cloud-lock"),
  TI_CLOUD_LOCK_OPEN("ti-cloud-lock-open"),
  TI_CLOUD_MINUS("ti-cloud-minus"),
  TI_CLOUD_NETWORK("ti-cloud-network"),
  TI_CLOUD_OFF("ti-cloud-off"),
  TI_CLOUD_PAUSE("ti-cloud-pause"),
  TI_CLOUD_PIN("ti-cloud-pin"),
  TI_CLOUD_PLUS("ti-cloud-plus"),
  TI_CLOUD_QUESTION("ti-cloud-question"),
  TI_CLOUD_RAIN("ti-cloud-rain"),
  TI_CLOUD_SEARCH("ti-cloud-search"),
  TI_CLOUD_SHARE("ti-cloud-share"),
  TI_CLOUD_SNOW("ti-cloud-snow"),
  TI_CLOUD_STAR("ti-cloud-star"),
  TI_CLOUD_STORM("ti-cloud-storm"),
  TI_CLOUD_UP("ti-cloud-up"),
  TI_CLOUD_UPLOAD("ti-cloud-upload"),
  TI_CLOUD_X("ti-cloud-x"),
  TI_CLOVER("ti-clover"),
  TI_CLOVER_2("ti-clover-2"),
  TI_CLUBS("ti-clubs"),
  TI_CODE("ti-code"),
  TI_CODE_AI("ti-code-ai"),
  TI_CODE_ASTERISK("ti-code-asterisk"),
  TI_CODE_ASTERIX("ti-code-asterix"),
  TI_CODE_CIRCLE("ti-code-circle"),
  TI_CODE_CIRCLE_2("ti-code-circle-2"),
  TI_CODE_DOTS("ti-code-dots"),
  TI_CODE_MINUS("ti-code-minus"),
  TI_CODE_OFF("ti-code-off"),
  TI_CODE_PLUS("ti-code-plus"),
  TI_CODE_VARIABLE("ti-code-variable"),
  TI_CODE_VARIABLE_MINUS("ti-code-variable-minus"),
  TI_CODE_VARIABLE_PLUS("ti-code-variable-plus"),
  TI_CODEBLOCK("ti-codeblock"),
  TI_COFFEE("ti-coffee"),
  TI_COFFEE_OFF("ti-coffee-off"),
  TI_COFFIN("ti-coffin"),
  TI_COIN("ti-coin"),
  TI_COIN_BITCOIN("ti-coin-bitcoin"),
  TI_COIN_EURO("ti-coin-euro"),
  TI_COIN_MONERO("ti-coin-monero"),
  TI_COIN_OFF("ti-coin-off"),
  TI_COIN_POUND("ti-coin-pound"),
  TI_COIN_RUPEE("ti-coin-rupee"),
  TI_COIN_TAKA("ti-coin-taka"),
  TI_COIN_YEN("ti-coin-yen"),
  TI_COIN_YUAN("ti-coin-yuan"),
  TI_COINS("ti-coins"),
  TI_COLOR_FILTER("ti-color-filter"),
  TI_COLOR_PICKER("ti-color-picker"),
  TI_COLOR_PICKER_OFF("ti-color-picker-off"),
  TI_COLOR_SWATCH("ti-color-swatch"),
  TI_COLOR_SWATCH_OFF("ti-color-swatch-off"),
  TI_COLUMN_INSERT_LEFT("ti-column-insert-left"),
  TI_COLUMN_INSERT_RIGHT("ti-column-insert-right"),
  TI_COLUMN_REMOVE("ti-column-remove"),
  TI_COLUMNS("ti-columns"),
  TI_COLUMNS_1("ti-columns-1"),
  TI_COLUMNS_2("ti-columns-2"),
  TI_COLUMNS_3("ti-columns-3"),
  TI_COLUMNS_OFF("ti-columns-off"),
  TI_COMET("ti-comet"),
  TI_COMMAND("ti-command"),
  TI_COMMAND_OFF("ti-command-off"),
  TI_COMPASS("ti-compass"),
  TI_COMPASS_OFF("ti-compass-off"),
  TI_COMPONENTS("ti-components"),
  TI_COMPONENTS_OFF("ti-components-off"),
  TI_CONE("ti-cone"),
  TI_CONE_2("ti-cone-2"),
  TI_CONE_OFF("ti-cone-off"),
  TI_CONE_PLUS("ti-cone-plus"),
  TI_CONFETTI("ti-confetti"),
  TI_CONFETTI_OFF("ti-confetti-off"),
  TI_CONFUCIUS("ti-confucius"),
  TI_CONGRUENT_TO("ti-congruent-to"),
  TI_CONNECTION("ti-connection"),
  TI_CONTAINER("ti-container"),
  TI_CONTAINER_OFF("ti-container-off"),
  TI_CONTRACT("ti-contract"),
  TI_CONTRAST("ti-contrast"),
  TI_CONTRAST_2("ti-contrast-2"),
  TI_CONTRAST_2_OFF("ti-contrast-2-off"),
  TI_CONTRAST_OFF("ti-contrast-off"),
  TI_COOKER("ti-cooker"),
  TI_COOKIE("ti-cookie"),
  TI_COOKIE_MAN("ti-cookie-man"),
  TI_COOKIE_OFF("ti-cookie-off"),
  TI_COPY("ti-copy"),
  TI_COPY_CHECK("ti-copy-check"),
  TI_COPY_MINUS("ti-copy-minus"),
  TI_COPY_OFF("ti-copy-off"),
  TI_COPY_PLUS("ti-copy-plus"),
  TI_COPY_X("ti-copy-x"),
  TI_COPYLEFT("ti-copyleft"),
  TI_COPYLEFT_OFF("ti-copyleft-off"),
  TI_COPYRIGHT("ti-copyright"),
  TI_COPYRIGHT_OFF("ti-copyright-off"),
  TI_CORNER_DOWN_LEFT("ti-corner-down-left"),
  TI_CORNER_DOWN_LEFT_DOUBLE("ti-corner-down-left-double"),
  TI_CORNER_DOWN_RIGHT("ti-corner-down-right"),
  TI_CORNER_DOWN_RIGHT_DOUBLE("ti-corner-down-right-double"),
  TI_CORNER_LEFT_DOWN("ti-corner-left-down"),
  TI_CORNER_LEFT_DOWN_DOUBLE("ti-corner-left-down-double"),
  TI_CORNER_LEFT_UP("ti-corner-left-up"),
  TI_CORNER_LEFT_UP_DOUBLE("ti-corner-left-up-double"),
  TI_CORNER_RIGHT_DOWN("ti-corner-right-down"),
  TI_CORNER_RIGHT_DOWN_DOUBLE("ti-corner-right-down-double"),
  TI_CORNER_RIGHT_UP("ti-corner-right-up"),
  TI_CORNER_RIGHT_UP_DOUBLE("ti-corner-right-up-double"),
  TI_CORNER_UP_LEFT("ti-corner-up-left"),
  TI_CORNER_UP_LEFT_DOUBLE("ti-corner-up-left-double"),
  TI_CORNER_UP_RIGHT("ti-corner-up-right"),
  TI_CORNER_UP_RIGHT_DOUBLE("ti-corner-up-right-double"),
  TI_CPU("ti-cpu"),
  TI_CPU_2("ti-cpu-2"),
  TI_CPU_OFF("ti-cpu-off"),
  TI_CRANE("ti-crane"),
  TI_CRANE_OFF("ti-crane-off"),
  TI_CREATIVE_COMMONS("ti-creative-commons"),
  TI_CREATIVE_COMMONS_BY("ti-creative-commons-by"),
  TI_CREATIVE_COMMONS_NC("ti-creative-commons-nc"),
  TI_CREATIVE_COMMONS_ND("ti-creative-commons-nd"),
  TI_CREATIVE_COMMONS_OFF("ti-creative-commons-off"),
  TI_CREATIVE_COMMONS_SA("ti-creative-commons-sa"),
  TI_CREATIVE_COMMONS_ZERO("ti-creative-commons-zero"),
  TI_CREDIT_CARD("ti-credit-card"),
  TI_CREDIT_CARD_HAND("ti-credit-card-hand"),
  TI_CREDIT_CARD_OFF("ti-credit-card-off"),
  TI_CREDIT_CARD_PAY("ti-credit-card-pay"),
  TI_CREDIT_CARD_REFUND("ti-credit-card-refund"),
  TI_CREDITS("ti-credits"),
  TI_CRICKET("ti-cricket"),
  TI_CROP("ti-crop"),
  TI_CROP_1_1("ti-crop-1-1"),
  TI_CROP_16_9("ti-crop-16-9"),
  TI_CROP_3_2("ti-crop-3-2"),
  TI_CROP_5_4("ti-crop-5-4"),
  TI_CROP_7_5("ti-crop-7-5"),
  TI_CROP_LANDSCAPE("ti-crop-landscape"),
  TI_CROP_PORTRAIT("ti-crop-portrait"),
  TI_CROSS("ti-cross"),
  TI_CROSS_OFF("ti-cross-off"),
  TI_CROSSHAIR("ti-crosshair"),
  TI_CROWN("ti-crown"),
  TI_CROWN_OFF("ti-crown-off"),
  TI_CRUTCHES("ti-crutches"),
  TI_CRUTCHES_OFF("ti-crutches-off"),
  TI_CRYSTAL_BALL("ti-crystal-ball"),
  TI_CSV("ti-csv"),
  TI_CUBE("ti-cube"),
  TI_CUBE_3D_SPHERE("ti-cube-3d-sphere"),
  TI_CUBE_3D_SPHERE_OFF("ti-cube-3d-sphere-off"),
  TI_CUBE_OFF("ti-cube-off"),
  TI_CUBE_PLUS("ti-cube-plus"),
  TI_CUBE_SEND("ti-cube-send"),
  TI_CUBE_SPARK("ti-cube-spark"),
  TI_CUBE_UNFOLDED("ti-cube-unfolded"),
  TI_CUP("ti-cup"),
  TI_CUP_OFF("ti-cup-off"),
  TI_CURLING("ti-curling"),
  TI_CURLY_LOOP("ti-curly-loop"),
  TI_CURRENCY("ti-currency"),
  TI_CURRENCY_AFGHANI("ti-currency-afghani"),
  TI_CURRENCY_BAHRAINI("ti-currency-bahraini"),
  TI_CURRENCY_BAHT("ti-currency-baht"),
  TI_CURRENCY_BITCOIN("ti-currency-bitcoin"),
  TI_CURRENCY_CENT("ti-currency-cent"),
  TI_CURRENCY_DINAR("ti-currency-dinar"),
  TI_CURRENCY_DIRHAM("ti-currency-dirham"),
  TI_CURRENCY_DOGECOIN("ti-currency-dogecoin"),
  TI_CURRENCY_DOLLAR("ti-currency-dollar"),
  TI_CURRENCY_DOLLAR_AUSTRALIAN("ti-currency-dollar-australian"),
  TI_CURRENCY_DOLLAR_BRUNEI("ti-currency-dollar-brunei"),
  TI_CURRENCY_DOLLAR_CANADIAN("ti-currency-dollar-canadian"),
  TI_CURRENCY_DOLLAR_GUYANESE("ti-currency-dollar-guyanese"),
  TI_CURRENCY_DOLLAR_OFF("ti-currency-dollar-off"),
  TI_CURRENCY_DOLLAR_SINGAPORE("ti-currency-dollar-singapore"),
  TI_CURRENCY_DOLLAR_ZIMBABWEAN("ti-currency-dollar-zimbabwean"),
  TI_CURRENCY_DONG("ti-currency-dong"),
  TI_CURRENCY_DRAM("ti-currency-dram"),
  TI_CURRENCY_ETHEREUM("ti-currency-ethereum"),
  TI_CURRENCY_EURO("ti-currency-euro"),
  TI_CURRENCY_EURO_OFF("ti-currency-euro-off"),
  TI_CURRENCY_FLORIN("ti-currency-florin"),
  TI_CURRENCY_FORINT("ti-currency-forint"),
  TI_CURRENCY_FRANK("ti-currency-frank"),
  TI_CURRENCY_GUARANI("ti-currency-guarani"),
  TI_CURRENCY_HRYVNIA("ti-currency-hryvnia"),
  TI_CURRENCY_HUSD("ti-currency-husd"),
  TI_CURRENCY_IRANIAN_RIAL("ti-currency-iranian-rial"),
  TI_CURRENCY_KIP("ti-currency-kip"),
  TI_CURRENCY_KRONE_CZECH("ti-currency-krone-czech"),
  TI_CURRENCY_KRONE_DANISH("ti-currency-krone-danish"),
  TI_CURRENCY_KRONE_SWEDISH("ti-currency-krone-swedish"),
  TI_CURRENCY_LARI("ti-currency-lari"),
  TI_CURRENCY_LEU("ti-currency-leu"),
  TI_CURRENCY_LIRA("ti-currency-lira"),
  TI_CURRENCY_LITECOIN("ti-currency-litecoin"),
  TI_CURRENCY_LYD("ti-currency-lyd"),
  TI_CURRENCY_MANAT("ti-currency-manat"),
  TI_CURRENCY_MONERO("ti-currency-monero"),
  TI_CURRENCY_NAIRA("ti-currency-naira"),
  TI_CURRENCY_NANO("ti-currency-nano"),
  TI_CURRENCY_OFF("ti-currency-off"),
  TI_CURRENCY_PAANGA("ti-currency-paanga"),
  TI_CURRENCY_PESO("ti-currency-peso"),
  TI_CURRENCY_POUND("ti-currency-pound"),
  TI_CURRENCY_POUND_OFF("ti-currency-pound-off"),
  TI_CURRENCY_QUETZAL("ti-currency-quetzal"),
  TI_CURRENCY_REAL("ti-currency-real"),
  TI_CURRENCY_RENMINBI("ti-currency-renminbi"),
  TI_CURRENCY_RIPPLE("ti-currency-ripple"),
  TI_CURRENCY_RIYAL("ti-currency-riyal"),
  TI_CURRENCY_RUBEL("ti-currency-rubel"),
  TI_CURRENCY_RUBLE("ti-currency-ruble"),
  TI_CURRENCY_RUFIYAA("ti-currency-rufiyaa"),
  TI_CURRENCY_RUPEE("ti-currency-rupee"),
  TI_CURRENCY_RUPEE_NEPALESE("ti-currency-rupee-nepalese"),
  TI_CURRENCY_SHEKEL("ti-currency-shekel"),
  TI_CURRENCY_SOLANA("ti-currency-solana"),
  TI_CURRENCY_SOM("ti-currency-som"),
  TI_CURRENCY_TAKA("ti-currency-taka"),
  TI_CURRENCY_TENGE("ti-currency-tenge"),
  TI_CURRENCY_TETHER("ti-currency-tether"),
  TI_CURRENCY_TUGRIK("ti-currency-tugrik"),
  TI_CURRENCY_WON("ti-currency-won"),
  TI_CURRENCY_XRP("ti-currency-xrp"),
  TI_CURRENCY_YEN("ti-currency-yen"),
  TI_CURRENCY_YEN_OFF("ti-currency-yen-off"),
  TI_CURRENCY_YUAN("ti-currency-yuan"),
  TI_CURRENCY_ZCASH("ti-currency-zcash"),
  TI_CURRENCY_ZLOTY("ti-currency-zloty"),
  TI_CURRENT_LOCATION("ti-current-location"),
  TI_CURRENT_LOCATION_OFF("ti-current-location-off"),
  TI_CURSOR_OFF("ti-cursor-off"),
  TI_CURSOR_TEXT("ti-cursor-text"),
  TI_CUT("ti-cut"),
  TI_CYLINDER("ti-cylinder"),
  TI_CYLINDER_OFF("ti-cylinder-off"),
  TI_CYLINDER_PLUS("ti-cylinder-plus"),
  TI_DASHBOARD("ti-dashboard"),
  TI_DASHBOARD_OFF("ti-dashboard-off"),
  TI_DATABASE("ti-database"),
  TI_DATABASE_COG("ti-database-cog"),
  TI_DATABASE_DOLLAR("ti-database-dollar"),
  TI_DATABASE_EDIT("ti-database-edit"),
  TI_DATABASE_EXCLAMATION("ti-database-exclamation"),
  TI_DATABASE_EXPORT("ti-database-export"),
  TI_DATABASE_HEART("ti-database-heart"),
  TI_DATABASE_IMPORT("ti-database-import"),
  TI_DATABASE_LEAK("ti-database-leak"),
  TI_DATABASE_MINUS("ti-database-minus"),
  TI_DATABASE_OFF("ti-database-off"),
  TI_DATABASE_PLUS("ti-database-plus"),
  TI_DATABASE_SEARCH("ti-database-search"),
  TI_DATABASE_SHARE("ti-database-share"),
  TI_DATABASE_SMILE("ti-database-smile"),
  TI_DATABASE_STAR("ti-database-star"),
  TI_DATABASE_X("ti-database-x"),
  TI_DEAF("ti-deaf"),
  TI_DECIMAL("ti-decimal"),
  TI_DEER("ti-deer"),
  TI_DELTA("ti-delta"),
  TI_DENTAL("ti-dental"),
  TI_DENTAL_BROKEN("ti-dental-broken"),
  TI_DENTAL_OFF("ti-dental-off"),
  TI_DESELECT("ti-deselect"),
  TI_DESK("ti-desk"),
  TI_DETAILS("ti-details"),
  TI_DETAILS_OFF("ti-details-off"),
  TI_DEVICE_3D_CAMERA("ti-device-3d-camera"),
  TI_DEVICE_3D_LENS("ti-device-3d-lens"),
  TI_DEVICE_AIRPODS("ti-device-airpods"),
  TI_DEVICE_AIRPODS_CASE("ti-device-airpods-case"),
  TI_DEVICE_AIRTAG("ti-device-airtag"),
  TI_DEVICE_ANALYTICS("ti-device-analytics"),
  TI_DEVICE_AUDIO_TAPE("ti-device-audio-tape"),
  TI_DEVICE_CAMERA_PHONE("ti-device-camera-phone"),
  TI_DEVICE_CCTV("ti-device-cctv"),
  TI_DEVICE_CCTV_OFF("ti-device-cctv-off"),
  TI_DEVICE_COMPUTER_CAMERA("ti-device-computer-camera"),
  TI_DEVICE_COMPUTER_CAMERA_2("ti-device-computer-camera-2"),
  TI_DEVICE_COMPUTER_CAMERA_OFF("ti-device-computer-camera-off"),
  TI_DEVICE_DESKTOP("ti-device-desktop"),
  TI_DEVICE_DESKTOP_ANALYTICS("ti-device-desktop-analytics"),
  TI_DEVICE_DESKTOP_BOLT("ti-device-desktop-bolt"),
  TI_DEVICE_DESKTOP_CANCEL("ti-device-desktop-cancel"),
  TI_DEVICE_DESKTOP_CHECK("ti-device-desktop-check"),
  TI_DEVICE_DESKTOP_CODE("ti-device-desktop-code"),
  TI_DEVICE_DESKTOP_COG("ti-device-desktop-cog"),
  TI_DEVICE_DESKTOP_DOLLAR("ti-device-desktop-dollar"),
  TI_DEVICE_DESKTOP_DOWN("ti-device-desktop-down"),
  TI_DEVICE_DESKTOP_EXCLAMATION("ti-device-desktop-exclamation"),
  TI_DEVICE_DESKTOP_HEART("ti-device-desktop-heart"),
  TI_DEVICE_DESKTOP_MINUS("ti-device-desktop-minus"),
  TI_DEVICE_DESKTOP_OFF("ti-device-desktop-off"),
  TI_DEVICE_DESKTOP_PAUSE("ti-device-desktop-pause"),
  TI_DEVICE_DESKTOP_PIN("ti-device-desktop-pin"),
  TI_DEVICE_DESKTOP_PLUS("ti-device-desktop-plus"),
  TI_DEVICE_DESKTOP_QUESTION("ti-device-desktop-question"),
  TI_DEVICE_DESKTOP_SEARCH("ti-device-desktop-search"),
  TI_DEVICE_DESKTOP_SHARE("ti-device-desktop-share"),
  TI_DEVICE_DESKTOP_STAR("ti-device-desktop-star"),
  TI_DEVICE_DESKTOP_UP("ti-device-desktop-up"),
  TI_DEVICE_DESKTOP_X("ti-device-desktop-x"),
  TI_DEVICE_FLOPPY("ti-device-floppy"),
  TI_DEVICE_GAMEPAD("ti-device-gamepad"),
  TI_DEVICE_GAMEPAD_2("ti-device-gamepad-2"),
  TI_DEVICE_GAMEPAD_3("ti-device-gamepad-3"),
  TI_DEVICE_HEART_MONITOR("ti-device-heart-monitor"),
  TI_DEVICE_IMAC("ti-device-imac"),
  TI_DEVICE_IMAC_BOLT("ti-device-imac-bolt"),
  TI_DEVICE_IMAC_CANCEL("ti-device-imac-cancel"),
  TI_DEVICE_IMAC_CHECK("ti-device-imac-check"),
  TI_DEVICE_IMAC_CODE("ti-device-imac-code"),
  TI_DEVICE_IMAC_COG("ti-device-imac-cog"),
  TI_DEVICE_IMAC_DOLLAR("ti-device-imac-dollar"),
  TI_DEVICE_IMAC_DOWN("ti-device-imac-down"),
  TI_DEVICE_IMAC_EXCLAMATION("ti-device-imac-exclamation"),
  TI_DEVICE_IMAC_HEART("ti-device-imac-heart"),
  TI_DEVICE_IMAC_MINUS("ti-device-imac-minus"),
  TI_DEVICE_IMAC_OFF("ti-device-imac-off"),
  TI_DEVICE_IMAC_PAUSE("ti-device-imac-pause"),
  TI_DEVICE_IMAC_PIN("ti-device-imac-pin"),
  TI_DEVICE_IMAC_PLUS("ti-device-imac-plus"),
  TI_DEVICE_IMAC_QUESTION("ti-device-imac-question"),
  TI_DEVICE_IMAC_SEARCH("ti-device-imac-search"),
  TI_DEVICE_IMAC_SHARE("ti-device-imac-share"),
  TI_DEVICE_IMAC_STAR("ti-device-imac-star"),
  TI_DEVICE_IMAC_UP("ti-device-imac-up"),
  TI_DEVICE_IMAC_X("ti-device-imac-x"),
  TI_DEVICE_IPAD("ti-device-ipad"),
  TI_DEVICE_IPAD_BOLT("ti-device-ipad-bolt"),
  TI_DEVICE_IPAD_CANCEL("ti-device-ipad-cancel"),
  TI_DEVICE_IPAD_CHECK("ti-device-ipad-check"),
  TI_DEVICE_IPAD_CODE("ti-device-ipad-code"),
  TI_DEVICE_IPAD_COG("ti-device-ipad-cog"),
  TI_DEVICE_IPAD_DOLLAR("ti-device-ipad-dollar"),
  TI_DEVICE_IPAD_DOWN("ti-device-ipad-down"),
  TI_DEVICE_IPAD_EXCLAMATION("ti-device-ipad-exclamation"),
  TI_DEVICE_IPAD_HEART("ti-device-ipad-heart"),
  TI_DEVICE_IPAD_HORIZONTAL("ti-device-ipad-horizontal"),
  TI_DEVICE_IPAD_HORIZONTAL_BOLT("ti-device-ipad-horizontal-bolt"),
  TI_DEVICE_IPAD_HORIZONTAL_CANCEL("ti-device-ipad-horizontal-cancel"),
  TI_DEVICE_IPAD_HORIZONTAL_CHECK("ti-device-ipad-horizontal-check"),
  TI_DEVICE_IPAD_HORIZONTAL_CODE("ti-device-ipad-horizontal-code"),
  TI_DEVICE_IPAD_HORIZONTAL_COG("ti-device-ipad-horizontal-cog"),
  TI_DEVICE_IPAD_HORIZONTAL_DOLLAR("ti-device-ipad-horizontal-dollar"),
  TI_DEVICE_IPAD_HORIZONTAL_DOWN("ti-device-ipad-horizontal-down"),
  TI_DEVICE_IPAD_HORIZONTAL_EXCLAMATION("ti-device-ipad-horizontal-exclamation"),
  TI_DEVICE_IPAD_HORIZONTAL_HEART("ti-device-ipad-horizontal-heart"),
  TI_DEVICE_IPAD_HORIZONTAL_MINUS("ti-device-ipad-horizontal-minus"),
  TI_DEVICE_IPAD_HORIZONTAL_OFF("ti-device-ipad-horizontal-off"),
  TI_DEVICE_IPAD_HORIZONTAL_PAUSE("ti-device-ipad-horizontal-pause"),
  TI_DEVICE_IPAD_HORIZONTAL_PIN("ti-device-ipad-horizontal-pin"),
  TI_DEVICE_IPAD_HORIZONTAL_PLUS("ti-device-ipad-horizontal-plus"),
  TI_DEVICE_IPAD_HORIZONTAL_QUESTION("ti-device-ipad-horizontal-question"),
  TI_DEVICE_IPAD_HORIZONTAL_SEARCH("ti-device-ipad-horizontal-search"),
  TI_DEVICE_IPAD_HORIZONTAL_SHARE("ti-device-ipad-horizontal-share"),
  TI_DEVICE_IPAD_HORIZONTAL_STAR("ti-device-ipad-horizontal-star"),
  TI_DEVICE_IPAD_HORIZONTAL_UP("ti-device-ipad-horizontal-up"),
  TI_DEVICE_IPAD_HORIZONTAL_X("ti-device-ipad-horizontal-x"),
  TI_DEVICE_IPAD_MINUS("ti-device-ipad-minus"),
  TI_DEVICE_IPAD_OFF("ti-device-ipad-off"),
  TI_DEVICE_IPAD_PAUSE("ti-device-ipad-pause"),
  TI_DEVICE_IPAD_PIN("ti-device-ipad-pin"),
  TI_DEVICE_IPAD_PLUS("ti-device-ipad-plus"),
  TI_DEVICE_IPAD_QUESTION("ti-device-ipad-question"),
  TI_DEVICE_IPAD_SEARCH("ti-device-ipad-search"),
  TI_DEVICE_IPAD_SHARE("ti-device-ipad-share"),
  TI_DEVICE_IPAD_STAR("ti-device-ipad-star"),
  TI_DEVICE_IPAD_UP("ti-device-ipad-up"),
  TI_DEVICE_IPAD_X("ti-device-ipad-x"),
  TI_DEVICE_LANDLINE_PHONE("ti-device-landline-phone"),
  TI_DEVICE_LAPTOP("ti-device-laptop"),
  TI_DEVICE_LAPTOP_OFF("ti-device-laptop-off"),
  TI_DEVICE_MOBILE("ti-device-mobile"),
  TI_DEVICE_MOBILE_BOLT("ti-device-mobile-bolt"),
  TI_DEVICE_MOBILE_CANCEL("ti-device-mobile-cancel"),
  TI_DEVICE_MOBILE_CHARGING("ti-device-mobile-charging"),
  TI_DEVICE_MOBILE_CHECK("ti-device-mobile-check"),
  TI_DEVICE_MOBILE_CODE("ti-device-mobile-code"),
  TI_DEVICE_MOBILE_COG("ti-device-mobile-cog"),
  TI_DEVICE_MOBILE_DOLLAR("ti-device-mobile-dollar"),
  TI_DEVICE_MOBILE_DOWN("ti-device-mobile-down"),
  TI_DEVICE_MOBILE_EXCLAMATION("ti-device-mobile-exclamation"),
  TI_DEVICE_MOBILE_HEART("ti-device-mobile-heart"),
  TI_DEVICE_MOBILE_MESSAGE("ti-device-mobile-message"),
  TI_DEVICE_MOBILE_MINUS("ti-device-mobile-minus"),
  TI_DEVICE_MOBILE_OFF("ti-device-mobile-off"),
  TI_DEVICE_MOBILE_PAUSE("ti-device-mobile-pause"),
  TI_DEVICE_MOBILE_PIN("ti-device-mobile-pin"),
  TI_DEVICE_MOBILE_PLUS("ti-device-mobile-plus"),
  TI_DEVICE_MOBILE_QUESTION("ti-device-mobile-question"),
  TI_DEVICE_MOBILE_ROTATED("ti-device-mobile-rotated"),
  TI_DEVICE_MOBILE_SEARCH("ti-device-mobile-search"),
  TI_DEVICE_MOBILE_SHARE("ti-device-mobile-share"),
  TI_DEVICE_MOBILE_STAR("ti-device-mobile-star"),
  TI_DEVICE_MOBILE_UP("ti-device-mobile-up"),
  TI_DEVICE_MOBILE_VIBRATION("ti-device-mobile-vibration"),
  TI_DEVICE_MOBILE_X("ti-device-mobile-x"),
  TI_DEVICE_NINTENDO("ti-device-nintendo"),
  TI_DEVICE_NINTENDO_OFF("ti-device-nintendo-off"),
  TI_DEVICE_PROJECTOR("ti-device-projector"),
  TI_DEVICE_REMOTE("ti-device-remote"),
  TI_DEVICE_SCREEN("ti-device-screen"),
  TI_DEVICE_SD_CARD("ti-device-sd-card"),
  TI_DEVICE_SIM("ti-device-sim"),
  TI_DEVICE_SIM_1("ti-device-sim-1"),
  TI_DEVICE_SIM_2("ti-device-sim-2"),
  TI_DEVICE_SIM_3("ti-device-sim-3"),
  TI_DEVICE_SPEAKER("ti-device-speaker"),
  TI_DEVICE_SPEAKER_OFF("ti-device-speaker-off"),
  TI_DEVICE_TABLET("ti-device-tablet"),
  TI_DEVICE_TABLET_BOLT("ti-device-tablet-bolt"),
  TI_DEVICE_TABLET_CANCEL("ti-device-tablet-cancel"),
  TI_DEVICE_TABLET_CHECK("ti-device-tablet-check"),
  TI_DEVICE_TABLET_CODE("ti-device-tablet-code"),
  TI_DEVICE_TABLET_COG("ti-device-tablet-cog"),
  TI_DEVICE_TABLET_DOLLAR("ti-device-tablet-dollar"),
  TI_DEVICE_TABLET_DOWN("ti-device-tablet-down"),
  TI_DEVICE_TABLET_EXCLAMATION("ti-device-tablet-exclamation"),
  TI_DEVICE_TABLET_HEART("ti-device-tablet-heart"),
  TI_DEVICE_TABLET_MINUS("ti-device-tablet-minus"),
  TI_DEVICE_TABLET_OFF("ti-device-tablet-off"),
  TI_DEVICE_TABLET_PAUSE("ti-device-tablet-pause"),
  TI_DEVICE_TABLET_PIN("ti-device-tablet-pin"),
  TI_DEVICE_TABLET_PLUS("ti-device-tablet-plus"),
  TI_DEVICE_TABLET_QUESTION("ti-device-tablet-question"),
  TI_DEVICE_TABLET_SEARCH("ti-device-tablet-search"),
  TI_DEVICE_TABLET_SHARE("ti-device-tablet-share"),
  TI_DEVICE_TABLET_STAR("ti-device-tablet-star"),
  TI_DEVICE_TABLET_UP("ti-device-tablet-up"),
  TI_DEVICE_TABLET_X("ti-device-tablet-x"),
  TI_DEVICE_TV("ti-device-tv"),
  TI_DEVICE_TV_OFF("ti-device-tv-off"),
  TI_DEVICE_TV_OLD("ti-device-tv-old"),
  TI_DEVICE_UNKNOWN("ti-device-unknown"),
  TI_DEVICE_USB("ti-device-usb"),
  TI_DEVICE_VISION_PRO("ti-device-vision-pro"),
  TI_DEVICE_VISION_PRO_WIFI("ti-device-vision-pro-wifi"),
  TI_DEVICE_WATCH("ti-device-watch"),
  TI_DEVICE_WATCH_BOLT("ti-device-watch-bolt"),
  TI_DEVICE_WATCH_CANCEL("ti-device-watch-cancel"),
  TI_DEVICE_WATCH_CHECK("ti-device-watch-check"),
  TI_DEVICE_WATCH_CODE("ti-device-watch-code"),
  TI_DEVICE_WATCH_COG("ti-device-watch-cog"),
  TI_DEVICE_WATCH_DOLLAR("ti-device-watch-dollar"),
  TI_DEVICE_WATCH_DOWN("ti-device-watch-down"),
  TI_DEVICE_WATCH_EXCLAMATION("ti-device-watch-exclamation"),
  TI_DEVICE_WATCH_HEART("ti-device-watch-heart"),
  TI_DEVICE_WATCH_MINUS("ti-device-watch-minus"),
  TI_DEVICE_WATCH_OFF("ti-device-watch-off"),
  TI_DEVICE_WATCH_PAUSE("ti-device-watch-pause"),
  TI_DEVICE_WATCH_PIN("ti-device-watch-pin"),
  TI_DEVICE_WATCH_PLUS("ti-device-watch-plus"),
  TI_DEVICE_WATCH_QUESTION("ti-device-watch-question"),
  TI_DEVICE_WATCH_SEARCH("ti-device-watch-search"),
  TI_DEVICE_WATCH_SHARE("ti-device-watch-share"),
  TI_DEVICE_WATCH_STAR("ti-device-watch-star"),
  TI_DEVICE_WATCH_STATS("ti-device-watch-stats"),
  TI_DEVICE_WATCH_STATS_2("ti-device-watch-stats-2"),
  TI_DEVICE_WATCH_UP("ti-device-watch-up"),
  TI_DEVICE_WATCH_X("ti-device-watch-x"),
  TI_DEVICE_WORKSTATION("ti-device-workstation"),
  TI_DEVICES("ti-devices"),
  TI_DEVICES_2("ti-devices-2"),
  TI_DEVICES_BOLT("ti-devices-bolt"),
  TI_DEVICES_CANCEL("ti-devices-cancel"),
  TI_DEVICES_CHECK("ti-devices-check"),
  TI_DEVICES_CODE("ti-devices-code"),
  TI_DEVICES_COG("ti-devices-cog"),
  TI_DEVICES_DOLLAR("ti-devices-dollar"),
  TI_DEVICES_DOWN("ti-devices-down"),
  TI_DEVICES_EXCLAMATION("ti-devices-exclamation"),
  TI_DEVICES_HEART("ti-devices-heart"),
  TI_DEVICES_MINUS("ti-devices-minus"),
  TI_DEVICES_OFF("ti-devices-off"),
  TI_DEVICES_PAUSE("ti-devices-pause"),
  TI_DEVICES_PC("ti-devices-pc"),
  TI_DEVICES_PC_OFF("ti-devices-pc-off"),
  TI_DEVICES_PIN("ti-devices-pin"),
  TI_DEVICES_PLUS("ti-devices-plus"),
  TI_DEVICES_QUESTION("ti-devices-question"),
  TI_DEVICES_SEARCH("ti-devices-search"),
  TI_DEVICES_SHARE("ti-devices-share"),
  TI_DEVICES_STAR("ti-devices-star"),
  TI_DEVICES_UP("ti-devices-up"),
  TI_DEVICES_X("ti-devices-x"),
  TI_DIABOLO("ti-diabolo"),
  TI_DIABOLO_OFF("ti-diabolo-off"),
  TI_DIABOLO_PLUS("ti-diabolo-plus"),
  TI_DIALPAD("ti-dialpad"),
  TI_DIALPAD_OFF("ti-dialpad-off"),
  TI_DIAMOND("ti-diamond"),
  TI_DIAMOND_OFF("ti-diamond-off"),
  TI_DIAMONDS("ti-diamonds"),
  TI_DIAPER("ti-diaper"),
  TI_DICE("ti-dice"),
  TI_DICE_1("ti-dice-1"),
  TI_DICE_2("ti-dice-2"),
  TI_DICE_3("ti-dice-3"),
  TI_DICE_4("ti-dice-4"),
  TI_DICE_5("ti-dice-5"),
  TI_DICE_6("ti-dice-6"),
  TI_DIMENSIONS("ti-dimensions"),
  TI_DIRECTION("ti-direction"),
  TI_DIRECTION_ARROWS("ti-direction-arrows"),
  TI_DIRECTION_HORIZONTAL("ti-direction-horizontal"),
  TI_DIRECTION_SIGN("ti-direction-sign"),
  TI_DIRECTION_SIGN_OFF("ti-direction-sign-off"),
  TI_DIRECTIONS("ti-directions"),
  TI_DIRECTIONS_OFF("ti-directions-off"),
  TI_DISABLED("ti-disabled"),
  TI_DISABLED_2("ti-disabled-2"),
  TI_DISABLED_OFF("ti-disabled-off"),
  TI_DISC("ti-disc"),
  TI_DISC_GOLF("ti-disc-golf"),
  TI_DISC_OFF("ti-disc-off"),
  TI_DISCOUNT("ti-discount"),
  TI_DISCOUNT_2("ti-discount-2"),
  TI_DISCOUNT_2_OFF("ti-discount-2-off"),
  TI_DISCOUNT_CHECK("ti-discount-check"),
  TI_DISCOUNT_OFF("ti-discount-off"),
  TI_DIVIDE("ti-divide"),
  TI_DNA("ti-dna"),
  TI_DNA_2("ti-dna-2"),
  TI_DNA_2_OFF("ti-dna-2-off"),
  TI_DNA_OFF("ti-dna-off"),
  TI_DOG("ti-dog"),
  TI_DOG_BOWL("ti-dog-bowl"),
  TI_DOOR("ti-door"),
  TI_DOOR_ENTER("ti-door-enter"),
  TI_DOOR_EXIT("ti-door-exit"),
  TI_DOOR_HANGER("ti-door-hanger"),
  TI_DOOR_OFF("ti-door-off"),
  TI_DOTS("ti-dots"),
  TI_DOTS_CIRCLE_HORIZONTAL("ti-dots-circle-horizontal"),
  TI_DOTS_DIAGONAL("ti-dots-diagonal"),
  TI_DOTS_DIAGONAL_2("ti-dots-diagonal-2"),
  TI_DOTS_VERTICAL("ti-dots-vertical"),
  TI_DOWNLOAD("ti-download"),
  TI_DOWNLOAD_OFF("ti-download-off"),
  TI_DRAG_DROP("ti-drag-drop"),
  TI_DRAG_DROP_2("ti-drag-drop-2"),
  TI_DRAGON("ti-dragon"),
  TI_DRONE("ti-drone"),
  TI_DRONE_OFF("ti-drone-off"),
  TI_DROP_CIRCLE("ti-drop-circle"),
  TI_DROPLET("ti-droplet"),
  TI_DROPLET_BOLT("ti-droplet-bolt"),
  TI_DROPLET_CANCEL("ti-droplet-cancel"),
  TI_DROPLET_CHECK("ti-droplet-check"),
  TI_DROPLET_CODE("ti-droplet-code"),
  TI_DROPLET_COG("ti-droplet-cog"),
  TI_DROPLET_DOLLAR("ti-droplet-dollar"),
  TI_DROPLET_DOWN("ti-droplet-down"),
  TI_DROPLET_EXCLAMATION("ti-droplet-exclamation"),
  TI_DROPLET_HALF("ti-droplet-half"),
  TI_DROPLET_HALF_2("ti-droplet-half-2"),
  TI_DROPLET_HEART("ti-droplet-heart"),
  TI_DROPLET_MINUS("ti-droplet-minus"),
  TI_DROPLET_OFF("ti-droplet-off"),
  TI_DROPLET_PAUSE("ti-droplet-pause"),
  TI_DROPLET_PIN("ti-droplet-pin"),
  TI_DROPLET_PLUS("ti-droplet-plus"),
  TI_DROPLET_QUESTION("ti-droplet-question"),
  TI_DROPLET_SEARCH("ti-droplet-search"),
  TI_DROPLET_SHARE("ti-droplet-share"),
  TI_DROPLET_STAR("ti-droplet-star"),
  TI_DROPLET_UP("ti-droplet-up"),
  TI_DROPLET_X("ti-droplet-x"),
  TI_DROPLETS("ti-droplets"),
  TI_DUAL_SCREEN("ti-dual-screen"),
  TI_DUMBBELL("ti-dumbbell"),
  TI_DUMPLING("ti-dumpling"),
  TI_E_PASSPORT("ti-e-passport"),
  TI_EAR("ti-ear"),
  TI_EAR_OFF("ti-ear-off"),
  TI_EAR_SCAN("ti-ear-scan"),
  TI_EARPHONE_BLUETOOTH("ti-earphone-bluetooth"),
  TI_EASE_IN("ti-ease-in"),
  TI_EASE_IN_CONTROL_POINT("ti-ease-in-control-point"),
  TI_EASE_IN_OUT("ti-ease-in-out"),
  TI_EASE_IN_OUT_CONTROL_POINTS("ti-ease-in-out-control-points"),
  TI_EASE_OUT("ti-ease-out"),
  TI_EASE_OUT_CONTROL_POINT("ti-ease-out-control-point"),
  TI_EDIT("ti-edit"),
  TI_EDIT_CIRCLE("ti-edit-circle"),
  TI_EDIT_CIRCLE_OFF("ti-edit-circle-off"),
  TI_EDIT_OFF("ti-edit-off"),
  TI_EGG("ti-egg"),
  TI_EGG_CRACKED("ti-egg-cracked"),
  TI_EGG_FRIED("ti-egg-fried"),
  TI_EGG_OFF("ti-egg-off"),
  TI_EGGS("ti-eggs"),
  TI_ELEVATOR("ti-elevator"),
  TI_ELEVATOR_OFF("ti-elevator-off"),
  TI_EMAIL_STAMP("ti-email-stamp"),
  TI_EMERGENCY_BED("ti-emergency-bed"),
  TI_EMPATHIZE("ti-empathize"),
  TI_EMPATHIZE_OFF("ti-empathize-off"),
  TI_EMPHASIS("ti-emphasis"),
  TI_ENGINE("ti-engine"),
  TI_ENGINE_OFF("ti-engine-off"),
  TI_EQUAL("ti-equal"),
  TI_EQUAL_DOUBLE("ti-equal-double"),
  TI_EQUAL_NOT("ti-equal-not"),
  TI_ERASER("ti-eraser"),
  TI_ERASER_OFF("ti-eraser-off"),
  TI_ERROR_404("ti-error-404"),
  TI_ERROR_404_OFF("ti-error-404-off"),
  TI_ESCALATOR("ti-escalator"),
  TI_ESCALATOR_DOWN("ti-escalator-down"),
  TI_ESCALATOR_UP("ti-escalator-up"),
  TI_EXCHANGE("ti-exchange"),
  TI_EXCHANGE_OFF("ti-exchange-off"),
  TI_EXCLAMATION_CIRCLE("ti-exclamation-circle"),
  TI_EXCLAMATION_MARK("ti-exclamation-mark"),
  TI_EXCLAMATION_MARK_OFF("ti-exclamation-mark-off"),
  TI_EXERCISE_BALL("ti-exercise-ball"),
  TI_EXPLICIT("ti-explicit"),
  TI_EXPLICIT_OFF("ti-explicit-off"),
  TI_EXPOSURE("ti-exposure"),
  TI_EXPOSURE_0("ti-exposure-0"),
  TI_EXPOSURE_MINUS_1("ti-exposure-minus-1"),
  TI_EXPOSURE_MINUS_2("ti-exposure-minus-2"),
  TI_EXPOSURE_OFF("ti-exposure-off"),
  TI_EXPOSURE_PLUS_1("ti-exposure-plus-1"),
  TI_EXPOSURE_PLUS_2("ti-exposure-plus-2"),
  TI_EXTERNAL_LINK("ti-external-link"),
  TI_EXTERNAL_LINK_OFF("ti-external-link-off"),
  TI_EYE("ti-eye"),
  TI_EYE_BITCOIN("ti-eye-bitcoin"),
  TI_EYE_BOLT("ti-eye-bolt"),
  TI_EYE_CANCEL("ti-eye-cancel"),
  TI_EYE_CHECK("ti-eye-check"),
  TI_EYE_CLOSED("ti-eye-closed"),
  TI_EYE_CODE("ti-eye-code"),
  TI_EYE_COG("ti-eye-cog"),
  TI_EYE_DISCOUNT("ti-eye-discount"),
  TI_EYE_DOLLAR("ti-eye-dollar"),
  TI_EYE_DOTTED("ti-eye-dotted"),
  TI_EYE_DOWN("ti-eye-down"),
  TI_EYE_EDIT("ti-eye-edit"),
  TI_EYE_EXCLAMATION("ti-eye-exclamation"),
  TI_EYE_HEART("ti-eye-heart"),
  TI_EYE_MINUS("ti-eye-minus"),
  TI_EYE_OFF("ti-eye-off"),
  TI_EYE_PAUSE("ti-eye-pause"),
  TI_EYE_PIN("ti-eye-pin"),
  TI_EYE_PLUS("ti-eye-plus"),
  TI_EYE_QUESTION("ti-eye-question"),
  TI_EYE_SEARCH("ti-eye-search"),
  TI_EYE_SHARE("ti-eye-share"),
  TI_EYE_SPARK("ti-eye-spark"),
  TI_EYE_STAR("ti-eye-star"),
  TI_EYE_TABLE("ti-eye-table"),
  TI_EYE_UP("ti-eye-up"),
  TI_EYE_X("ti-eye-x"),
  TI_EYEGLASS("ti-eyeglass"),
  TI_EYEGLASS_2("ti-eyeglass-2"),
  TI_EYEGLASS_OFF("ti-eyeglass-off"),
  TI_FACE_ID("ti-face-id"),
  TI_FACE_ID_ERROR("ti-face-id-error"),
  TI_FACE_MASK("ti-face-mask"),
  TI_FACE_MASK_OFF("ti-face-mask-off"),
  TI_FALL("ti-fall"),
  TI_FAVICON("ti-favicon"),
  TI_FEATHER("ti-feather"),
  TI_FEATHER_OFF("ti-feather-off"),
  TI_FENCE("ti-fence"),
  TI_FENCE_OFF("ti-fence-off"),
  TI_FERRY("ti-ferry"),
  TI_FIDGET_SPINNER("ti-fidget-spinner"),
  TI_FILE("ti-file"),
  TI_FILE_3D("ti-file-3d"),
  TI_FILE_AI("ti-file-ai"),
  TI_FILE_ALERT("ti-file-alert"),
  TI_FILE_ANALYTICS("ti-file-analytics"),
  TI_FILE_ARROW_LEFT("ti-file-arrow-left"),
  TI_FILE_ARROW_RIGHT("ti-file-arrow-right"),
  TI_FILE_BARCODE("ti-file-barcode"),
  TI_FILE_BITCOIN("ti-file-bitcoin"),
  TI_FILE_BROKEN("ti-file-broken"),
  TI_FILE_CERTIFICATE("ti-file-certificate"),
  TI_FILE_CHART("ti-file-chart"),
  TI_FILE_CHECK("ti-file-check"),
  TI_FILE_CODE("ti-file-code"),
  TI_FILE_CODE_2("ti-file-code-2"),
  TI_FILE_CV("ti-file-cv"),
  TI_FILE_DATABASE("ti-file-database"),
  TI_FILE_DELTA("ti-file-delta"),
  TI_FILE_DESCRIPTION("ti-file-description"),
  TI_FILE_DIFF("ti-file-diff"),
  TI_FILE_DIGIT("ti-file-digit"),
  TI_FILE_DISLIKE("ti-file-dislike"),
  TI_FILE_DOLLAR("ti-file-dollar"),
  TI_FILE_DOTS("ti-file-dots"),
  TI_FILE_DOWNLOAD("ti-file-download"),
  TI_FILE_EURO("ti-file-euro"),
  TI_FILE_EXCEL("ti-file-excel"),
  TI_FILE_EXPORT("ti-file-export"),
  TI_FILE_FUNCTION("ti-file-function"),
  TI_FILE_HORIZONTAL("ti-file-horizontal"),
  TI_FILE_IMPORT("ti-file-import"),
  TI_FILE_INFINITY("ti-file-infinity"),
  TI_FILE_INFO("ti-file-info"),
  TI_FILE_INVOICE("ti-file-invoice"),
  TI_FILE_ISR("ti-file-isr"),
  TI_FILE_LAMBDA("ti-file-lambda"),
  TI_FILE_LIKE("ti-file-like"),
  TI_FILE_MINUS("ti-file-minus"),
  TI_FILE_MUSIC("ti-file-music"),
  TI_FILE_NEUTRAL("ti-file-neutral"),
  TI_FILE_OFF("ti-file-off"),
  TI_FILE_ORIENTATION("ti-file-orientation"),
  TI_FILE_PENCIL("ti-file-pencil"),
  TI_FILE_PERCENT("ti-file-percent"),
  TI_FILE_PHONE("ti-file-phone"),
  TI_FILE_PLUS("ti-file-plus"),
  TI_FILE_POWER("ti-file-power"),
  TI_FILE_REPORT("ti-file-report"),
  TI_FILE_RSS("ti-file-rss"),
  TI_FILE_SAD("ti-file-sad"),
  TI_FILE_SCISSORS("ti-file-scissors"),
  TI_FILE_SEARCH("ti-file-search"),
  TI_FILE_SETTINGS("ti-file-settings"),
  TI_FILE_SHREDDER("ti-file-shredder"),
  TI_FILE_SIGNAL("ti-file-signal"),
  TI_FILE_SMILE("ti-file-smile"),
  TI_FILE_SPARK("ti-file-spark"),
  TI_FILE_SPREADSHEET("ti-file-spreadsheet"),
  TI_FILE_STACK("ti-file-stack"),
  TI_FILE_STAR("ti-file-star"),
  TI_FILE_SYMLINK("ti-file-symlink"),
  TI_FILE_TEXT("ti-file-text"),
  TI_FILE_TEXT_AI("ti-file-text-ai"),
  TI_FILE_TEXT_SHIELD("ti-file-text-shield"),
  TI_FILE_TEXT_SPARK("ti-file-text-spark"),
  TI_FILE_TIME("ti-file-time"),
  TI_FILE_TYPE_BMP("ti-file-type-bmp"),
  TI_FILE_TYPE_CSS("ti-file-type-css"),
  TI_FILE_TYPE_CSV("ti-file-type-csv"),
  TI_FILE_TYPE_DOC("ti-file-type-doc"),
  TI_FILE_TYPE_DOCX("ti-file-type-docx"),
  TI_FILE_TYPE_HTML("ti-file-type-html"),
  TI_FILE_TYPE_JPG("ti-file-type-jpg"),
  TI_FILE_TYPE_JS("ti-file-type-js"),
  TI_FILE_TYPE_JSX("ti-file-type-jsx"),
  TI_FILE_TYPE_PDF("ti-file-type-pdf"),
  TI_FILE_TYPE_PHP("ti-file-type-php"),
  TI_FILE_TYPE_PNG("ti-file-type-png"),
  TI_FILE_TYPE_PPT("ti-file-type-ppt"),
  TI_FILE_TYPE_RS("ti-file-type-rs"),
  TI_FILE_TYPE_SQL("ti-file-type-sql"),
  TI_FILE_TYPE_SVG("ti-file-type-svg"),
  TI_FILE_TYPE_TS("ti-file-type-ts"),
  TI_FILE_TYPE_TSX("ti-file-type-tsx"),
  TI_FILE_TYPE_TXT("ti-file-type-txt"),
  TI_FILE_TYPE_VUE("ti-file-type-vue"),
  TI_FILE_TYPE_XLS("ti-file-type-xls"),
  TI_FILE_TYPE_XML("ti-file-type-xml"),
  TI_FILE_TYPE_ZIP("ti-file-type-zip"),
  TI_FILE_TYPOGRAPHY("ti-file-typography"),
  TI_FILE_UNKNOWN("ti-file-unknown"),
  TI_FILE_UPLOAD("ti-file-upload"),
  TI_FILE_VECTOR("ti-file-vector"),
  TI_FILE_WORD("ti-file-word"),
  TI_FILE_X("ti-file-x"),
  TI_FILE_ZIP("ti-file-zip"),
  TI_FILES("ti-files"),
  TI_FILES_OFF("ti-files-off"),
  TI_FILTER("ti-filter"),
  TI_FILTER_2("ti-filter-2"),
  TI_FILTER_2_BOLT("ti-filter-2-bolt"),
  TI_FILTER_2_CANCEL("ti-filter-2-cancel"),
  TI_FILTER_2_CHECK("ti-filter-2-check"),
  TI_FILTER_2_CODE("ti-filter-2-code"),
  TI_FILTER_2_COG("ti-filter-2-cog"),
  TI_FILTER_2_DISCOUNT("ti-filter-2-discount"),
  TI_FILTER_2_DOLLAR("ti-filter-2-dollar"),
  TI_FILTER_2_DOWN("ti-filter-2-down"),
  TI_FILTER_2_EDIT("ti-filter-2-edit"),
  TI_FILTER_2_EXCLAMATION("ti-filter-2-exclamation"),
  TI_FILTER_2_MINUS("ti-filter-2-minus"),
  TI_FILTER_2_PAUSE("ti-filter-2-pause"),
  TI_FILTER_2_PIN("ti-filter-2-pin"),
  TI_FILTER_2_PLUS("ti-filter-2-plus"),
  TI_FILTER_2_QUESTION("ti-filter-2-question"),
  TI_FILTER_2_SEARCH("ti-filter-2-search"),
  TI_FILTER_2_SHARE("ti-filter-2-share"),
  TI_FILTER_2_SPARK("ti-filter-2-spark"),
  TI_FILTER_2_UP("ti-filter-2-up"),
  TI_FILTER_2_X("ti-filter-2-x"),
  TI_FILTER_BOLT("ti-filter-bolt"),
  TI_FILTER_CANCEL("ti-filter-cancel"),
  TI_FILTER_CHECK("ti-filter-check"),
  TI_FILTER_CODE("ti-filter-code"),
  TI_FILTER_COG("ti-filter-cog"),
  TI_FILTER_DISCOUNT("ti-filter-discount"),
  TI_FILTER_DOLLAR("ti-filter-dollar"),
  TI_FILTER_DOWN("ti-filter-down"),
  TI_FILTER_EDIT("ti-filter-edit"),
  TI_FILTER_EXCLAMATION("ti-filter-exclamation"),
  TI_FILTER_HEART("ti-filter-heart"),
  TI_FILTER_MINUS("ti-filter-minus"),
  TI_FILTER_OFF("ti-filter-off"),
  TI_FILTER_PAUSE("ti-filter-pause"),
  TI_FILTER_PIN("ti-filter-pin"),
  TI_FILTER_PLUS("ti-filter-plus"),
  TI_FILTER_QUESTION("ti-filter-question"),
  TI_FILTER_SEARCH("ti-filter-search"),
  TI_FILTER_SHARE("ti-filter-share"),
  TI_FILTER_SPARK("ti-filter-spark"),
  TI_FILTER_STAR("ti-filter-star"),
  TI_FILTER_UP("ti-filter-up"),
  TI_FILTER_X("ti-filter-x"),
  TI_FILTERS("ti-filters"),
  TI_FINGERPRINT("ti-fingerprint"),
  TI_FINGERPRINT_OFF("ti-fingerprint-off"),
  TI_FINGERPRINT_SCAN("ti-fingerprint-scan"),
  TI_FIRE_EXTINGUISHER("ti-fire-extinguisher"),
  TI_FIRE_HYDRANT("ti-fire-hydrant"),
  TI_FIRE_HYDRANT_OFF("ti-fire-hydrant-off"),
  TI_FIRETRUCK("ti-firetruck"),
  TI_FIREWALL_CHECK("ti-firewall-check"),
  TI_FIREWALL_FLAME("ti-firewall-flame"),
  TI_FIRST_AID_KIT("ti-first-aid-kit"),
  TI_FIRST_AID_KIT_OFF("ti-first-aid-kit-off"),
  TI_FISH("ti-fish"),
  TI_FISH_BONE("ti-fish-bone"),
  TI_FISH_CHRISTIANITY("ti-fish-christianity"),
  TI_FISH_HOOK("ti-fish-hook"),
  TI_FISH_HOOK_OFF("ti-fish-hook-off"),
  TI_FISH_OFF("ti-fish-off"),
  TI_FLAG("ti-flag"),
  TI_FLAG_2("ti-flag-2"),
  TI_FLAG_2_OFF("ti-flag-2-off"),
  TI_FLAG_3("ti-flag-3"),
  TI_FLAG_BITCOIN("ti-flag-bitcoin"),
  TI_FLAG_BOLT("ti-flag-bolt"),
  TI_FLAG_CANCEL("ti-flag-cancel"),
  TI_FLAG_CHECK("ti-flag-check"),
  TI_FLAG_CODE("ti-flag-code"),
  TI_FLAG_COG("ti-flag-cog"),
  TI_FLAG_DISCOUNT("ti-flag-discount"),
  TI_FLAG_DOLLAR("ti-flag-dollar"),
  TI_FLAG_DOWN("ti-flag-down"),
  TI_FLAG_EXCLAMATION("ti-flag-exclamation"),
  TI_FLAG_HEART("ti-flag-heart"),
  TI_FLAG_MINUS("ti-flag-minus"),
  TI_FLAG_OFF("ti-flag-off"),
  TI_FLAG_PAUSE("ti-flag-pause"),
  TI_FLAG_PIN("ti-flag-pin"),
  TI_FLAG_PLUS("ti-flag-plus"),
  TI_FLAG_QUESTION("ti-flag-question"),
  TI_FLAG_SEARCH("ti-flag-search"),
  TI_FLAG_SHARE("ti-flag-share"),
  TI_FLAG_SPARK("ti-flag-spark"),
  TI_FLAG_STAR("ti-flag-star"),
  TI_FLAG_UP("ti-flag-up"),
  TI_FLAG_X("ti-flag-x"),
  TI_FLAME("ti-flame"),
  TI_FLAME_OFF("ti-flame-off"),
  TI_FLARE("ti-flare"),
  TI_FLASK("ti-flask"),
  TI_FLASK_2("ti-flask-2"),
  TI_FLASK_2_OFF("ti-flask-2-off"),
  TI_FLASK_OFF("ti-flask-off"),
  TI_FLIP_FLOPS("ti-flip-flops"),
  TI_FLIP_HORIZONTAL("ti-flip-horizontal"),
  TI_FLIP_VERTICAL("ti-flip-vertical"),
  TI_FLOAT_CENTER("ti-float-center"),
  TI_FLOAT_LEFT("ti-float-left"),
  TI_FLOAT_NONE("ti-float-none"),
  TI_FLOAT_RIGHT("ti-float-right"),
  TI_FLOOD("ti-flood"),
  TI_FLOWER("ti-flower"),
  TI_FLOWER_OFF("ti-flower-off"),
  TI_FOCUS("ti-focus"),
  TI_FOCUS_2("ti-focus-2"),
  TI_FOCUS_AUTO("ti-focus-auto"),
  TI_FOCUS_CENTERED("ti-focus-centered"),
  TI_FOLD("ti-fold"),
  TI_FOLD_DOWN("ti-fold-down"),
  TI_FOLD_UP("ti-fold-up"),
  TI_FOLDER("ti-folder"),
  TI_FOLDER_BOLT("ti-folder-bolt"),
  TI_FOLDER_CANCEL("ti-folder-cancel"),
  TI_FOLDER_CHECK("ti-folder-check"),
  TI_FOLDER_CODE("ti-folder-code"),
  TI_FOLDER_COG("ti-folder-cog"),
  TI_FOLDER_DOLLAR("ti-folder-dollar"),
  TI_FOLDER_DOWN("ti-folder-down"),
  TI_FOLDER_EXCLAMATION("ti-folder-exclamation"),
  TI_FOLDER_HEART("ti-folder-heart"),
  TI_FOLDER_MINUS("ti-folder-minus"),
  TI_FOLDER_OFF("ti-folder-off"),
  TI_FOLDER_OPEN("ti-folder-open"),
  TI_FOLDER_PAUSE("ti-folder-pause"),
  TI_FOLDER_PIN("ti-folder-pin"),
  TI_FOLDER_PLUS("ti-folder-plus"),
  TI_FOLDER_QUESTION("ti-folder-question"),
  TI_FOLDER_ROOT("ti-folder-root"),
  TI_FOLDER_SEARCH("ti-folder-search"),
  TI_FOLDER_SHARE("ti-folder-share"),
  TI_FOLDER_STAR("ti-folder-star"),
  TI_FOLDER_SYMLINK("ti-folder-symlink"),
  TI_FOLDER_UP("ti-folder-up"),
  TI_FOLDER_X("ti-folder-x"),
  TI_FOLDERS("ti-folders"),
  TI_FOLDERS_OFF("ti-folders-off"),
  TI_FOODSTEPS("ti-foodsteps"),
  TI_FOOTSTEPS("ti-footsteps"),
  TI_FORBID("ti-forbid"),
  TI_FORBID_2("ti-forbid-2"),
  TI_FORKLIFT("ti-forklift"),
  TI_FORMS("ti-forms"),
  TI_FOUNTAIN("ti-fountain"),
  TI_FOUNTAIN_OFF("ti-fountain-off"),
  TI_FRAME("ti-frame"),
  TI_FRAME_OFF("ti-frame-off"),
  TI_FREE_RIGHTS("ti-free-rights"),
  TI_FREEZE_COLUMN("ti-freeze-column"),
  TI_FREEZE_ROW("ti-freeze-row"),
  TI_FREEZE_ROW_COLUMN("ti-freeze-row-column"),
  TI_FRIDGE("ti-fridge"),
  TI_FRIDGE_OFF("ti-fridge-off"),
  TI_FRIENDS("ti-friends"),
  TI_FRIENDS_OFF("ti-friends-off"),
  TI_FRUSTUM("ti-frustum"),
  TI_FRUSTUM_OFF("ti-frustum-off"),
  TI_FRUSTUM_PLUS("ti-frustum-plus"),
  TI_FUNCTION("ti-function"),
  TI_FUNCTION_OFF("ti-function-off"),
  TI_GALAXY("ti-galaxy"),
  TI_GARDEN_CART("ti-garden-cart"),
  TI_GARDEN_CART_OFF("ti-garden-cart-off"),
  TI_GAS_STATION("ti-gas-station"),
  TI_GAS_STATION_OFF("ti-gas-station-off"),
  TI_GAUGE("ti-gauge"),
  TI_GAUGE_OFF("ti-gauge-off"),
  TI_GAVEL("ti-gavel"),
  TI_GENDER_AGENDER("ti-gender-agender"),
  TI_GENDER_ANDROGYNE("ti-gender-androgyne"),
  TI_GENDER_BIGENDER("ti-gender-bigender"),
  TI_GENDER_DEMIBOY("ti-gender-demiboy"),
  TI_GENDER_DEMIGIRL("ti-gender-demigirl"),
  TI_GENDER_EPICENE("ti-gender-epicene"),
  TI_GENDER_FEMALE("ti-gender-female"),
  TI_GENDER_FEMME("ti-gender-femme"),
  TI_GENDER_GENDERFLUID("ti-gender-genderfluid"),
  TI_GENDER_GENDERLESS("ti-gender-genderless"),
  TI_GENDER_GENDERQUEER("ti-gender-genderqueer"),
  TI_GENDER_HERMAPHRODITE("ti-gender-hermaphrodite"),
  TI_GENDER_INTERGENDER("ti-gender-intergender"),
  TI_GENDER_MALE("ti-gender-male"),
  TI_GENDER_NEUTROIS("ti-gender-neutrois"),
  TI_GENDER_THIRD("ti-gender-third"),
  TI_GENDER_TRANSGENDER("ti-gender-transgender"),
  TI_GENDER_TRASVESTI("ti-gender-trasvesti"),
  TI_GENDER_TRAVESTI("ti-gender-travesti"),
  TI_GEOMETRY("ti-geometry"),
  TI_GHOST("ti-ghost"),
  TI_GHOST_2("ti-ghost-2"),
  TI_GHOST_3("ti-ghost-3"),
  TI_GHOST_OFF("ti-ghost-off"),
  TI_GIF("ti-gif"),
  TI_GIFT("ti-gift"),
  TI_GIFT_CARD("ti-gift-card"),
  TI_GIFT_OFF("ti-gift-off"),
  TI_GIT_BRANCH("ti-git-branch"),
  TI_GIT_BRANCH_DELETED("ti-git-branch-deleted"),
  TI_GIT_CHERRY_PICK("ti-git-cherry-pick"),
  TI_GIT_COMMIT("ti-git-commit"),
  TI_GIT_COMPARE("ti-git-compare"),
  TI_GIT_FORK("ti-git-fork"),
  TI_GIT_MERGE("ti-git-merge"),
  TI_GIT_PULL_REQUEST("ti-git-pull-request"),
  TI_GIT_PULL_REQUEST_CLOSED("ti-git-pull-request-closed"),
  TI_GIT_PULL_REQUEST_CONFLICT("ti-git-pull-request-conflict"),
  TI_GIT_PULL_REQUEST_DRAFT("ti-git-pull-request-draft"),
  TI_GIZMO("ti-gizmo"),
  TI_GLASS("ti-glass"),
  TI_GLASS_CHAMPAGNE("ti-glass-champagne"),
  TI_GLASS_COCKTAIL("ti-glass-cocktail"),
  TI_GLASS_FULL("ti-glass-full"),
  TI_GLASS_GIN("ti-glass-gin"),
  TI_GLASS_OFF("ti-glass-off"),
  TI_GLOBE("ti-globe"),
  TI_GLOBE_OFF("ti-globe-off"),
  TI_GO_GAME("ti-go-game"),
  TI_GOLF("ti-golf"),
  TI_GOLF_OFF("ti-golf-off"),
  TI_GPS("ti-gps"),
  TI_GRADIENTER("ti-gradienter"),
  TI_GRAIN("ti-grain"),
  TI_GRAPE("ti-grape"),
  TI_GRAPH("ti-graph"),
  TI_GRAPH_OFF("ti-graph-off"),
  TI_GRAVE("ti-grave"),
  TI_GRAVE_2("ti-grave-2"),
  TI_GRID_3X3("ti-grid-3x3"),
  TI_GRID_4X4("ti-grid-4x4"),
  TI_GRID_DOTS("ti-grid-dots"),
  TI_GRID_GOLDENRATIO("ti-grid-goldenratio"),
  TI_GRID_PATTERN("ti-grid-pattern"),
  TI_GRID_SCAN("ti-grid-scan"),
  TI_GRILL("ti-grill"),
  TI_GRILL_FORK("ti-grill-fork"),
  TI_GRILL_OFF("ti-grill-off"),
  TI_GRILL_SPATULA("ti-grill-spatula"),
  TI_GRIP_HORIZONTAL("ti-grip-horizontal"),
  TI_GRIP_VERTICAL("ti-grip-vertical"),
  TI_GROWTH("ti-growth"),
  TI_GUITAR_PICK("ti-guitar-pick"),
  TI_GYMNASTICS("ti-gymnastics"),
  TI_H_1("ti-h-1"),
  TI_H_2("ti-h-2"),
  TI_H_3("ti-h-3"),
  TI_H_4("ti-h-4"),
  TI_H_5("ti-h-5"),
  TI_H_6("ti-h-6"),
  TI_HAMMER("ti-hammer"),
  TI_HAMMER_DRILL("ti-hammer-drill"),
  TI_HAMMER_OFF("ti-hammer-off"),
  TI_HAND_CLICK("ti-hand-click"),
  TI_HAND_CLICK_OFF("ti-hand-click-off"),
  TI_HAND_FINGER("ti-hand-finger"),
  TI_HAND_FINGER_DOWN("ti-hand-finger-down"),
  TI_HAND_FINGER_LEFT("ti-hand-finger-left"),
  TI_HAND_FINGER_OFF("ti-hand-finger-off"),
  TI_HAND_FINGER_RIGHT("ti-hand-finger-right"),
  TI_HAND_GRAB("ti-hand-grab"),
  TI_HAND_LITTLE_FINGER("ti-hand-little-finger"),
  TI_HAND_LOVE_YOU("ti-hand-love-you"),
  TI_HAND_MIDDLE_FINGER("ti-hand-middle-finger"),
  TI_HAND_MOVE("ti-hand-move"),
  TI_HAND_OFF("ti-hand-off"),
  TI_HAND_RING_FINGER("ti-hand-ring-finger"),
  TI_HAND_ROCK("ti-hand-rock"),
  TI_HAND_SANITIZER("ti-hand-sanitizer"),
  TI_HAND_STOP("ti-hand-stop"),
  TI_HAND_THREE_FINGERS("ti-hand-three-fingers"),
  TI_HAND_TWO_FINGERS("ti-hand-two-fingers"),
  TI_HANGER("ti-hanger"),
  TI_HANGER_2("ti-hanger-2"),
  TI_HANGER_OFF("ti-hanger-off"),
  TI_HASH("ti-hash"),
  TI_HAZE("ti-haze"),
  TI_HAZE_MOON("ti-haze-moon"),
  TI_HDR("ti-hdr"),
  TI_HEADING("ti-heading"),
  TI_HEADING_OFF("ti-heading-off"),
  TI_HEADPHONES("ti-headphones"),
  TI_HEADPHONES_OFF("ti-headphones-off"),
  TI_HEADSET("ti-headset"),
  TI_HEADSET_OFF("ti-headset-off"),
  TI_HEALTH_RECOGNITION("ti-health-recognition"),
  TI_HEART("ti-heart"),
  TI_HEART_BITCOIN("ti-heart-bitcoin"),
  TI_HEART_BOLT("ti-heart-bolt"),
  TI_HEART_BROKEN("ti-heart-broken"),
  TI_HEART_CANCEL("ti-heart-cancel"),
  TI_HEART_CHECK("ti-heart-check"),
  TI_HEART_CODE("ti-heart-code"),
  TI_HEART_COG("ti-heart-cog"),
  TI_HEART_DISCOUNT("ti-heart-discount"),
  TI_HEART_DOLLAR("ti-heart-dollar"),
  TI_HEART_DOWN("ti-heart-down"),
  TI_HEART_EXCLAMATION("ti-heart-exclamation"),
  TI_HEART_HANDSHAKE("ti-heart-handshake"),
  TI_HEART_MINUS("ti-heart-minus"),
  TI_HEART_OFF("ti-heart-off"),
  TI_HEART_PAUSE("ti-heart-pause"),
  TI_HEART_PIN("ti-heart-pin"),
  TI_HEART_PLUS("ti-heart-plus"),
  TI_HEART_QUESTION("ti-heart-question"),
  TI_HEART_RATE_MONITOR("ti-heart-rate-monitor"),
  TI_HEART_SEARCH("ti-heart-search"),
  TI_HEART_SHARE("ti-heart-share"),
  TI_HEART_SPARK("ti-heart-spark"),
  TI_HEART_STAR("ti-heart-star"),
  TI_HEART_UP("ti-heart-up"),
  TI_HEART_X("ti-heart-x"),
  TI_HEARTBEAT("ti-heartbeat"),
  TI_HEARTS("ti-hearts"),
  TI_HEARTS_OFF("ti-hearts-off"),
  TI_HELICOPTER("ti-helicopter"),
  TI_HELICOPTER_LANDING("ti-helicopter-landing"),
  TI_HELMET("ti-helmet"),
  TI_HELMET_OFF("ti-helmet-off"),
  TI_HELP("ti-help"),
  TI_HELP_CIRCLE("ti-help-circle"),
  TI_HELP_HEXAGON("ti-help-hexagon"),
  TI_HELP_OCTAGON("ti-help-octagon"),
  TI_HELP_OFF("ti-help-off"),
  TI_HELP_SMALL("ti-help-small"),
  TI_HELP_SQUARE("ti-help-square"),
  TI_HELP_SQUARE_ROUNDED("ti-help-square-rounded"),
  TI_HELP_TRIANGLE("ti-help-triangle"),
  TI_HEMISPHERE("ti-hemisphere"),
  TI_HEMISPHERE_OFF("ti-hemisphere-off"),
  TI_HEMISPHERE_PLUS("ti-hemisphere-plus"),
  TI_HEXAGON("ti-hexagon"),
  TI_HEXAGON_0("ti-hexagon-0"),
  TI_HEXAGON_1("ti-hexagon-1"),
  TI_HEXAGON_2("ti-hexagon-2"),
  TI_HEXAGON_3("ti-hexagon-3"),
  TI_HEXAGON_3D("ti-hexagon-3d"),
  TI_HEXAGON_4("ti-hexagon-4"),
  TI_HEXAGON_5("ti-hexagon-5"),
  TI_HEXAGON_6("ti-hexagon-6"),
  TI_HEXAGON_7("ti-hexagon-7"),
  TI_HEXAGON_8("ti-hexagon-8"),
  TI_HEXAGON_9("ti-hexagon-9"),
  TI_HEXAGON_ASTERISK("ti-hexagon-asterisk"),
  TI_HEXAGON_LETTER_A("ti-hexagon-letter-a"),
  TI_HEXAGON_LETTER_B("ti-hexagon-letter-b"),
  TI_HEXAGON_LETTER_C("ti-hexagon-letter-c"),
  TI_HEXAGON_LETTER_D("ti-hexagon-letter-d"),
  TI_HEXAGON_LETTER_E("ti-hexagon-letter-e"),
  TI_HEXAGON_LETTER_F("ti-hexagon-letter-f"),
  TI_HEXAGON_LETTER_G("ti-hexagon-letter-g"),
  TI_HEXAGON_LETTER_H("ti-hexagon-letter-h"),
  TI_HEXAGON_LETTER_I("ti-hexagon-letter-i"),
  TI_HEXAGON_LETTER_J("ti-hexagon-letter-j"),
  TI_HEXAGON_LETTER_K("ti-hexagon-letter-k"),
  TI_HEXAGON_LETTER_L("ti-hexagon-letter-l"),
  TI_HEXAGON_LETTER_M("ti-hexagon-letter-m"),
  TI_HEXAGON_LETTER_N("ti-hexagon-letter-n"),
  TI_HEXAGON_LETTER_O("ti-hexagon-letter-o"),
  TI_HEXAGON_LETTER_P("ti-hexagon-letter-p"),
  TI_HEXAGON_LETTER_Q("ti-hexagon-letter-q"),
  TI_HEXAGON_LETTER_R("ti-hexagon-letter-r"),
  TI_HEXAGON_LETTER_S("ti-hexagon-letter-s"),
  TI_HEXAGON_LETTER_T("ti-hexagon-letter-t"),
  TI_HEXAGON_LETTER_U("ti-hexagon-letter-u"),
  TI_HEXAGON_LETTER_V("ti-hexagon-letter-v"),
  TI_HEXAGON_LETTER_W("ti-hexagon-letter-w"),
  TI_HEXAGON_LETTER_X("ti-hexagon-letter-x"),
  TI_HEXAGON_LETTER_Y("ti-hexagon-letter-y"),
  TI_HEXAGON_LETTER_Z("ti-hexagon-letter-z"),
  TI_HEXAGON_MINUS("ti-hexagon-minus"),
  TI_HEXAGON_MINUS_2("ti-hexagon-minus-2"),
  TI_HEXAGON_NUMBER_0("ti-hexagon-number-0"),
  TI_HEXAGON_NUMBER_1("ti-hexagon-number-1"),
  TI_HEXAGON_NUMBER_2("ti-hexagon-number-2"),
  TI_HEXAGON_NUMBER_3("ti-hexagon-number-3"),
  TI_HEXAGON_NUMBER_4("ti-hexagon-number-4"),
  TI_HEXAGON_NUMBER_5("ti-hexagon-number-5"),
  TI_HEXAGON_NUMBER_6("ti-hexagon-number-6"),
  TI_HEXAGON_NUMBER_7("ti-hexagon-number-7"),
  TI_HEXAGON_NUMBER_8("ti-hexagon-number-8"),
  TI_HEXAGON_NUMBER_9("ti-hexagon-number-9"),
  TI_HEXAGON_OFF("ti-hexagon-off"),
  TI_HEXAGON_PLUS("ti-hexagon-plus"),
  TI_HEXAGON_PLUS_2("ti-hexagon-plus-2"),
  TI_HEXAGONAL_PRISM("ti-hexagonal-prism"),
  TI_HEXAGONAL_PRISM_OFF("ti-hexagonal-prism-off"),
  TI_HEXAGONAL_PRISM_PLUS("ti-hexagonal-prism-plus"),
  TI_HEXAGONAL_PYRAMID("ti-hexagonal-pyramid"),
  TI_HEXAGONAL_PYRAMID_OFF("ti-hexagonal-pyramid-off"),
  TI_HEXAGONAL_PYRAMID_PLUS("ti-hexagonal-pyramid-plus"),
  TI_HEXAGONS("ti-hexagons"),
  TI_HEXAGONS_OFF("ti-hexagons-off"),
  TI_HIERARCHY("ti-hierarchy"),
  TI_HIERARCHY_2("ti-hierarchy-2"),
  TI_HIERARCHY_3("ti-hierarchy-3"),
  TI_HIERARCHY_OFF("ti-hierarchy-off"),
  TI_HIGHLIGHT("ti-highlight"),
  TI_HIGHLIGHT_OFF("ti-highlight-off"),
  TI_HISTORY("ti-history"),
  TI_HISTORY_OFF("ti-history-off"),
  TI_HISTORY_TOGGLE("ti-history-toggle"),
  TI_HOME("ti-home"),
  TI_HOME_2("ti-home-2"),
  TI_HOME_BITCOIN("ti-home-bitcoin"),
  TI_HOME_BOLT("ti-home-bolt"),
  TI_HOME_CANCEL("ti-home-cancel"),
  TI_HOME_CHECK("ti-home-check"),
  TI_HOME_COG("ti-home-cog"),
  TI_HOME_DOLLAR("ti-home-dollar"),
  TI_HOME_DOT("ti-home-dot"),
  TI_HOME_DOWN("ti-home-down"),
  TI_HOME_ECO("ti-home-eco"),
  TI_HOME_EDIT("ti-home-edit"),
  TI_HOME_EXCLAMATION("ti-home-exclamation"),
  TI_HOME_HAND("ti-home-hand"),
  TI_HOME_HEART("ti-home-heart"),
  TI_HOME_INFINITY("ti-home-infinity"),
  TI_HOME_LINK("ti-home-link"),
  TI_HOME_LOCK("ti-home-lock"),
  TI_HOME_MINUS("ti-home-minus"),
  TI_HOME_MOVE("ti-home-move"),
  TI_HOME_OFF("ti-home-off"),
  TI_HOME_PLUS("ti-home-plus"),
  TI_HOME_QUESTION("ti-home-question"),
  TI_HOME_RIBBON("ti-home-ribbon"),
  TI_HOME_SEARCH("ti-home-search"),
  TI_HOME_SHARE("ti-home-share"),
  TI_HOME_SHIELD("ti-home-shield"),
  TI_HOME_SIGNAL("ti-home-signal"),
  TI_HOME_SPARK("ti-home-spark"),
  TI_HOME_STAR("ti-home-star"),
  TI_HOME_STATS("ti-home-stats"),
  TI_HOME_UP("ti-home-up"),
  TI_HOME_X("ti-home-x"),
  TI_HORSE("ti-horse"),
  TI_HORSE_TOY("ti-horse-toy"),
  TI_HORSESHOE("ti-horseshoe"),
  TI_HOSPITAL("ti-hospital"),
  TI_HOSPITAL_CIRCLE("ti-hospital-circle"),
  TI_HOTEL_SERVICE("ti-hotel-service"),
  TI_HOURGLASS("ti-hourglass"),
  TI_HOURGLASS_EMPTY("ti-hourglass-empty"),
  TI_HOURGLASS_HIGH("ti-hourglass-high"),
  TI_HOURGLASS_LOW("ti-hourglass-low"),
  TI_HOURGLASS_OFF("ti-hourglass-off"),
  TI_HOURS_12("ti-hours-12"),
  TI_HOURS_24("ti-hours-24"),
  TI_HTML("ti-html"),
  TI_HTTP_CONNECT("ti-http-connect"),
  TI_HTTP_CONNECT_OFF("ti-http-connect-off"),
  TI_HTTP_DELETE("ti-http-delete"),
  TI_HTTP_DELETE_OFF("ti-http-delete-off"),
  TI_HTTP_GET("ti-http-get"),
  TI_HTTP_GET_OFF("ti-http-get-off"),
  TI_HTTP_HEAD("ti-http-head"),
  TI_HTTP_HEAD_OFF("ti-http-head-off"),
  TI_HTTP_OPTIONS("ti-http-options"),
  TI_HTTP_OPTIONS_OFF("ti-http-options-off"),
  TI_HTTP_PATCH("ti-http-patch"),
  TI_HTTP_PATCH_OFF("ti-http-patch-off"),
  TI_HTTP_POST("ti-http-post"),
  TI_HTTP_POST_OFF("ti-http-post-off"),
  TI_HTTP_PUT("ti-http-put"),
  TI_HTTP_PUT_OFF("ti-http-put-off"),
  TI_HTTP_QUE("ti-http-que"),
  TI_HTTP_QUE_OFF("ti-http-que-off"),
  TI_HTTP_TRACE("ti-http-trace"),
  TI_HTTP_TRACE_OFF("ti-http-trace-off"),
  TI_HULA_HOOP("ti-hula-hoop"),
  TI_ICE_CREAM("ti-ice-cream"),
  TI_ICE_CREAM_2("ti-ice-cream-2"),
  TI_ICE_CREAM_OFF("ti-ice-cream-off"),
  TI_ICE_SKATING("ti-ice-skating"),
  TI_ICEBERG("ti-iceberg"),
  TI_ICONS("ti-icons"),
  TI_ICONS_OFF("ti-icons-off"),
  TI_ICOSAHEDRON("ti-icosahedron"),
  TI_ID("ti-id"),
  TI_ID_BADGE("ti-id-badge"),
  TI_ID_BADGE_2("ti-id-badge-2"),
  TI_ID_BADGE_OFF("ti-id-badge-off"),
  TI_ID_OFF("ti-id-off"),
  TI_IKOSAEDR("ti-ikosaedr"),
  TI_IMAGE_GENERATION("ti-image-generation"),
  TI_IMAGE_IN_PICTURE("ti-image-in-picture"),
  TI_INBOX("ti-inbox"),
  TI_INBOX_OFF("ti-inbox-off"),
  TI_INDENT_DECREASE("ti-indent-decrease"),
  TI_INDENT_INCREASE("ti-indent-increase"),
  TI_INFINITY("ti-infinity"),
  TI_INFINITY_2("ti-infinity-2"),
  TI_INFINITY_OFF("ti-infinity-off"),
  TI_INFO_CIRCLE("ti-info-circle"),
  TI_INFO_HEXAGON("ti-info-hexagon"),
  TI_INFO_OCTAGON("ti-info-octagon"),
  TI_INFO_SMALL("ti-info-small"),
  TI_INFO_SQUARE("ti-info-square"),
  TI_INFO_SQUARE_ROUNDED("ti-info-square-rounded"),
  TI_INFO_TRIANGLE("ti-info-triangle"),
  TI_INNER_SHADOW_BOTTOM("ti-inner-shadow-bottom"),
  TI_INNER_SHADOW_BOTTOM_LEFT("ti-inner-shadow-bottom-left"),
  TI_INNER_SHADOW_BOTTOM_RIGHT("ti-inner-shadow-bottom-right"),
  TI_INNER_SHADOW_LEFT("ti-inner-shadow-left"),
  TI_INNER_SHADOW_RIGHT("ti-inner-shadow-right"),
  TI_INNER_SHADOW_TOP("ti-inner-shadow-top"),
  TI_INNER_SHADOW_TOP_LEFT("ti-inner-shadow-top-left"),
  TI_INNER_SHADOW_TOP_RIGHT("ti-inner-shadow-top-right"),
  TI_INPUT_AI("ti-input-ai"),
  TI_INPUT_CHECK("ti-input-check"),
  TI_INPUT_SEARCH("ti-input-search"),
  TI_INPUT_SPARK("ti-input-spark"),
  TI_INPUT_X("ti-input-x"),
  TI_INVOICE("ti-invoice"),
  TI_IRONING("ti-ironing"),
  TI_IRONING_1("ti-ironing-1"),
  TI_IRONING_2("ti-ironing-2"),
  TI_IRONING_3("ti-ironing-3"),
  TI_IRONING_OFF("ti-ironing-off"),
  TI_IRONING_STEAM("ti-ironing-steam"),
  TI_IRONING_STEAM_OFF("ti-ironing-steam-off"),
  TI_IRREGULAR_POLYHEDRON("ti-irregular-polyhedron"),
  TI_IRREGULAR_POLYHEDRON_OFF("ti-irregular-polyhedron-off"),
  TI_IRREGULAR_POLYHEDRON_PLUS("ti-irregular-polyhedron-plus"),
  TI_ITALIC("ti-italic"),
  TI_ITALIC_OFF("ti-italic-off"),
  TI_JACKET("ti-jacket"),
  TI_JETPACK("ti-jetpack"),
  TI_JETSKI("ti-jetski"),
  TI_JEWISH_STAR("ti-jewish-star"),
  TI_JOIN_BEVEL("ti-join-bevel"),
  TI_JOIN_ROUND("ti-join-round"),
  TI_JOIN_STRAIGHT("ti-join-straight"),
  TI_JOKER("ti-joker"),
  TI_JPG("ti-jpg"),
  TI_JSON("ti-json"),
  TI_JUMP_ROPE("ti-jump-rope"),
  TI_KARATE("ti-karate"),
  TI_KAYAK("ti-kayak"),
  TI_KERING("ti-kering"),
  TI_KERNING("ti-kerning"),
  TI_KEY("ti-key"),
  TI_KEY_OFF("ti-key-off"),
  TI_KEYBOARD("ti-keyboard"),
  TI_KEYBOARD_HIDE("ti-keyboard-hide"),
  TI_KEYBOARD_OFF("ti-keyboard-off"),
  TI_KEYBOARD_SHOW("ti-keyboard-show"),
  TI_KEYFRAME("ti-keyframe"),
  TI_KEYFRAME_ALIGN_CENTER("ti-keyframe-align-center"),
  TI_KEYFRAME_ALIGN_HORIZONTAL("ti-keyframe-align-horizontal"),
  TI_KEYFRAME_ALIGN_VERTICAL("ti-keyframe-align-vertical"),
  TI_KEYFRAMES("ti-keyframes"),
  TI_LABEL("ti-label"),
  TI_LABEL_IMPORTANT("ti-label-important"),
  TI_LABEL_OFF("ti-label-off"),
  TI_LADDER("ti-ladder"),
  TI_LADDER_OFF("ti-ladder-off"),
  TI_LADLE("ti-ladle"),
  TI_LAMBDA("ti-lambda"),
  TI_LAMP("ti-lamp"),
  TI_LAMP_2("ti-lamp-2"),
  TI_LAMP_OFF("ti-lamp-off"),
  TI_LANE("ti-lane"),
  TI_LANGUAGE("ti-language"),
  TI_LANGUAGE_HIRAGANA("ti-language-hiragana"),
  TI_LANGUAGE_KATAKANA("ti-language-katakana"),
  TI_LANGUAGE_OFF("ti-language-off"),
  TI_LASSO("ti-lasso"),
  TI_LASSO_OFF("ti-lasso-off"),
  TI_LASSO_POLYGON("ti-lasso-polygon"),
  TI_LAUREL_WREATH("ti-laurel-wreath"),
  TI_LAUREL_WREATH_1("ti-laurel-wreath-1"),
  TI_LAUREL_WREATH_2("ti-laurel-wreath-2"),
  TI_LAUREL_WREATH_3("ti-laurel-wreath-3"),
  TI_LAWN_MOWER("ti-lawn-mower"),
  TI_LAYERS_DIFFERENCE("ti-layers-difference"),
  TI_LAYERS_INTERSECT("ti-layers-intersect"),
  TI_LAYERS_INTERSECT_2("ti-layers-intersect-2"),
  TI_LAYERS_LINKED("ti-layers-linked"),
  TI_LAYERS_OFF("ti-layers-off"),
  TI_LAYERS_SELECTED("ti-layers-selected"),
  TI_LAYERS_SELECTED_BOTTOM("ti-layers-selected-bottom"),
  TI_LAYERS_SUBTRACT("ti-layers-subtract"),
  TI_LAYERS_UNION("ti-layers-union"),
  TI_LAYOUT("ti-layout"),
  TI_LAYOUT_2("ti-layout-2"),
  TI_LAYOUT_ALIGN_BOTTOM("ti-layout-align-bottom"),
  TI_LAYOUT_ALIGN_CENTER("ti-layout-align-center"),
  TI_LAYOUT_ALIGN_LEFT("ti-layout-align-left"),
  TI_LAYOUT_ALIGN_MIDDLE("ti-layout-align-middle"),
  TI_LAYOUT_ALIGN_RIGHT("ti-layout-align-right"),
  TI_LAYOUT_ALIGN_TOP("ti-layout-align-top"),
  TI_LAYOUT_BOARD("ti-layout-board"),
  TI_LAYOUT_BOARD_SPLIT("ti-layout-board-split"),
  TI_LAYOUT_BOTTOMBAR("ti-layout-bottombar"),
  TI_LAYOUT_BOTTOMBAR_COLLAPSE("ti-layout-bottombar-collapse"),
  TI_LAYOUT_BOTTOMBAR_EXPAND("ti-layout-bottombar-expand"),
  TI_LAYOUT_BOTTOMBAR_INACTIVE("ti-layout-bottombar-inactive"),
  TI_LAYOUT_CARDS("ti-layout-cards"),
  TI_LAYOUT_COLLAGE("ti-layout-collage"),
  TI_LAYOUT_COLUMNS("ti-layout-columns"),
  TI_LAYOUT_DASHBOARD("ti-layout-dashboard"),
  TI_LAYOUT_DISTRIBUTE_HORIZONTAL("ti-layout-distribute-horizontal"),
  TI_LAYOUT_DISTRIBUTE_VERTICAL("ti-layout-distribute-vertical"),
  TI_LAYOUT_GRID("ti-layout-grid"),
  TI_LAYOUT_GRID_ADD("ti-layout-grid-add"),
  TI_LAYOUT_GRID_REMOVE("ti-layout-grid-remove"),
  TI_LAYOUT_KANBAN("ti-layout-kanban"),
  TI_LAYOUT_LIST("ti-layout-list"),
  TI_LAYOUT_NAVBAR("ti-layout-navbar"),
  TI_LAYOUT_NAVBAR_COLLAPSE("ti-layout-navbar-collapse"),
  TI_LAYOUT_NAVBAR_EXPAND("ti-layout-navbar-expand"),
  TI_LAYOUT_NAVBAR_INACTIVE("ti-layout-navbar-inactive"),
  TI_LAYOUT_OFF("ti-layout-off"),
  TI_LAYOUT_ROWS("ti-layout-rows"),
  TI_LAYOUT_SIDEBAR("ti-layout-sidebar"),
  TI_LAYOUT_SIDEBAR_INACTIVE("ti-layout-sidebar-inactive"),
  TI_LAYOUT_SIDEBAR_LEFT_COLLAPSE("ti-layout-sidebar-left-collapse"),
  TI_LAYOUT_SIDEBAR_LEFT_EXPAND("ti-layout-sidebar-left-expand"),
  TI_LAYOUT_SIDEBAR_RIGHT("ti-layout-sidebar-right"),
  TI_LAYOUT_SIDEBAR_RIGHT_COLLAPSE("ti-layout-sidebar-right-collapse"),
  TI_LAYOUT_SIDEBAR_RIGHT_EXPAND("ti-layout-sidebar-right-expand"),
  TI_LAYOUT_SIDEBAR_RIGHT_INACTIVE("ti-layout-sidebar-right-inactive"),
  TI_LEAF("ti-leaf"),
  TI_LEAF_2("ti-leaf-2"),
  TI_LEAF_MAPLE("ti-leaf-maple"),
  TI_LEAF_OFF("ti-leaf-off"),
  TI_LEGO("ti-lego"),
  TI_LEGO_OFF("ti-lego-off"),
  TI_LEMON("ti-lemon"),
  TI_LEMON_2("ti-lemon-2"),
  TI_LETTER_A("ti-letter-a"),
  TI_LETTER_A_SMALL("ti-letter-a-small"),
  TI_LETTER_B("ti-letter-b"),
  TI_LETTER_B_SMALL("ti-letter-b-small"),
  TI_LETTER_C("ti-letter-c"),
  TI_LETTER_C_SMALL("ti-letter-c-small"),
  TI_LETTER_CASE("ti-letter-case"),
  TI_LETTER_CASE_LOWER("ti-letter-case-lower"),
  TI_LETTER_CASE_TOGGLE("ti-letter-case-toggle"),
  TI_LETTER_CASE_UPPER("ti-letter-case-upper"),
  TI_LETTER_D("ti-letter-d"),
  TI_LETTER_D_SMALL("ti-letter-d-small"),
  TI_LETTER_E("ti-letter-e"),
  TI_LETTER_E_SMALL("ti-letter-e-small"),
  TI_LETTER_F("ti-letter-f"),
  TI_LETTER_F_SMALL("ti-letter-f-small"),
  TI_LETTER_G("ti-letter-g"),
  TI_LETTER_G_SMALL("ti-letter-g-small"),
  TI_LETTER_H("ti-letter-h"),
  TI_LETTER_H_SMALL("ti-letter-h-small"),
  TI_LETTER_I("ti-letter-i"),
  TI_LETTER_I_SMALL("ti-letter-i-small"),
  TI_LETTER_J("ti-letter-j"),
  TI_LETTER_J_SMALL("ti-letter-j-small"),
  TI_LETTER_K("ti-letter-k"),
  TI_LETTER_K_SMALL("ti-letter-k-small"),
  TI_LETTER_L("ti-letter-l"),
  TI_LETTER_L_SMALL("ti-letter-l-small"),
  TI_LETTER_M("ti-letter-m"),
  TI_LETTER_M_SMALL("ti-letter-m-small"),
  TI_LETTER_N("ti-letter-n"),
  TI_LETTER_N_SMALL("ti-letter-n-small"),
  TI_LETTER_O("ti-letter-o"),
  TI_LETTER_O_SMALL("ti-letter-o-small"),
  TI_LETTER_P("ti-letter-p"),
  TI_LETTER_P_SMALL("ti-letter-p-small"),
  TI_LETTER_Q("ti-letter-q"),
  TI_LETTER_Q_SMALL("ti-letter-q-small"),
  TI_LETTER_R("ti-letter-r"),
  TI_LETTER_R_SMALL("ti-letter-r-small"),
  TI_LETTER_S("ti-letter-s"),
  TI_LETTER_S_SMALL("ti-letter-s-small"),
  TI_LETTER_SPACING("ti-letter-spacing"),
  TI_LETTER_T("ti-letter-t"),
  TI_LETTER_T_SMALL("ti-letter-t-small"),
  TI_LETTER_U("ti-letter-u"),
  TI_LETTER_U_SMALL("ti-letter-u-small"),
  TI_LETTER_V("ti-letter-v"),
  TI_LETTER_V_SMALL("ti-letter-v-small"),
  TI_LETTER_W("ti-letter-w"),
  TI_LETTER_W_SMALL("ti-letter-w-small"),
  TI_LETTER_X("ti-letter-x"),
  TI_LETTER_X_SMALL("ti-letter-x-small"),
  TI_LETTER_Y("ti-letter-y"),
  TI_LETTER_Y_SMALL("ti-letter-y-small"),
  TI_LETTER_Z("ti-letter-z"),
  TI_LETTER_Z_SMALL("ti-letter-z-small"),
  TI_LIBRARY("ti-library"),
  TI_LIBRARY_MINUS("ti-library-minus"),
  TI_LIBRARY_PHOTO("ti-library-photo"),
  TI_LIBRARY_PLUS("ti-library-plus"),
  TI_LICENSE("ti-license"),
  TI_LICENSE_OFF("ti-license-off"),
  TI_LIFEBUOY("ti-lifebuoy"),
  TI_LIFEBUOY_OFF("ti-lifebuoy-off"),
  TI_LIGHTER("ti-lighter"),
  TI_LINE("ti-line"),
  TI_LINE_DASHED("ti-line-dashed"),
  TI_LINE_DOTTED("ti-line-dotted"),
  TI_LINE_HEIGHT("ti-line-height"),
  TI_LINE_SCAN("ti-line-scan"),
  TI_LINK("ti-link"),
  TI_LINK_MINUS("ti-link-minus"),
  TI_LINK_OFF("ti-link-off"),
  TI_LINK_PLUS("ti-link-plus"),
  TI_LIST("ti-list"),
  TI_LIST_CHECK("ti-list-check"),
  TI_LIST_DETAILS("ti-list-details"),
  TI_LIST_LETTERS("ti-list-letters"),
  TI_LIST_NUMBERS("ti-list-numbers"),
  TI_LIST_SEARCH("ti-list-search"),
  TI_LIST_TREE("ti-list-tree"),
  TI_LIVE_PHOTO("ti-live-photo"),
  TI_LIVE_PHOTO_OFF("ti-live-photo-off"),
  TI_LIVE_VIEW("ti-live-view"),
  TI_LOAD_BALANCER("ti-load-balancer"),
  TI_LOADER("ti-loader"),
  TI_LOADER_2("ti-loader-2"),
  TI_LOADER_3("ti-loader-3"),
  TI_LOADER_4("ti-loader-4"),
  TI_LOADER_QUARTER("ti-loader-quarter"),
  TI_LOCATION("ti-location"),
  TI_LOCATION_BOLT("ti-location-bolt"),
  TI_LOCATION_BROKEN("ti-location-broken"),
  TI_LOCATION_CANCEL("ti-location-cancel"),
  TI_LOCATION_CHECK("ti-location-check"),
  TI_LOCATION_CODE("ti-location-code"),
  TI_LOCATION_COG("ti-location-cog"),
  TI_LOCATION_DISCOUNT("ti-location-discount"),
  TI_LOCATION_DOLLAR("ti-location-dollar"),
  TI_LOCATION_DOWN("ti-location-down"),
  TI_LOCATION_EXCLAMATION("ti-location-exclamation"),
  TI_LOCATION_HEART("ti-location-heart"),
  TI_LOCATION_MINUS("ti-location-minus"),
  TI_LOCATION_OFF("ti-location-off"),
  TI_LOCATION_PAUSE("ti-location-pause"),
  TI_LOCATION_PIN("ti-location-pin"),
  TI_LOCATION_PLUS("ti-location-plus"),
  TI_LOCATION_QUESTION("ti-location-question"),
  TI_LOCATION_SEARCH("ti-location-search"),
  TI_LOCATION_SHARE("ti-location-share"),
  TI_LOCATION_STAR("ti-location-star"),
  TI_LOCATION_UP("ti-location-up"),
  TI_LOCATION_X("ti-location-x"),
  TI_LOCK("ti-lock"),
  TI_LOCK_ACCESS("ti-lock-access"),
  TI_LOCK_ACCESS_OFF("ti-lock-access-off"),
  TI_LOCK_BITCOIN("ti-lock-bitcoin"),
  TI_LOCK_BOLT("ti-lock-bolt"),
  TI_LOCK_CANCEL("ti-lock-cancel"),
  TI_LOCK_CHECK("ti-lock-check"),
  TI_LOCK_CODE("ti-lock-code"),
  TI_LOCK_COG("ti-lock-cog"),
  TI_LOCK_DOLLAR("ti-lock-dollar"),
  TI_LOCK_DOWN("ti-lock-down"),
  TI_LOCK_EXCLAMATION("ti-lock-exclamation"),
  TI_LOCK_HEART("ti-lock-heart"),
  TI_LOCK_MINUS("ti-lock-minus"),
  TI_LOCK_OFF("ti-lock-off"),
  TI_LOCK_OPEN("ti-lock-open"),
  TI_LOCK_OPEN_2("ti-lock-open-2"),
  TI_LOCK_OPEN_OFF("ti-lock-open-off"),
  TI_LOCK_PASSWORD("ti-lock-password"),
  TI_LOCK_PAUSE("ti-lock-pause"),
  TI_LOCK_PIN("ti-lock-pin"),
  TI_LOCK_PLUS("ti-lock-plus"),
  TI_LOCK_QUESTION("ti-lock-question"),
  TI_LOCK_SEARCH("ti-lock-search"),
  TI_LOCK_SHARE("ti-lock-share"),
  TI_LOCK_SQUARE("ti-lock-square"),
  TI_LOCK_SQUARE_ROUNDED("ti-lock-square-rounded"),
  TI_LOCK_STAR("ti-lock-star"),
  TI_LOCK_UP("ti-lock-up"),
  TI_LOCK_X("ti-lock-x"),
  TI_LOGIC_AND("ti-logic-and"),
  TI_LOGIC_BUFFER("ti-logic-buffer"),
  TI_LOGIC_NAND("ti-logic-nand"),
  TI_LOGIC_NOR("ti-logic-nor"),
  TI_LOGIC_NOT("ti-logic-not"),
  TI_LOGIC_OR("ti-logic-or"),
  TI_LOGIC_XNOR("ti-logic-xnor"),
  TI_LOGIC_XOR("ti-logic-xor"),
  TI_LOGIN("ti-login"),
  TI_LOGIN_2("ti-login-2"),
  TI_LOGOUT("ti-logout"),
  TI_LOGOUT_2("ti-logout-2"),
  TI_LOGS("ti-logs"),
  TI_LOLLIPOP("ti-lollipop"),
  TI_LOLLIPOP_OFF("ti-lollipop-off"),
  TI_LUGGAGE("ti-luggage"),
  TI_LUGGAGE_OFF("ti-luggage-off"),
  TI_LUNGS("ti-lungs"),
  TI_LUNGS_OFF("ti-lungs-off"),
  TI_MACRO("ti-macro"),
  TI_MACRO_OFF("ti-macro-off"),
  TI_MAGNET("ti-magnet"),
  TI_MAGNET_OFF("ti-magnet-off"),
  TI_MAGNETIC("ti-magnetic"),
  TI_MAIL("ti-mail"),
  TI_MAIL_AI("ti-mail-ai"),
  TI_MAIL_BITCOIN("ti-mail-bitcoin"),
  TI_MAIL_BOLT("ti-mail-bolt"),
  TI_MAIL_CANCEL("ti-mail-cancel"),
  TI_MAIL_CHECK("ti-mail-check"),
  TI_MAIL_CODE("ti-mail-code"),
  TI_MAIL_COG("ti-mail-cog"),
  TI_MAIL_DOLLAR("ti-mail-dollar"),
  TI_MAIL_DOWN("ti-mail-down"),
  TI_MAIL_EXCLAMATION("ti-mail-exclamation"),
  TI_MAIL_FAST("ti-mail-fast"),
  TI_MAIL_FORWARD("ti-mail-forward"),
  TI_MAIL_HEART("ti-mail-heart"),
  TI_MAIL_MINUS("ti-mail-minus"),
  TI_MAIL_OFF("ti-mail-off"),
  TI_MAIL_OPENED("ti-mail-opened"),
  TI_MAIL_PAUSE("ti-mail-pause"),
  TI_MAIL_PIN("ti-mail-pin"),
  TI_MAIL_PLUS("ti-mail-plus"),
  TI_MAIL_QUESTION("ti-mail-question"),
  TI_MAIL_SEARCH("ti-mail-search"),
  TI_MAIL_SHARE("ti-mail-share"),
  TI_MAIL_SPARK("ti-mail-spark"),
  TI_MAIL_STAR("ti-mail-star"),
  TI_MAIL_UP("ti-mail-up"),
  TI_MAIL_X("ti-mail-x"),
  TI_MAILBOX("ti-mailbox"),
  TI_MAILBOX_OFF("ti-mailbox-off"),
  TI_MAN("ti-man"),
  TI_MANUAL_GEARBOX("ti-manual-gearbox"),
  TI_MAP("ti-map"),
  TI_MAP_2("ti-map-2"),
  TI_MAP_BOLT("ti-map-bolt"),
  TI_MAP_CANCEL("ti-map-cancel"),
  TI_MAP_CHECK("ti-map-check"),
  TI_MAP_CODE("ti-map-code"),
  TI_MAP_COG("ti-map-cog"),
  TI_MAP_DISCOUNT("ti-map-discount"),
  TI_MAP_DOLLAR("ti-map-dollar"),
  TI_MAP_DOWN("ti-map-down"),
  TI_MAP_EAST("ti-map-east"),
  TI_MAP_EXCLAMATION("ti-map-exclamation"),
  TI_MAP_HEART("ti-map-heart"),
  TI_MAP_LOCK("ti-map-lock"),
  TI_MAP_MINUS("ti-map-minus"),
  TI_MAP_NORTH("ti-map-north"),
  TI_MAP_OFF("ti-map-off"),
  TI_MAP_PAUSE("ti-map-pause"),
  TI_MAP_PIN("ti-map-pin"),
  TI_MAP_PIN_2("ti-map-pin-2"),
  TI_MAP_PIN_BOLT("ti-map-pin-bolt"),
  TI_MAP_PIN_CANCEL("ti-map-pin-cancel"),
  TI_MAP_PIN_CHECK("ti-map-pin-check"),
  TI_MAP_PIN_CODE("ti-map-pin-code"),
  TI_MAP_PIN_COG("ti-map-pin-cog"),
  TI_MAP_PIN_DOLLAR("ti-map-pin-dollar"),
  TI_MAP_PIN_DOWN("ti-map-pin-down"),
  TI_MAP_PIN_EXCLAMATION("ti-map-pin-exclamation"),
  TI_MAP_PIN_HEART("ti-map-pin-heart"),
  TI_MAP_PIN_MINUS("ti-map-pin-minus"),
  TI_MAP_PIN_OFF("ti-map-pin-off"),
  TI_MAP_PIN_PAUSE("ti-map-pin-pause"),
  TI_MAP_PIN_PIN("ti-map-pin-pin"),
  TI_MAP_PIN_PLUS("ti-map-pin-plus"),
  TI_MAP_PIN_QUESTION("ti-map-pin-question"),
  TI_MAP_PIN_SEARCH("ti-map-pin-search"),
  TI_MAP_PIN_SHARE("ti-map-pin-share"),
  TI_MAP_PIN_STAR("ti-map-pin-star"),
  TI_MAP_PIN_UP("ti-map-pin-up"),
  TI_MAP_PIN_X("ti-map-pin-x"),
  TI_MAP_PINS("ti-map-pins"),
  TI_MAP_PLUS("ti-map-plus"),
  TI_MAP_QUESTION("ti-map-question"),
  TI_MAP_ROUTE("ti-map-route"),
  TI_MAP_SEARCH("ti-map-search"),
  TI_MAP_SHARE("ti-map-share"),
  TI_MAP_SHIELD("ti-map-shield"),
  TI_MAP_SOUTH("ti-map-south"),
  TI_MAP_STAR("ti-map-star"),
  TI_MAP_UP("ti-map-up"),
  TI_MAP_WEST("ti-map-west"),
  TI_MAP_X("ti-map-x"),
  TI_MARKDOWN("ti-markdown"),
  TI_MARKDOWN_OFF("ti-markdown-off"),
  TI_MARQUEE("ti-marquee"),
  TI_MARQUEE_2("ti-marquee-2"),
  TI_MARQUEE_OFF("ti-marquee-off"),
  TI_MARS("ti-mars"),
  TI_MASK("ti-mask"),
  TI_MASK_OFF("ti-mask-off"),
  TI_MASKS_THEATER("ti-masks-theater"),
  TI_MASKS_THEATER_OFF("ti-masks-theater-off"),
  TI_MASSAGE("ti-massage"),
  TI_MATCHSTICK("ti-matchstick"),
  TI_MATH("ti-math"),
  TI_MATH_1_DIVIDE_2("ti-math-1-divide-2"),
  TI_MATH_1_DIVIDE_3("ti-math-1-divide-3"),
  TI_MATH_AVG("ti-math-avg"),
  TI_MATH_COS("ti-math-cos"),
  TI_MATH_CTG("ti-math-ctg"),
  TI_MATH_EQUAL_GREATER("ti-math-equal-greater"),
  TI_MATH_EQUAL_LOWER("ti-math-equal-lower"),
  TI_MATH_FUNCTION("ti-math-function"),
  TI_MATH_FUNCTION_OFF("ti-math-function-off"),
  TI_MATH_FUNCTION_Y("ti-math-function-y"),
  TI_MATH_GREATER("ti-math-greater"),
  TI_MATH_INTEGRAL("ti-math-integral"),
  TI_MATH_INTEGRAL_X("ti-math-integral-x"),
  TI_MATH_INTEGRALS("ti-math-integrals"),
  TI_MATH_LOWER("ti-math-lower"),
  TI_MATH_MAX("ti-math-max"),
  TI_MATH_MAX_MIN("ti-math-max-min"),
  TI_MATH_MIN("ti-math-min"),
  TI_MATH_NOT("ti-math-not"),
  TI_MATH_OFF("ti-math-off"),
  TI_MATH_PI("ti-math-pi"),
  TI_MATH_PI_DIVIDE_2("ti-math-pi-divide-2"),
  TI_MATH_SEC("ti-math-sec"),
  TI_MATH_SIN("ti-math-sin"),
  TI_MATH_SYMBOLS("ti-math-symbols"),
  TI_MATH_TG("ti-math-tg"),
  TI_MATH_X_DIVIDE_2("ti-math-x-divide-2"),
  TI_MATH_X_DIVIDE_Y("ti-math-x-divide-y"),
  TI_MATH_X_DIVIDE_Y_2("ti-math-x-divide-y-2"),
  TI_MATH_X_FLOOR_DIVIDE_Y("ti-math-x-floor-divide-y"),
  TI_MATH_X_MINUS_X("ti-math-x-minus-x"),
  TI_MATH_X_MINUS_Y("ti-math-x-minus-y"),
  TI_MATH_X_PLUS_X("ti-math-x-plus-x"),
  TI_MATH_X_PLUS_Y("ti-math-x-plus-y"),
  TI_MATH_XY("ti-math-xy"),
  TI_MATH_Y_MINUS_Y("ti-math-y-minus-y"),
  TI_MATH_Y_PLUS_Y("ti-math-y-plus-y"),
  TI_MATRIX("ti-matrix"),
  TI_MAXIMIZE("ti-maximize"),
  TI_MAXIMIZE_OFF("ti-maximize-off"),
  TI_MEAT("ti-meat"),
  TI_MEAT_OFF("ti-meat-off"),
  TI_MEDAL("ti-medal"),
  TI_MEDAL_2("ti-medal-2"),
  TI_MEDICAL_CROSS("ti-medical-cross"),
  TI_MEDICAL_CROSS_CIRCLE("ti-medical-cross-circle"),
  TI_MEDICAL_CROSS_OFF("ti-medical-cross-off"),
  TI_MEDICINE_SYRUP("ti-medicine-syrup"),
  TI_MEEPLE("ti-meeple"),
  TI_MELON("ti-melon"),
  TI_MENORAH("ti-menorah"),
  TI_MENU("ti-menu"),
  TI_MENU_2("ti-menu-2"),
  TI_MENU_3("ti-menu-3"),
  TI_MENU_4("ti-menu-4"),
  TI_MENU_DEEP("ti-menu-deep"),
  TI_MENU_ORDER("ti-menu-order"),
  TI_MESH("ti-mesh"),
  TI_MESSAGE("ti-message"),
  TI_MESSAGE_2("ti-message-2"),
  TI_MESSAGE_2_BOLT("ti-message-2-bolt"),
  TI_MESSAGE_2_CANCEL("ti-message-2-cancel"),
  TI_MESSAGE_2_CHECK("ti-message-2-check"),
  TI_MESSAGE_2_CODE("ti-message-2-code"),
  TI_MESSAGE_2_COG("ti-message-2-cog"),
  TI_MESSAGE_2_DOLLAR("ti-message-2-dollar"),
  TI_MESSAGE_2_DOWN("ti-message-2-down"),
  TI_MESSAGE_2_EXCLAMATION("ti-message-2-exclamation"),
  TI_MESSAGE_2_HEART("ti-message-2-heart"),
  TI_MESSAGE_2_MINUS("ti-message-2-minus"),
  TI_MESSAGE_2_OFF("ti-message-2-off"),
  TI_MESSAGE_2_PAUSE("ti-message-2-pause"),
  TI_MESSAGE_2_PIN("ti-message-2-pin"),
  TI_MESSAGE_2_PLUS("ti-message-2-plus"),
  TI_MESSAGE_2_QUESTION("ti-message-2-question"),
  TI_MESSAGE_2_SEARCH("ti-message-2-search"),
  TI_MESSAGE_2_SHARE("ti-message-2-share"),
  TI_MESSAGE_2_STAR("ti-message-2-star"),
  TI_MESSAGE_2_UP("ti-message-2-up"),
  TI_MESSAGE_2_X("ti-message-2-x"),
  TI_MESSAGE_BOLT("ti-message-bolt"),
  TI_MESSAGE_CANCEL("ti-message-cancel"),
  TI_MESSAGE_CHATBOT("ti-message-chatbot"),
  TI_MESSAGE_CHECK("ti-message-check"),
  TI_MESSAGE_CIRCLE("ti-message-circle"),
  TI_MESSAGE_CIRCLE_2("ti-message-circle-2"),
  TI_MESSAGE_CIRCLE_BOLT("ti-message-circle-bolt"),
  TI_MESSAGE_CIRCLE_CANCEL("ti-message-circle-cancel"),
  TI_MESSAGE_CIRCLE_CHECK("ti-message-circle-check"),
  TI_MESSAGE_CIRCLE_CODE("ti-message-circle-code"),
  TI_MESSAGE_CIRCLE_COG("ti-message-circle-cog"),
  TI_MESSAGE_CIRCLE_DOLLAR("ti-message-circle-dollar"),
  TI_MESSAGE_CIRCLE_DOWN("ti-message-circle-down"),
  TI_MESSAGE_CIRCLE_EXCLAMATION("ti-message-circle-exclamation"),
  TI_MESSAGE_CIRCLE_HEART("ti-message-circle-heart"),
  TI_MESSAGE_CIRCLE_MINUS("ti-message-circle-minus"),
  TI_MESSAGE_CIRCLE_OFF("ti-message-circle-off"),
  TI_MESSAGE_CIRCLE_PAUSE("ti-message-circle-pause"),
  TI_MESSAGE_CIRCLE_PIN("ti-message-circle-pin"),
  TI_MESSAGE_CIRCLE_PLUS("ti-message-circle-plus"),
  TI_MESSAGE_CIRCLE_QUESTION("ti-message-circle-question"),
  TI_MESSAGE_CIRCLE_SEARCH("ti-message-circle-search"),
  TI_MESSAGE_CIRCLE_SHARE("ti-message-circle-share"),
  TI_MESSAGE_CIRCLE_STAR("ti-message-circle-star"),
  TI_MESSAGE_CIRCLE_UP("ti-message-circle-up"),
  TI_MESSAGE_CIRCLE_USER("ti-message-circle-user"),
  TI_MESSAGE_CIRCLE_X("ti-message-circle-x"),
  TI_MESSAGE_CODE("ti-message-code"),
  TI_MESSAGE_COG("ti-message-cog"),
  TI_MESSAGE_DOLLAR("ti-message-dollar"),
  TI_MESSAGE_DOTS("ti-message-dots"),
  TI_MESSAGE_DOWN("ti-message-down"),
  TI_MESSAGE_EXCLAMATION("ti-message-exclamation"),
  TI_MESSAGE_FORWARD("ti-message-forward"),
  TI_MESSAGE_HEART("ti-message-heart"),
  TI_MESSAGE_LANGUAGE("ti-message-language"),
  TI_MESSAGE_MINUS("ti-message-minus"),
  TI_MESSAGE_OFF("ti-message-off"),
  TI_MESSAGE_PAUSE("ti-message-pause"),
  TI_MESSAGE_PIN("ti-message-pin"),
  TI_MESSAGE_PLUS("ti-message-plus"),
  TI_MESSAGE_QUESTION("ti-message-question"),
  TI_MESSAGE_REPLY("ti-message-reply"),
  TI_MESSAGE_REPORT("ti-message-report"),
  TI_MESSAGE_SEARCH("ti-message-search"),
  TI_MESSAGE_SHARE("ti-message-share"),
  TI_MESSAGE_STAR("ti-message-star"),
  TI_MESSAGE_UP("ti-message-up"),
  TI_MESSAGE_USER("ti-message-user"),
  TI_MESSAGE_X("ti-message-x"),
  TI_MESSAGES("ti-messages"),
  TI_MESSAGES_OFF("ti-messages-off"),
  TI_METEOR("ti-meteor"),
  TI_METEOR_OFF("ti-meteor-off"),
  TI_METER_CUBE("ti-meter-cube"),
  TI_METER_SQUARE("ti-meter-square"),
  TI_METRONOME("ti-metronome"),
  TI_MICHELIN_BIB_GOURMAND("ti-michelin-bib-gourmand"),
  TI_MICHELIN_STAR("ti-michelin-star"),
  TI_MICHELIN_STAR_GREEN("ti-michelin-star-green"),
  TI_MICKEY("ti-mickey"),
  TI_MICROFRONTENDS("ti-microfrontends"),
  TI_MICROPHONE("ti-microphone"),
  TI_MICROPHONE_2("ti-microphone-2"),
  TI_MICROPHONE_2_OFF("ti-microphone-2-off"),
  TI_MICROPHONE_OFF("ti-microphone-off"),
  TI_MICROSCOPE("ti-microscope"),
  TI_MICROSCOPE_OFF("ti-microscope-off"),
  TI_MICROWAVE("ti-microwave"),
  TI_MICROWAVE_OFF("ti-microwave-off"),
  TI_MIDDLEWARE("ti-middleware"),
  TI_MILITARY_AWARD("ti-military-award"),
  TI_MILITARY_RANK("ti-military-rank"),
  TI_MILK("ti-milk"),
  TI_MILK_OFF("ti-milk-off"),
  TI_MILKSHAKE("ti-milkshake"),
  TI_MINIMIZE("ti-minimize"),
  TI_MINUS("ti-minus"),
  TI_MINUS_VERTICAL("ti-minus-vertical"),
  TI_MIST("ti-mist"),
  TI_MIST_OFF("ti-mist-off"),
  TI_MOBILEDATA("ti-mobiledata"),
  TI_MOBILEDATA_OFF("ti-mobiledata-off"),
  TI_MONEYBAG("ti-moneybag"),
  TI_MONEYBAG_EDIT("ti-moneybag-edit"),
  TI_MONEYBAG_HEART("ti-moneybag-heart"),
  TI_MONEYBAG_MINUS("ti-moneybag-minus"),
  TI_MONEYBAG_MOVE("ti-moneybag-move"),
  TI_MONEYBAG_MOVE_BACK("ti-moneybag-move-back"),
  TI_MONEYBAG_PLUS("ti-moneybag-plus"),
  TI_MONKEYBAR("ti-monkeybar"),
  TI_MOOD_ANGRY("ti-mood-angry"),
  TI_MOOD_ANNOYED("ti-mood-annoyed"),
  TI_MOOD_ANNOYED_2("ti-mood-annoyed-2"),
  TI_MOOD_BITCOIN("ti-mood-bitcoin"),
  TI_MOOD_BOY("ti-mood-boy"),
  TI_MOOD_CHECK("ti-mood-check"),
  TI_MOOD_COG("ti-mood-cog"),
  TI_MOOD_CONFUSED("ti-mood-confused"),
  TI_MOOD_CONFUZED("ti-mood-confuzed"),
  TI_MOOD_CRAZY_HAPPY("ti-mood-crazy-happy"),
  TI_MOOD_CRY("ti-mood-cry"),
  TI_MOOD_DOLLAR("ti-mood-dollar"),
  TI_MOOD_EDIT("ti-mood-edit"),
  TI_MOOD_EMPTY("ti-mood-empty"),
  TI_MOOD_HAPPY("ti-mood-happy"),
  TI_MOOD_HEART("ti-mood-heart"),
  TI_MOOD_KID("ti-mood-kid"),
  TI_MOOD_LOOK_DOWN("ti-mood-look-down"),
  TI_MOOD_LOOK_LEFT("ti-mood-look-left"),
  TI_MOOD_LOOK_RIGHT("ti-mood-look-right"),
  TI_MOOD_LOOK_UP("ti-mood-look-up"),
  TI_MOOD_MINUS("ti-mood-minus"),
  TI_MOOD_NERD("ti-mood-nerd"),
  TI_MOOD_NERVOUS("ti-mood-nervous"),
  TI_MOOD_NEUTRAL("ti-mood-neutral"),
  TI_MOOD_OFF("ti-mood-off"),
  TI_MOOD_PIN("ti-mood-pin"),
  TI_MOOD_PLUS("ti-mood-plus"),
  TI_MOOD_PUZZLED("ti-mood-puzzled"),
  TI_MOOD_SAD("ti-mood-sad"),
  TI_MOOD_SAD_2("ti-mood-sad-2"),
  TI_MOOD_SAD_DIZZY("ti-mood-sad-dizzy"),
  TI_MOOD_SAD_SQUINT("ti-mood-sad-squint"),
  TI_MOOD_SEARCH("ti-mood-search"),
  TI_MOOD_SHARE("ti-mood-share"),
  TI_MOOD_SICK("ti-mood-sick"),
  TI_MOOD_SILENCE("ti-mood-silence"),
  TI_MOOD_SING("ti-mood-sing"),
  TI_MOOD_SMILE("ti-mood-smile"),
  TI_MOOD_SMILE_BEAM("ti-mood-smile-beam"),
  TI_MOOD_SMILE_DIZZY("ti-mood-smile-dizzy"),
  TI_MOOD_SPARK("ti-mood-spark"),
  TI_MOOD_SUPRISED("ti-mood-suprised"),
  TI_MOOD_SURPRISED("ti-mood-surprised"),
  TI_MOOD_TONGUE("ti-mood-tongue"),
  TI_MOOD_TONGUE_WINK("ti-mood-tongue-wink"),
  TI_MOOD_TONGUE_WINK_2("ti-mood-tongue-wink-2"),
  TI_MOOD_UNAMUSED("ti-mood-unamused"),
  TI_MOOD_UP("ti-mood-up"),
  TI_MOOD_WINK("ti-mood-wink"),
  TI_MOOD_WINK_2("ti-mood-wink-2"),
  TI_MOOD_WRRR("ti-mood-wrrr"),
  TI_MOOD_X("ti-mood-x"),
  TI_MOOD_XD("ti-mood-xd"),
  TI_MOON("ti-moon"),
  TI_MOON_2("ti-moon-2"),
  TI_MOON_OFF("ti-moon-off"),
  TI_MOON_STARS("ti-moon-stars"),
  TI_MOPED("ti-moped"),
  TI_MOSQUE("ti-mosque"),
  TI_MOTORBIKE("ti-motorbike"),
  TI_MOUNTAIN("ti-mountain"),
  TI_MOUNTAIN_OFF("ti-mountain-off"),
  TI_MOUSE("ti-mouse"),
  TI_MOUSE_2("ti-mouse-2"),
  TI_MOUSE_OFF("ti-mouse-off"),
  TI_MOUSTACHE("ti-moustache"),
  TI_MOVIE("ti-movie"),
  TI_MOVIE_OFF("ti-movie-off"),
  TI_MUG("ti-mug"),
  TI_MUG_OFF("ti-mug-off"),
  TI_MULTIPLIER_0_5X("ti-multiplier-0-5x"),
  TI_MULTIPLIER_1_5X("ti-multiplier-1-5x"),
  TI_MULTIPLIER_1X("ti-multiplier-1x"),
  TI_MULTIPLIER_2X("ti-multiplier-2x"),
  TI_MUSHROOM("ti-mushroom"),
  TI_MUSHROOM_OFF("ti-mushroom-off"),
  TI_MUSIC("ti-music"),
  TI_MUSIC_BOLT("ti-music-bolt"),
  TI_MUSIC_CANCEL("ti-music-cancel"),
  TI_MUSIC_CHECK("ti-music-check"),
  TI_MUSIC_CODE("ti-music-code"),
  TI_MUSIC_COG("ti-music-cog"),
  TI_MUSIC_DISCOUNT("ti-music-discount"),
  TI_MUSIC_DOLLAR("ti-music-dollar"),
  TI_MUSIC_DOWN("ti-music-down"),
  TI_MUSIC_EXCLAMATION("ti-music-exclamation"),
  TI_MUSIC_HEART("ti-music-heart"),
  TI_MUSIC_MINUS("ti-music-minus"),
  TI_MUSIC_OFF("ti-music-off"),
  TI_MUSIC_PAUSE("ti-music-pause"),
  TI_MUSIC_PIN("ti-music-pin"),
  TI_MUSIC_PLUS("ti-music-plus"),
  TI_MUSIC_QUESTION("ti-music-question"),
  TI_MUSIC_SEARCH("ti-music-search"),
  TI_MUSIC_SHARE("ti-music-share"),
  TI_MUSIC_STAR("ti-music-star"),
  TI_MUSIC_UP("ti-music-up"),
  TI_MUSIC_X("ti-music-x"),
  TI_NAVIGATION("ti-navigation"),
  TI_NAVIGATION_BOLT("ti-navigation-bolt"),
  TI_NAVIGATION_CANCEL("ti-navigation-cancel"),
  TI_NAVIGATION_CHECK("ti-navigation-check"),
  TI_NAVIGATION_CODE("ti-navigation-code"),
  TI_NAVIGATION_COG("ti-navigation-cog"),
  TI_NAVIGATION_DISCOUNT("ti-navigation-discount"),
  TI_NAVIGATION_DOLLAR("ti-navigation-dollar"),
  TI_NAVIGATION_DOWN("ti-navigation-down"),
  TI_NAVIGATION_EAST("ti-navigation-east"),
  TI_NAVIGATION_EXCLAMATION("ti-navigation-exclamation"),
  TI_NAVIGATION_HEART("ti-navigation-heart"),
  TI_NAVIGATION_MINUS("ti-navigation-minus"),
  TI_NAVIGATION_NORTH("ti-navigation-north"),
  TI_NAVIGATION_OFF("ti-navigation-off"),
  TI_NAVIGATION_PAUSE("ti-navigation-pause"),
  TI_NAVIGATION_PIN("ti-navigation-pin"),
  TI_NAVIGATION_PLUS("ti-navigation-plus"),
  TI_NAVIGATION_QUESTION("ti-navigation-question"),
  TI_NAVIGATION_SEARCH("ti-navigation-search"),
  TI_NAVIGATION_SHARE("ti-navigation-share"),
  TI_NAVIGATION_SOUTH("ti-navigation-south"),
  TI_NAVIGATION_STAR("ti-navigation-star"),
  TI_NAVIGATION_TOP("ti-navigation-top"),
  TI_NAVIGATION_UP("ti-navigation-up"),
  TI_NAVIGATION_WEST("ti-navigation-west"),
  TI_NAVIGATION_X("ti-navigation-x"),
  TI_NEEDLE("ti-needle"),
  TI_NEEDLE_THREAD("ti-needle-thread"),
  TI_NETWORK("ti-network"),
  TI_NETWORK_OFF("ti-network-off"),
  TI_NEW_SECTION("ti-new-section"),
  TI_NEWS("ti-news"),
  TI_NEWS_OFF("ti-news-off"),
  TI_NFC("ti-nfc"),
  TI_NFC_OFF("ti-nfc-off"),
  TI_NO_COPYRIGHT("ti-no-copyright"),
  TI_NO_CREATIVE_COMMONS("ti-no-creative-commons"),
  TI_NO_DERIVATIVES("ti-no-derivatives"),
  TI_NOISE_REDUCTION("ti-noise-reduction"),
  TI_NORTH_STAR("ti-north-star"),
  TI_NOTDEF("ti-notdef"),
  TI_NOTE("ti-note"),
  TI_NOTE_OFF("ti-note-off"),
  TI_NOTEBOOK("ti-notebook"),
  TI_NOTEBOOK_OFF("ti-notebook-off"),
  TI_NOTES("ti-notes"),
  TI_NOTES_OFF("ti-notes-off"),
  TI_NOTIFICATION("ti-notification"),
  TI_NOTIFICATION_OFF("ti-notification-off"),
  TI_NUMBER("ti-number"),
  TI_NUMBER_0("ti-number-0"),
  TI_NUMBER_0_SMALL("ti-number-0-small"),
  TI_NUMBER_1("ti-number-1"),
  TI_NUMBER_1_SMALL("ti-number-1-small"),
  TI_NUMBER_10("ti-number-10"),
  TI_NUMBER_10_SMALL("ti-number-10-small"),
  TI_NUMBER_100_SMALL("ti-number-100-small"),
  TI_NUMBER_11("ti-number-11"),
  TI_NUMBER_11_SMALL("ti-number-11-small"),
  TI_NUMBER_12_SMALL("ti-number-12-small"),
  TI_NUMBER_123("ti-number-123"),
  TI_NUMBER_13_SMALL("ti-number-13-small"),
  TI_NUMBER_14_SMALL("ti-number-14-small"),
  TI_NUMBER_15_SMALL("ti-number-15-small"),
  TI_NUMBER_16_SMALL("ti-number-16-small"),
  TI_NUMBER_17_SMALL("ti-number-17-small"),
  TI_NUMBER_18_SMALL("ti-number-18-small"),
  TI_NUMBER_19_SMALL("ti-number-19-small"),
  TI_NUMBER_2("ti-number-2"),
  TI_NUMBER_2_SMALL("ti-number-2-small"),
  TI_NUMBER_20_SMALL("ti-number-20-small"),
  TI_NUMBER_21_SMALL("ti-number-21-small"),
  TI_NUMBER_22_SMALL("ti-number-22-small"),
  TI_NUMBER_23_SMALL("ti-number-23-small"),
  TI_NUMBER_24_SMALL("ti-number-24-small"),
  TI_NUMBER_25_SMALL("ti-number-25-small"),
  TI_NUMBER_26_SMALL("ti-number-26-small"),
  TI_NUMBER_27_SMALL("ti-number-27-small"),
  TI_NUMBER_28_SMALL("ti-number-28-small"),
  TI_NUMBER_29_SMALL("ti-number-29-small"),
  TI_NUMBER_3("ti-number-3"),
  TI_NUMBER_3_SMALL("ti-number-3-small"),
  TI_NUMBER_30_SMALL("ti-number-30-small"),
  TI_NUMBER_31_SMALL("ti-number-31-small"),
  TI_NUMBER_32_SMALL("ti-number-32-small"),
  TI_NUMBER_33_SMALL("ti-number-33-small"),
  TI_NUMBER_34_SMALL("ti-number-34-small"),
  TI_NUMBER_35_SMALL("ti-number-35-small"),
  TI_NUMBER_36_SMALL("ti-number-36-small"),
  TI_NUMBER_37_SMALL("ti-number-37-small"),
  TI_NUMBER_38_SMALL("ti-number-38-small"),
  TI_NUMBER_39_SMALL("ti-number-39-small"),
  TI_NUMBER_4("ti-number-4"),
  TI_NUMBER_4_SMALL("ti-number-4-small"),
  TI_NUMBER_40_SMALL("ti-number-40-small"),
  TI_NUMBER_41_SMALL("ti-number-41-small"),
  TI_NUMBER_42_SMALL("ti-number-42-small"),
  TI_NUMBER_43_SMALL("ti-number-43-small"),
  TI_NUMBER_44_SMALL("ti-number-44-small"),
  TI_NUMBER_45_SMALL("ti-number-45-small"),
  TI_NUMBER_46_SMALL("ti-number-46-small"),
  TI_NUMBER_47_SMALL("ti-number-47-small"),
  TI_NUMBER_48_SMALL("ti-number-48-small"),
  TI_NUMBER_49_SMALL("ti-number-49-small"),
  TI_NUMBER_5("ti-number-5"),
  TI_NUMBER_5_SMALL("ti-number-5-small"),
  TI_NUMBER_50_SMALL("ti-number-50-small"),
  TI_NUMBER_51_SMALL("ti-number-51-small"),
  TI_NUMBER_52_SMALL("ti-number-52-small"),
  TI_NUMBER_53_SMALL("ti-number-53-small"),
  TI_NUMBER_54_SMALL("ti-number-54-small"),
  TI_NUMBER_55_SMALL("ti-number-55-small"),
  TI_NUMBER_56_SMALL("ti-number-56-small"),
  TI_NUMBER_57_SMALL("ti-number-57-small"),
  TI_NUMBER_58_SMALL("ti-number-58-small"),
  TI_NUMBER_59_SMALL("ti-number-59-small"),
  TI_NUMBER_6("ti-number-6"),
  TI_NUMBER_6_SMALL("ti-number-6-small"),
  TI_NUMBER_60_SMALL("ti-number-60-small"),
  TI_NUMBER_61_SMALL("ti-number-61-small"),
  TI_NUMBER_62_SMALL("ti-number-62-small"),
  TI_NUMBER_63_SMALL("ti-number-63-small"),
  TI_NUMBER_64_SMALL("ti-number-64-small"),
  TI_NUMBER_65_SMALL("ti-number-65-small"),
  TI_NUMBER_66_SMALL("ti-number-66-small"),
  TI_NUMBER_67_SMALL("ti-number-67-small"),
  TI_NUMBER_68_SMALL("ti-number-68-small"),
  TI_NUMBER_69_SMALL("ti-number-69-small"),
  TI_NUMBER_7("ti-number-7"),
  TI_NUMBER_7_SMALL("ti-number-7-small"),
  TI_NUMBER_70_SMALL("ti-number-70-small"),
  TI_NUMBER_71_SMALL("ti-number-71-small"),
  TI_NUMBER_72_SMALL("ti-number-72-small"),
  TI_NUMBER_73_SMALL("ti-number-73-small"),
  TI_NUMBER_74_SMALL("ti-number-74-small"),
  TI_NUMBER_75_SMALL("ti-number-75-small"),
  TI_NUMBER_76_SMALL("ti-number-76-small"),
  TI_NUMBER_77_SMALL("ti-number-77-small"),
  TI_NUMBER_78_SMALL("ti-number-78-small"),
  TI_NUMBER_79_SMALL("ti-number-79-small"),
  TI_NUMBER_8("ti-number-8"),
  TI_NUMBER_8_SMALL("ti-number-8-small"),
  TI_NUMBER_80_SMALL("ti-number-80-small"),
  TI_NUMBER_81_SMALL("ti-number-81-small"),
  TI_NUMBER_82_SMALL("ti-number-82-small"),
  TI_NUMBER_83_SMALL("ti-number-83-small"),
  TI_NUMBER_84_SMALL("ti-number-84-small"),
  TI_NUMBER_85_SMALL("ti-number-85-small"),
  TI_NUMBER_86_SMALL("ti-number-86-small"),
  TI_NUMBER_87_SMALL("ti-number-87-small"),
  TI_NUMBER_88_SMALL("ti-number-88-small"),
  TI_NUMBER_89_SMALL("ti-number-89-small"),
  TI_NUMBER_9("ti-number-9"),
  TI_NUMBER_9_SMALL("ti-number-9-small"),
  TI_NUMBER_90_SMALL("ti-number-90-small"),
  TI_NUMBER_91_SMALL("ti-number-91-small"),
  TI_NUMBER_92_SMALL("ti-number-92-small"),
  TI_NUMBER_93_SMALL("ti-number-93-small"),
  TI_NUMBER_94_SMALL("ti-number-94-small"),
  TI_NUMBER_95_SMALL("ti-number-95-small"),
  TI_NUMBER_96_SMALL("ti-number-96-small"),
  TI_NUMBER_97_SMALL("ti-number-97-small"),
  TI_NUMBER_98_SMALL("ti-number-98-small"),
  TI_NUMBER_99_SMALL("ti-number-99-small"),
  TI_NUMBERS("ti-numbers"),
  TI_NURSE("ti-nurse"),
  TI_NUT("ti-nut"),
  TI_OBJECT_SCAN("ti-object-scan"),
  TI_OCTAGON("ti-octagon"),
  TI_OCTAGON_MINUS("ti-octagon-minus"),
  TI_OCTAGON_MINUS_2("ti-octagon-minus-2"),
  TI_OCTAGON_OFF("ti-octagon-off"),
  TI_OCTAGON_PLUS("ti-octagon-plus"),
  TI_OCTAGON_PLUS_2("ti-octagon-plus-2"),
  TI_OCTAHEDRON("ti-octahedron"),
  TI_OCTAHEDRON_OFF("ti-octahedron-off"),
  TI_OCTAHEDRON_PLUS("ti-octahedron-plus"),
  TI_OLD("ti-old"),
  TI_OLYMPIC_TORCH("ti-olympic-torch"),
  TI_OLYMPICS("ti-olympics"),
  TI_OLYMPICS_OFF("ti-olympics-off"),
  TI_OM("ti-om"),
  TI_OMEGA("ti-omega"),
  TI_OPTION("ti-option"),
  TI_OUTBOUND("ti-outbound"),
  TI_OUTLET("ti-outlet"),
  TI_OVAL("ti-oval"),
  TI_OVAL_VERTICAL("ti-oval-vertical"),
  TI_OVERLINE("ti-overline"),
  TI_PACKAGE("ti-package"),
  TI_PACKAGE_EXPORT("ti-package-export"),
  TI_PACKAGE_IMPORT("ti-package-import"),
  TI_PACKAGE_OFF("ti-package-off"),
  TI_PACKAGES("ti-packages"),
  TI_PACMAN("ti-pacman"),
  TI_PAGE_BREAK("ti-page-break"),
  TI_PAINT("ti-paint"),
  TI_PAINT_OFF("ti-paint-off"),
  TI_PALETTE("ti-palette"),
  TI_PALETTE_OFF("ti-palette-off"),
  TI_PANORAMA_HORIZONTAL("ti-panorama-horizontal"),
  TI_PANORAMA_HORIZONTAL_OFF("ti-panorama-horizontal-off"),
  TI_PANORAMA_VERTICAL("ti-panorama-vertical"),
  TI_PANORAMA_VERTICAL_OFF("ti-panorama-vertical-off"),
  TI_PAPER_BAG("ti-paper-bag"),
  TI_PAPER_BAG_OFF("ti-paper-bag-off"),
  TI_PAPERCLIP("ti-paperclip"),
  TI_PARACHUTE("ti-parachute"),
  TI_PARACHUTE_OFF("ti-parachute-off"),
  TI_PARENTHESES("ti-parentheses"),
  TI_PARENTHESES_OFF("ti-parentheses-off"),
  TI_PARKING("ti-parking"),
  TI_PARKING_CIRCLE("ti-parking-circle"),
  TI_PARKING_METER("ti-parking-meter"),
  TI_PARKING_OFF("ti-parking-off"),
  TI_PASSWORD("ti-password"),
  TI_PASSWORD_FINGERPRINT("ti-password-fingerprint"),
  TI_PASSWORD_MOBILE_PHONE("ti-password-mobile-phone"),
  TI_PASSWORD_USER("ti-password-user"),
  TI_PAW("ti-paw"),
  TI_PAW_OFF("ti-paw-off"),
  TI_PAYWALL("ti-paywall"),
  TI_PDF("ti-pdf"),
  TI_PEACE("ti-peace"),
  TI_PENCIL("ti-pencil"),
  TI_PENCIL_BOLT("ti-pencil-bolt"),
  TI_PENCIL_CANCEL("ti-pencil-cancel"),
  TI_PENCIL_CHECK("ti-pencil-check"),
  TI_PENCIL_CODE("ti-pencil-code"),
  TI_PENCIL_COG("ti-pencil-cog"),
  TI_PENCIL_DISCOUNT("ti-pencil-discount"),
  TI_PENCIL_DOLLAR("ti-pencil-dollar"),
  TI_PENCIL_DOWN("ti-pencil-down"),
  TI_PENCIL_EXCLAMATION("ti-pencil-exclamation"),
  TI_PENCIL_HEART("ti-pencil-heart"),
  TI_PENCIL_MINUS("ti-pencil-minus"),
  TI_PENCIL_OFF("ti-pencil-off"),
  TI_PENCIL_PAUSE("ti-pencil-pause"),
  TI_PENCIL_PIN("ti-pencil-pin"),
  TI_PENCIL_PLUS("ti-pencil-plus"),
  TI_PENCIL_QUESTION("ti-pencil-question"),
  TI_PENCIL_SEARCH("ti-pencil-search"),
  TI_PENCIL_SHARE("ti-pencil-share"),
  TI_PENCIL_STAR("ti-pencil-star"),
  TI_PENCIL_UP("ti-pencil-up"),
  TI_PENCIL_X("ti-pencil-x"),
  TI_PENDULUM("ti-pendulum"),
  TI_PENNANT("ti-pennant"),
  TI_PENNANT_2("ti-pennant-2"),
  TI_PENNANT_OFF("ti-pennant-off"),
  TI_PENTAGON("ti-pentagon"),
  TI_PENTAGON_MINUS("ti-pentagon-minus"),
  TI_PENTAGON_NUMBER_0("ti-pentagon-number-0"),
  TI_PENTAGON_NUMBER_1("ti-pentagon-number-1"),
  TI_PENTAGON_NUMBER_2("ti-pentagon-number-2"),
  TI_PENTAGON_NUMBER_3("ti-pentagon-number-3"),
  TI_PENTAGON_NUMBER_4("ti-pentagon-number-4"),
  TI_PENTAGON_NUMBER_5("ti-pentagon-number-5"),
  TI_PENTAGON_NUMBER_6("ti-pentagon-number-6"),
  TI_PENTAGON_NUMBER_7("ti-pentagon-number-7"),
  TI_PENTAGON_NUMBER_8("ti-pentagon-number-8"),
  TI_PENTAGON_NUMBER_9("ti-pentagon-number-9"),
  TI_PENTAGON_OFF("ti-pentagon-off"),
  TI_PENTAGON_PLUS("ti-pentagon-plus"),
  TI_PENTAGON_X("ti-pentagon-x"),
  TI_PENTAGRAM("ti-pentagram"),
  TI_PEPPER("ti-pepper"),
  TI_PEPPER_OFF("ti-pepper-off"),
  TI_PERCENTAGE("ti-percentage"),
  TI_PERCENTAGE_0("ti-percentage-0"),
  TI_PERCENTAGE_10("ti-percentage-10"),
  TI_PERCENTAGE_100("ti-percentage-100"),
  TI_PERCENTAGE_20("ti-percentage-20"),
  TI_PERCENTAGE_25("ti-percentage-25"),
  TI_PERCENTAGE_30("ti-percentage-30"),
  TI_PERCENTAGE_33("ti-percentage-33"),
  TI_PERCENTAGE_40("ti-percentage-40"),
  TI_PERCENTAGE_50("ti-percentage-50"),
  TI_PERCENTAGE_60("ti-percentage-60"),
  TI_PERCENTAGE_66("ti-percentage-66"),
  TI_PERCENTAGE_70("ti-percentage-70"),
  TI_PERCENTAGE_75("ti-percentage-75"),
  TI_PERCENTAGE_80("ti-percentage-80"),
  TI_PERCENTAGE_90("ti-percentage-90"),
  TI_PERFUME("ti-perfume"),
  TI_PERSPECTIVE("ti-perspective"),
  TI_PERSPECTIVE_OFF("ti-perspective-off"),
  TI_PHONE("ti-phone"),
  TI_PHONE_CALL("ti-phone-call"),
  TI_PHONE_CALLING("ti-phone-calling"),
  TI_PHONE_CHECK("ti-phone-check"),
  TI_PHONE_DONE("ti-phone-done"),
  TI_PHONE_END("ti-phone-end"),
  TI_PHONE_INCOMING("ti-phone-incoming"),
  TI_PHONE_OFF("ti-phone-off"),
  TI_PHONE_OUTGOING("ti-phone-outgoing"),
  TI_PHONE_PAUSE("ti-phone-pause"),
  TI_PHONE_PLUS("ti-phone-plus"),
  TI_PHONE_RINGING("ti-phone-ringing"),
  TI_PHONE_SPARK("ti-phone-spark"),
  TI_PHONE_X("ti-phone-x"),
  TI_PHOTO("ti-photo"),
  TI_PHOTO_AI("ti-photo-ai"),
  TI_PHOTO_ALT("ti-photo-alt"),
  TI_PHOTO_BITCOIN("ti-photo-bitcoin"),
  TI_PHOTO_BOLT("ti-photo-bolt"),
  TI_PHOTO_CANCEL("ti-photo-cancel"),
  TI_PHOTO_CHECK("ti-photo-check"),
  TI_PHOTO_CIRCLE("ti-photo-circle"),
  TI_PHOTO_CIRCLE_MINUS("ti-photo-circle-minus"),
  TI_PHOTO_CIRCLE_PLUS("ti-photo-circle-plus"),
  TI_PHOTO_CODE("ti-photo-code"),
  TI_PHOTO_COG("ti-photo-cog"),
  TI_PHOTO_DOLLAR("ti-photo-dollar"),
  TI_PHOTO_DOWN("ti-photo-down"),
  TI_PHOTO_EDIT("ti-photo-edit"),
  TI_PHOTO_EXCLAMATION("ti-photo-exclamation"),
  TI_PHOTO_HEART("ti-photo-heart"),
  TI_PHOTO_HEXAGON("ti-photo-hexagon"),
  TI_PHOTO_MINUS("ti-photo-minus"),
  TI_PHOTO_OFF("ti-photo-off"),
  TI_PHOTO_PAUSE("ti-photo-pause"),
  TI_PHOTO_PENTAGON("ti-photo-pentagon"),
  TI_PHOTO_PIN("ti-photo-pin"),
  TI_PHOTO_PLUS("ti-photo-plus"),
  TI_PHOTO_QUESTION("ti-photo-question"),
  TI_PHOTO_SCAN("ti-photo-scan"),
  TI_PHOTO_SEARCH("ti-photo-search"),
  TI_PHOTO_SENSOR("ti-photo-sensor"),
  TI_PHOTO_SENSOR_2("ti-photo-sensor-2"),
  TI_PHOTO_SENSOR_3("ti-photo-sensor-3"),
  TI_PHOTO_SHARE("ti-photo-share"),
  TI_PHOTO_SHIELD("ti-photo-shield"),
  TI_PHOTO_SPARK("ti-photo-spark"),
  TI_PHOTO_SQUARE_ROUNDED("ti-photo-square-rounded"),
  TI_PHOTO_STAR("ti-photo-star"),
  TI_PHOTO_UP("ti-photo-up"),
  TI_PHOTO_VIDEO("ti-photo-video"),
  TI_PHOTO_X("ti-photo-x"),
  TI_PHYSIOTHERAPIST("ti-physiotherapist"),
  TI_PHYSOTHERAPIST("ti-physotherapist"),
  TI_PIANO("ti-piano"),
  TI_PICK("ti-pick"),
  TI_PICNIC_TABLE("ti-picnic-table"),
  TI_PICTURE_IN_PICTURE("ti-picture-in-picture"),
  TI_PICTURE_IN_PICTURE_OFF("ti-picture-in-picture-off"),
  TI_PICTURE_IN_PICTURE_ON("ti-picture-in-picture-on"),
  TI_PICTURE_IN_PICTURE_TOP("ti-picture-in-picture-top"),
  TI_PIG("ti-pig"),
  TI_PIG_MONEY("ti-pig-money"),
  TI_PIG_OFF("ti-pig-off"),
  TI_PILCROW("ti-pilcrow"),
  TI_PILCROW_LEFT("ti-pilcrow-left"),
  TI_PILCROW_RIGHT("ti-pilcrow-right"),
  TI_PILL("ti-pill"),
  TI_PILL_OFF("ti-pill-off"),
  TI_PILLOW("ti-pillow"),
  TI_PILLS("ti-pills"),
  TI_PIN("ti-pin"),
  TI_PIN_END("ti-pin-end"),
  TI_PIN_INVOKE("ti-pin-invoke"),
  TI_PING_PONG("ti-ping-pong"),
  TI_PINNED("ti-pinned"),
  TI_PINNED_OFF("ti-pinned-off"),
  TI_PIPELINE("ti-pipeline"),
  TI_PIZZA("ti-pizza"),
  TI_PIZZA_OFF("ti-pizza-off"),
  TI_PLACEHOLDER("ti-placeholder"),
  TI_PLANE("ti-plane"),
  TI_PLANE_ARRIVAL("ti-plane-arrival"),
  TI_PLANE_DEPARTURE("ti-plane-departure"),
  TI_PLANE_INFLIGHT("ti-plane-inflight"),
  TI_PLANE_OFF("ti-plane-off"),
  TI_PLANE_TILT("ti-plane-tilt"),
  TI_PLANET("ti-planet"),
  TI_PLANET_OFF("ti-planet-off"),
  TI_PLANT("ti-plant"),
  TI_PLANT_2("ti-plant-2"),
  TI_PLANT_2_OFF("ti-plant-2-off"),
  TI_PLANT_OFF("ti-plant-off"),
  TI_PLAY_BASKETBALL("ti-play-basketball"),
  TI_PLAY_BUG("ti-play-bug"),
  TI_PLAY_BUGS("ti-play-bugs"),
  TI_PLAY_CARD("ti-play-card"),
  TI_PLAY_CARD_1("ti-play-card-1"),
  TI_PLAY_CARD_10("ti-play-card-10"),
  TI_PLAY_CARD_2("ti-play-card-2"),
  TI_PLAY_CARD_3("ti-play-card-3"),
  TI_PLAY_CARD_4("ti-play-card-4"),
  TI_PLAY_CARD_5("ti-play-card-5"),
  TI_PLAY_CARD_6("ti-play-card-6"),
  TI_PLAY_CARD_7("ti-play-card-7"),
  TI_PLAY_CARD_8("ti-play-card-8"),
  TI_PLAY_CARD_9("ti-play-card-9"),
  TI_PLAY_CARD_A("ti-play-card-a"),
  TI_PLAY_CARD_J("ti-play-card-j"),
  TI_PLAY_CARD_K("ti-play-card-k"),
  TI_PLAY_CARD_OFF("ti-play-card-off"),
  TI_PLAY_CARD_Q("ti-play-card-q"),
  TI_PLAY_CARD_STAR("ti-play-card-star"),
  TI_PLAY_FOOTBALL("ti-play-football"),
  TI_PLAY_HANDBALL("ti-play-handball"),
  TI_PLAY_VOLLEYBALL("ti-play-volleyball"),
  TI_PLAYER_EJECT("ti-player-eject"),
  TI_PLAYER_PAUSE("ti-player-pause"),
  TI_PLAYER_PLAY("ti-player-play"),
  TI_PLAYER_RECORD("ti-player-record"),
  TI_PLAYER_SKIP_BACK("ti-player-skip-back"),
  TI_PLAYER_SKIP_FORWARD("ti-player-skip-forward"),
  TI_PLAYER_STOP("ti-player-stop"),
  TI_PLAYER_TRACK_NEXT("ti-player-track-next"),
  TI_PLAYER_TRACK_PREV("ti-player-track-prev"),
  TI_PLAYLIST("ti-playlist"),
  TI_PLAYLIST_ADD("ti-playlist-add"),
  TI_PLAYLIST_OFF("ti-playlist-off"),
  TI_PLAYLIST_X("ti-playlist-x"),
  TI_PLAYSTATION_CIRCLE("ti-playstation-circle"),
  TI_PLAYSTATION_SQUARE("ti-playstation-square"),
  TI_PLAYSTATION_TRIANGLE("ti-playstation-triangle"),
  TI_PLAYSTATION_X("ti-playstation-x"),
  TI_PLUG("ti-plug"),
  TI_PLUG_CONNECTED("ti-plug-connected"),
  TI_PLUG_CONNECTED_X("ti-plug-connected-x"),
  TI_PLUG_OFF("ti-plug-off"),
  TI_PLUG_X("ti-plug-x"),
  TI_PLUNGER("ti-plunger"),
  TI_PLUS("ti-plus"),
  TI_PLUS_EQUAL("ti-plus-equal"),
  TI_PLUS_MINUS("ti-plus-minus"),
  TI_PNG("ti-png"),
  TI_PODIUM("ti-podium"),
  TI_PODIUM_OFF("ti-podium-off"),
  TI_POINT("ti-point"),
  TI_POINT_OFF("ti-point-off"),
  TI_POINTER("ti-pointer"),
  TI_POINTER_2("ti-pointer-2"),
  TI_POINTER_BOLT("ti-pointer-bolt"),
  TI_POINTER_CANCEL("ti-pointer-cancel"),
  TI_POINTER_CHECK("ti-pointer-check"),
  TI_POINTER_CODE("ti-pointer-code"),
  TI_POINTER_COG("ti-pointer-cog"),
  TI_POINTER_COLLABORATION("ti-pointer-collaboration"),
  TI_POINTER_COLLABORATION_2("ti-pointer-collaboration-2"),
  TI_POINTER_DOLLAR("ti-pointer-dollar"),
  TI_POINTER_DOWN("ti-pointer-down"),
  TI_POINTER_EXCLAMATION("ti-pointer-exclamation"),
  TI_POINTER_HEART("ti-pointer-heart"),
  TI_POINTER_MINUS("ti-pointer-minus"),
  TI_POINTER_OFF("ti-pointer-off"),
  TI_POINTER_PAUSE("ti-pointer-pause"),
  TI_POINTER_PIN("ti-pointer-pin"),
  TI_POINTER_PLUS("ti-pointer-plus"),
  TI_POINTER_QUESTION("ti-pointer-question"),
  TI_POINTER_SEARCH("ti-pointer-search"),
  TI_POINTER_SHARE("ti-pointer-share"),
  TI_POINTER_STAR("ti-pointer-star"),
  TI_POINTER_UP("ti-pointer-up"),
  TI_POINTER_X("ti-pointer-x"),
  TI_POKEBALL("ti-pokeball"),
  TI_POKEBALL_OFF("ti-pokeball-off"),
  TI_POKER_CHIP("ti-poker-chip"),
  TI_POLAROID("ti-polaroid"),
  TI_POLYGON("ti-polygon"),
  TI_POLYGON_OFF("ti-polygon-off"),
  TI_POO("ti-poo"),
  TI_POOL("ti-pool"),
  TI_POOL_OFF("ti-pool-off"),
  TI_POWER("ti-power"),
  TI_PRAY("ti-pray"),
  TI_PREMIUM_RIGHTS("ti-premium-rights"),
  TI_PRESCRIPTION("ti-prescription"),
  TI_PRESENTATION("ti-presentation"),
  TI_PRESENTATION_ANALYTICS("ti-presentation-analytics"),
  TI_PRESENTATION_OFF("ti-presentation-off"),
  TI_PRINTER("ti-printer"),
  TI_PRINTER_OFF("ti-printer-off"),
  TI_PRISM("ti-prism"),
  TI_PRISM_LIGHT("ti-prism-light"),
  TI_PRISM_OFF("ti-prism-off"),
  TI_PRISM_PLUS("ti-prism-plus"),
  TI_PRISON("ti-prison"),
  TI_PROGRESS("ti-progress"),
  TI_PROGRESS_ALERT("ti-progress-alert"),
  TI_PROGRESS_BOLT("ti-progress-bolt"),
  TI_PROGRESS_CHECK("ti-progress-check"),
  TI_PROGRESS_DOWN("ti-progress-down"),
  TI_PROGRESS_HELP("ti-progress-help"),
  TI_PROGRESS_X("ti-progress-x"),
  TI_PROMPT("ti-prompt"),
  TI_PRONG("ti-prong"),
  TI_PROPELLER("ti-propeller"),
  TI_PROPELLER_OFF("ti-propeller-off"),
  TI_PROTOCOL("ti-protocol"),
  TI_PUMPKIN_SCARY("ti-pumpkin-scary"),
  TI_PUZZLE("ti-puzzle"),
  TI_PUZZLE_2("ti-puzzle-2"),
  TI_PUZZLE_OFF("ti-puzzle-off"),
  TI_PYRAMID("ti-pyramid"),
  TI_PYRAMID_OFF("ti-pyramid-off"),
  TI_PYRAMID_PLUS("ti-pyramid-plus"),
  TI_QRCODE("ti-qrcode"),
  TI_QRCODE_OFF("ti-qrcode-off"),
  TI_QUESTION_MARK("ti-question-mark"),
  TI_QUEUE_POP_IN("ti-queue-pop-in"),
  TI_QUEUE_POP_OUT("ti-queue-pop-out"),
  TI_QUOTE("ti-quote"),
  TI_QUOTE_OFF("ti-quote-off"),
  TI_QUOTE_OPEN("ti-quote-open"),
  TI_QUOTES("ti-quotes"),
  TI_RADAR("ti-radar"),
  TI_RADAR_2("ti-radar-2"),
  TI_RADAR_OFF("ti-radar-off"),
  TI_RADIO("ti-radio"),
  TI_RADIO_OFF("ti-radio-off"),
  TI_RADIOACTIVE("ti-radioactive"),
  TI_RADIOACTIVE_OFF("ti-radioactive-off"),
  TI_RADIUS_BOTTOM_LEFT("ti-radius-bottom-left"),
  TI_RADIUS_BOTTOM_RIGHT("ti-radius-bottom-right"),
  TI_RADIUS_TOP_LEFT("ti-radius-top-left"),
  TI_RADIUS_TOP_RIGHT("ti-radius-top-right"),
  TI_RAINBOW("ti-rainbow"),
  TI_RAINBOW_OFF("ti-rainbow-off"),
  TI_RATING_12_PLUS("ti-rating-12-plus"),
  TI_RATING_14_PLUS("ti-rating-14-plus"),
  TI_RATING_16_PLUS("ti-rating-16-plus"),
  TI_RATING_18_PLUS("ti-rating-18-plus"),
  TI_RATING_21_PLUS("ti-rating-21-plus"),
  TI_RAZOR("ti-razor"),
  TI_RAZOR_ELECTRIC("ti-razor-electric"),
  TI_RECEIPT("ti-receipt"),
  TI_RECEIPT_2("ti-receipt-2"),
  TI_RECEIPT_BITCOIN("ti-receipt-bitcoin"),
  TI_RECEIPT_DOLLAR("ti-receipt-dollar"),
  TI_RECEIPT_EURO("ti-receipt-euro"),
  TI_RECEIPT_OFF("ti-receipt-off"),
  TI_RECEIPT_POUND("ti-receipt-pound"),
  TI_RECEIPT_REFUND("ti-receipt-refund"),
  TI_RECEIPT_RUPEE("ti-receipt-rupee"),
  TI_RECEIPT_TAX("ti-receipt-tax"),
  TI_RECEIPT_YEN("ti-receipt-yen"),
  TI_RECEIPT_YUAN("ti-receipt-yuan"),
  TI_RECHARGING("ti-recharging"),
  TI_RECORD_MAIL("ti-record-mail"),
  TI_RECORD_MAIL_OFF("ti-record-mail-off"),
  TI_RECTANGLE("ti-rectangle"),
  TI_RECTANGLE_ROUNDED_BOTTOM("ti-rectangle-rounded-bottom"),
  TI_RECTANGLE_ROUNDED_TOP("ti-rectangle-rounded-top"),
  TI_RECTANGLE_VERTICAL("ti-rectangle-vertical"),
  TI_RECTANGULAR_PRISM("ti-rectangular-prism"),
  TI_RECTANGULAR_PRISM_OFF("ti-rectangular-prism-off"),
  TI_RECTANGULAR_PRISM_PLUS("ti-rectangular-prism-plus"),
  TI_RECYCLE("ti-recycle"),
  TI_RECYCLE_OFF("ti-recycle-off"),
  TI_REFRESH("ti-refresh"),
  TI_REFRESH_ALERT("ti-refresh-alert"),
  TI_REFRESH_DOT("ti-refresh-dot"),
  TI_REFRESH_OFF("ti-refresh-off"),
  TI_REGEX("ti-regex"),
  TI_REGEX_OFF("ti-regex-off"),
  TI_REGISTERED("ti-registered"),
  TI_RELATION_MANY_TO_MANY("ti-relation-many-to-many"),
  TI_RELATION_ONE_TO_MANY("ti-relation-one-to-many"),
  TI_RELATION_ONE_TO_ONE("ti-relation-one-to-one"),
  TI_RELOAD("ti-reload"),
  TI_REMOTE_CONTROL("ti-remote-control"),
  TI_REORDER("ti-reorder"),
  TI_REPEAT("ti-repeat"),
  TI_REPEAT_OFF("ti-repeat-off"),
  TI_REPEAT_ONCE("ti-repeat-once"),
  TI_REPLACE("ti-replace"),
  TI_REPLACE_OFF("ti-replace-off"),
  TI_REPLACE_USER("ti-replace-user"),
  TI_REPORT("ti-report"),
  TI_REPORT_ANALYTICS("ti-report-analytics"),
  TI_REPORT_MEDICAL("ti-report-medical"),
  TI_REPORT_MONEY("ti-report-money"),
  TI_REPORT_OFF("ti-report-off"),
  TI_REPORT_SEARCH("ti-report-search"),
  TI_RESERVED_LINE("ti-reserved-line"),
  TI_RESIZE("ti-resize"),
  TI_RESTORE("ti-restore"),
  TI_REWIND_BACKWARD_10("ti-rewind-backward-10"),
  TI_REWIND_BACKWARD_15("ti-rewind-backward-15"),
  TI_REWIND_BACKWARD_20("ti-rewind-backward-20"),
  TI_REWIND_BACKWARD_30("ti-rewind-backward-30"),
  TI_REWIND_BACKWARD_40("ti-rewind-backward-40"),
  TI_REWIND_BACKWARD_5("ti-rewind-backward-5"),
  TI_REWIND_BACKWARD_50("ti-rewind-backward-50"),
  TI_REWIND_BACKWARD_60("ti-rewind-backward-60"),
  TI_REWIND_FORWARD_10("ti-rewind-forward-10"),
  TI_REWIND_FORWARD_15("ti-rewind-forward-15"),
  TI_REWIND_FORWARD_20("ti-rewind-forward-20"),
  TI_REWIND_FORWARD_30("ti-rewind-forward-30"),
  TI_REWIND_FORWARD_40("ti-rewind-forward-40"),
  TI_REWIND_FORWARD_5("ti-rewind-forward-5"),
  TI_REWIND_FORWARD_50("ti-rewind-forward-50"),
  TI_REWIND_FORWARD_60("ti-rewind-forward-60"),
  TI_RIBBON_HEALTH("ti-ribbon-health"),
  TI_RINGS("ti-rings"),
  TI_RIPPLE("ti-ripple"),
  TI_RIPPLE_DOWN("ti-ripple-down"),
  TI_RIPPLE_OFF("ti-ripple-off"),
  TI_RIPPLE_UP("ti-ripple-up"),
  TI_ROAD("ti-road"),
  TI_ROAD_OFF("ti-road-off"),
  TI_ROAD_SIGN("ti-road-sign"),
  TI_ROBOT("ti-robot"),
  TI_ROBOT_FACE("ti-robot-face"),
  TI_ROBOT_OFF("ti-robot-off"),
  TI_ROCKET("ti-rocket"),
  TI_ROCKET_OFF("ti-rocket-off"),
  TI_ROCKING_CHAIR("ti-rocking-chair"),
  TI_ROLLER_SKATING("ti-roller-skating"),
  TI_ROLLERCOASTER("ti-rollercoaster"),
  TI_ROLLERCOASTER_OFF("ti-rollercoaster-off"),
  TI_ROSETTE("ti-rosette"),
  TI_ROSETTE_ASTERISK("ti-rosette-asterisk"),
  TI_ROSETTE_DISCOUNT("ti-rosette-discount"),
  TI_ROSETTE_DISCOUNT_CHECK("ti-rosette-discount-check"),
  TI_ROSETTE_DISCOUNT_CHECK_OFF("ti-rosette-discount-check-off"),
  TI_ROSETTE_DISCOUNT_OFF("ti-rosette-discount-off"),
  TI_ROSETTE_NUMBER_0("ti-rosette-number-0"),
  TI_ROSETTE_NUMBER_1("ti-rosette-number-1"),
  TI_ROSETTE_NUMBER_2("ti-rosette-number-2"),
  TI_ROSETTE_NUMBER_3("ti-rosette-number-3"),
  TI_ROSETTE_NUMBER_4("ti-rosette-number-4"),
  TI_ROSETTE_NUMBER_5("ti-rosette-number-5"),
  TI_ROSETTE_NUMBER_6("ti-rosette-number-6"),
  TI_ROSETTE_NUMBER_7("ti-rosette-number-7"),
  TI_ROSETTE_NUMBER_8("ti-rosette-number-8"),
  TI_ROSETTE_NUMBER_9("ti-rosette-number-9"),
  TI_ROTATE("ti-rotate"),
  TI_ROTATE_2("ti-rotate-2"),
  TI_ROTATE_360("ti-rotate-360"),
  TI_ROTATE_3D("ti-rotate-3d"),
  TI_ROTATE_CLOCKWISE("ti-rotate-clockwise"),
  TI_ROTATE_CLOCKWISE_2("ti-rotate-clockwise-2"),
  TI_ROTATE_DOT("ti-rotate-dot"),
  TI_ROTATE_RECTANGLE("ti-rotate-rectangle"),
  TI_ROULETTE("ti-roulette"),
  TI_ROUTE("ti-route"),
  TI_ROUTE_2("ti-route-2"),
  TI_ROUTE_ALT_LEFT("ti-route-alt-left"),
  TI_ROUTE_ALT_RIGHT("ti-route-alt-right"),
  TI_ROUTE_OFF("ti-route-off"),
  TI_ROUTE_SCAN("ti-route-scan"),
  TI_ROUTE_SQUARE("ti-route-square"),
  TI_ROUTE_SQUARE_2("ti-route-square-2"),
  TI_ROUTE_X("ti-route-x"),
  TI_ROUTE_X_2("ti-route-x-2"),
  TI_ROUTER("ti-router"),
  TI_ROUTER_OFF("ti-router-off"),
  TI_ROW_INSERT_BOTTOM("ti-row-insert-bottom"),
  TI_ROW_INSERT_TOP("ti-row-insert-top"),
  TI_ROW_REMOVE("ti-row-remove"),
  TI_RSS("ti-rss"),
  TI_RUBBER_STAMP("ti-rubber-stamp"),
  TI_RUBBER_STAMP_OFF("ti-rubber-stamp-off"),
  TI_RUGBY("ti-rugby"),
  TI_RULER("ti-ruler"),
  TI_RULER_2("ti-ruler-2"),
  TI_RULER_2_OFF("ti-ruler-2-off"),
  TI_RULER_3("ti-ruler-3"),
  TI_RULER_MEASURE("ti-ruler-measure"),
  TI_RULER_MEASURE_2("ti-ruler-measure-2"),
  TI_RULER_OFF("ti-ruler-off"),
  TI_RUN("ti-run"),
  TI_RUN_SPRINT("ti-run-sprint"),
  TI_RV_TRUCK("ti-rv-truck"),
  TI_S_TURN_DOWN("ti-s-turn-down"),
  TI_S_TURN_LEFT("ti-s-turn-left"),
  TI_S_TURN_RIGHT("ti-s-turn-right"),
  TI_S_TURN_UP("ti-s-turn-up"),
  TI_SAILBOAT("ti-sailboat"),
  TI_SAILBOAT_2("ti-sailboat-2"),
  TI_SAILBOAT_OFF("ti-sailboat-off"),
  TI_SALAD("ti-salad"),
  TI_SALT("ti-salt"),
  TI_SANDBOX("ti-sandbox"),
  TI_SATELLITE("ti-satellite"),
  TI_SATELLITE_OFF("ti-satellite-off"),
  TI_SAUSAGE("ti-sausage"),
  TI_SCALE("ti-scale"),
  TI_SCALE_OFF("ti-scale-off"),
  TI_SCALE_OUTLINE("ti-scale-outline"),
  TI_SCALE_OUTLINE_OFF("ti-scale-outline-off"),
  TI_SCAN("ti-scan"),
  TI_SCAN_CUBE("ti-scan-cube"),
  TI_SCAN_EYE("ti-scan-eye"),
  TI_SCAN_LETTER_A("ti-scan-letter-a"),
  TI_SCAN_LETTER_T("ti-scan-letter-t"),
  TI_SCAN_POSITION("ti-scan-position"),
  TI_SCAN_TRACES("ti-scan-traces"),
  TI_SCHEMA("ti-schema"),
  TI_SCHEMA_OFF("ti-schema-off"),
  TI_SCHOOL("ti-school"),
  TI_SCHOOL_BELL("ti-school-bell"),
  TI_SCHOOL_OFF("ti-school-off"),
  TI_SCISSORS("ti-scissors"),
  TI_SCISSORS_OFF("ti-scissors-off"),
  TI_SCOOTER("ti-scooter"),
  TI_SCOOTER_ELECTRIC("ti-scooter-electric"),
  TI_SCOREBOARD("ti-scoreboard"),
  TI_SCREEN_SHARE("ti-screen-share"),
  TI_SCREEN_SHARE_OFF("ti-screen-share-off"),
  TI_SCREENSHOT("ti-screenshot"),
  TI_SCRIBBLE("ti-scribble"),
  TI_SCRIBBLE_OFF("ti-scribble-off"),
  TI_SCRIPT("ti-script"),
  TI_SCRIPT_MINUS("ti-script-minus"),
  TI_SCRIPT_PLUS("ti-script-plus"),
  TI_SCRIPT_X("ti-script-x"),
  TI_SCUBA_DIVING("ti-scuba-diving"),
  TI_SCUBA_DIVING_TANK("ti-scuba-diving-tank"),
  TI_SCUBA_MASK("ti-scuba-mask"),
  TI_SCUBA_MASK_OFF("ti-scuba-mask-off"),
  TI_SDK("ti-sdk"),
  TI_SEARCH("ti-search"),
  TI_SEARCH_OFF("ti-search-off"),
  TI_SECTION("ti-section"),
  TI_SECTION_SIGN("ti-section-sign"),
  TI_SEEDING("ti-seeding"),
  TI_SEEDING_OFF("ti-seeding-off"),
  TI_SEEDLING("ti-seedling"),
  TI_SEEDLING_OFF("ti-seedling-off"),
  TI_SEGWAY("ti-segway"),
  TI_SELECT("ti-select"),
  TI_SELECT_ALL("ti-select-all"),
  TI_SELECTOR("ti-selector"),
  TI_SEND("ti-send"),
  TI_SEND_2("ti-send-2"),
  TI_SEND_OFF("ti-send-off"),
  TI_SEO("ti-seo"),
  TI_SEPARATOR("ti-separator"),
  TI_SEPARATOR_HORIZONTAL("ti-separator-horizontal"),
  TI_SEPARATOR_VERTICAL("ti-separator-vertical"),
  TI_SERVER("ti-server"),
  TI_SERVER_2("ti-server-2"),
  TI_SERVER_BOLT("ti-server-bolt"),
  TI_SERVER_COG("ti-server-cog"),
  TI_SERVER_OFF("ti-server-off"),
  TI_SERVER_SPARK("ti-server-spark"),
  TI_SERVERLESS("ti-serverless"),
  TI_SERVICEMARK("ti-servicemark"),
  TI_SETTINGS("ti-settings"),
  TI_SETTINGS_2("ti-settings-2"),
  TI_SETTINGS_AI("ti-settings-ai"),
  TI_SETTINGS_AUTOMATION("ti-settings-automation"),
  TI_SETTINGS_BOLT("ti-settings-bolt"),
  TI_SETTINGS_CANCEL("ti-settings-cancel"),
  TI_SETTINGS_CHECK("ti-settings-check"),
  TI_SETTINGS_CODE("ti-settings-code"),
  TI_SETTINGS_COG("ti-settings-cog"),
  TI_SETTINGS_DOLLAR("ti-settings-dollar"),
  TI_SETTINGS_DOWN("ti-settings-down"),
  TI_SETTINGS_EXCLAMATION("ti-settings-exclamation"),
  TI_SETTINGS_HEART("ti-settings-heart"),
  TI_SETTINGS_MINUS("ti-settings-minus"),
  TI_SETTINGS_OFF("ti-settings-off"),
  TI_SETTINGS_PAUSE("ti-settings-pause"),
  TI_SETTINGS_PIN("ti-settings-pin"),
  TI_SETTINGS_PLUS("ti-settings-plus"),
  TI_SETTINGS_QUESTION("ti-settings-question"),
  TI_SETTINGS_SEARCH("ti-settings-search"),
  TI_SETTINGS_SHARE("ti-settings-share"),
  TI_SETTINGS_SPARK("ti-settings-spark"),
  TI_SETTINGS_STAR("ti-settings-star"),
  TI_SETTINGS_UP("ti-settings-up"),
  TI_SETTINGS_X("ti-settings-x"),
  TI_SHADOW("ti-shadow"),
  TI_SHADOW_OFF("ti-shadow-off"),
  TI_SHAPE("ti-shape"),
  TI_SHAPE_2("ti-shape-2"),
  TI_SHAPE_3("ti-shape-3"),
  TI_SHAPE_OFF("ti-shape-off"),
  TI_SHARE("ti-share"),
  TI_SHARE_2("ti-share-2"),
  TI_SHARE_3("ti-share-3"),
  TI_SHARE_OFF("ti-share-off"),
  TI_SHAREPLAY("ti-shareplay"),
  TI_SHI_JUMPING("ti-shi-jumping"),
  TI_SHIELD("ti-shield"),
  TI_SHIELD_BOLT("ti-shield-bolt"),
  TI_SHIELD_CANCEL("ti-shield-cancel"),
  TI_SHIELD_CHECK("ti-shield-check"),
  TI_SHIELD_CHECKERED("ti-shield-checkered"),
  TI_SHIELD_CHEVRON("ti-shield-chevron"),
  TI_SHIELD_CODE("ti-shield-code"),
  TI_SHIELD_COG("ti-shield-cog"),
  TI_SHIELD_DOLLAR("ti-shield-dollar"),
  TI_SHIELD_DOWN("ti-shield-down"),
  TI_SHIELD_EXCLAMATION("ti-shield-exclamation"),
  TI_SHIELD_HALF("ti-shield-half"),
  TI_SHIELD_HEART("ti-shield-heart"),
  TI_SHIELD_LOCK("ti-shield-lock"),
  TI_SHIELD_MINUS("ti-shield-minus"),
  TI_SHIELD_OFF("ti-shield-off"),
  TI_SHIELD_PAUSE("ti-shield-pause"),
  TI_SHIELD_PIN("ti-shield-pin"),
  TI_SHIELD_PLUS("ti-shield-plus"),
  TI_SHIELD_QUESTION("ti-shield-question"),
  TI_SHIELD_SEARCH("ti-shield-search"),
  TI_SHIELD_SHARE("ti-shield-share"),
  TI_SHIELD_STAR("ti-shield-star"),
  TI_SHIELD_UP("ti-shield-up"),
  TI_SHIELD_X("ti-shield-x"),
  TI_SHIP("ti-ship"),
  TI_SHIP_OFF("ti-ship-off"),
  TI_SHIRT("ti-shirt"),
  TI_SHIRT_OFF("ti-shirt-off"),
  TI_SHIRT_SPORT("ti-shirt-sport"),
  TI_SHOE("ti-shoe"),
  TI_SHOE_OFF("ti-shoe-off"),
  TI_SHOPPING_BAG("ti-shopping-bag"),
  TI_SHOPPING_BAG_CHECK("ti-shopping-bag-check"),
  TI_SHOPPING_BAG_DISCOUNT("ti-shopping-bag-discount"),
  TI_SHOPPING_BAG_EDIT("ti-shopping-bag-edit"),
  TI_SHOPPING_BAG_EXCLAMATION("ti-shopping-bag-exclamation"),
  TI_SHOPPING_BAG_HEART("ti-shopping-bag-heart"),
  TI_SHOPPING_BAG_MINUS("ti-shopping-bag-minus"),
  TI_SHOPPING_BAG_PLUS("ti-shopping-bag-plus"),
  TI_SHOPPING_BAG_SEARCH("ti-shopping-bag-search"),
  TI_SHOPPING_BAG_X("ti-shopping-bag-x"),
  TI_SHOPPING_CART("ti-shopping-cart"),
  TI_SHOPPING_CART_BOLT("ti-shopping-cart-bolt"),
  TI_SHOPPING_CART_CANCEL("ti-shopping-cart-cancel"),
  TI_SHOPPING_CART_CHECK("ti-shopping-cart-check"),
  TI_SHOPPING_CART_CODE("ti-shopping-cart-code"),
  TI_SHOPPING_CART_COG("ti-shopping-cart-cog"),
  TI_SHOPPING_CART_COPY("ti-shopping-cart-copy"),
  TI_SHOPPING_CART_DISCOUNT("ti-shopping-cart-discount"),
  TI_SHOPPING_CART_DOLLAR("ti-shopping-cart-dollar"),
  TI_SHOPPING_CART_DOWN("ti-shopping-cart-down"),
  TI_SHOPPING_CART_EXCLAMATION("ti-shopping-cart-exclamation"),
  TI_SHOPPING_CART_HEART("ti-shopping-cart-heart"),
  TI_SHOPPING_CART_MINUS("ti-shopping-cart-minus"),
  TI_SHOPPING_CART_OFF("ti-shopping-cart-off"),
  TI_SHOPPING_CART_PAUSE("ti-shopping-cart-pause"),
  TI_SHOPPING_CART_PIN("ti-shopping-cart-pin"),
  TI_SHOPPING_CART_PLUS("ti-shopping-cart-plus"),
  TI_SHOPPING_CART_QUESTION("ti-shopping-cart-question"),
  TI_SHOPPING_CART_SEARCH("ti-shopping-cart-search"),
  TI_SHOPPING_CART_SHARE("ti-shopping-cart-share"),
  TI_SHOPPING_CART_STAR("ti-shopping-cart-star"),
  TI_SHOPPING_CART_UP("ti-shopping-cart-up"),
  TI_SHOPPING_CART_X("ti-shopping-cart-x"),
  TI_SHOVEL("ti-shovel"),
  TI_SHOVEL_PITCHFORKS("ti-shovel-pitchforks"),
  TI_SHREDDER("ti-shredder"),
  TI_SIGN_LEFT("ti-sign-left"),
  TI_SIGN_RIGHT("ti-sign-right"),
  TI_SIGNAL_2G("ti-signal-2g"),
  TI_SIGNAL_3G("ti-signal-3g"),
  TI_SIGNAL_4G("ti-signal-4g"),
  TI_SIGNAL_4G_PLUS("ti-signal-4g-plus"),
  TI_SIGNAL_5G("ti-signal-5g"),
  TI_SIGNAL_6G("ti-signal-6g"),
  TI_SIGNAL_E("ti-signal-e"),
  TI_SIGNAL_G("ti-signal-g"),
  TI_SIGNAL_H("ti-signal-h"),
  TI_SIGNAL_H_PLUS("ti-signal-h-plus"),
  TI_SIGNAL_LTE("ti-signal-lte"),
  TI_SIGNATURE("ti-signature"),
  TI_SIGNATURE_OFF("ti-signature-off"),
  TI_SITEMAP("ti-sitemap"),
  TI_SITEMAP_OFF("ti-sitemap-off"),
  TI_SKATEBOARD("ti-skateboard"),
  TI_SKATEBOARD_OFF("ti-skateboard-off"),
  TI_SKATEBOARDING("ti-skateboarding"),
  TI_SKETCHING("ti-sketching"),
  TI_SKEW_X("ti-skew-x"),
  TI_SKEW_Y("ti-skew-y"),
  TI_SKI_JUMPING("ti-ski-jumping"),
  TI_SKULL("ti-skull"),
  TI_SLASH("ti-slash"),
  TI_SLASHES("ti-slashes"),
  TI_SLEIGH("ti-sleigh"),
  TI_SLICE("ti-slice"),
  TI_SLIDESHOW("ti-slideshow"),
  TI_SMART_HOME("ti-smart-home"),
  TI_SMART_HOME_OFF("ti-smart-home-off"),
  TI_SMOKING("ti-smoking"),
  TI_SMOKING_NO("ti-smoking-no"),
  TI_SNOWBOARDING("ti-snowboarding"),
  TI_SNOWFLAKE("ti-snowflake"),
  TI_SNOWFLAKE_OFF("ti-snowflake-off"),
  TI_SNOWMAN("ti-snowman"),
  TI_SOCCER_FIELD("ti-soccer-field"),
  TI_SOCIAL("ti-social"),
  TI_SOCIAL_OFF("ti-social-off"),
  TI_SOCK("ti-sock"),
  TI_SOFA("ti-sofa"),
  TI_SOFA_OFF("ti-sofa-off"),
  TI_SOLAR_ELECTRICITY("ti-solar-electricity"),
  TI_SOLAR_PANEL("ti-solar-panel"),
  TI_SOLAR_PANEL_2("ti-solar-panel-2"),
  TI_SORT_0_9("ti-sort-0-9"),
  TI_SORT_9_0("ti-sort-9-0"),
  TI_SORT_A_Z("ti-sort-a-z"),
  TI_SORT_ASCENDING("ti-sort-ascending"),
  TI_SORT_ASCENDING_2("ti-sort-ascending-2"),
  TI_SORT_ASCENDING_LETTERS("ti-sort-ascending-letters"),
  TI_SORT_ASCENDING_NUMBERS("ti-sort-ascending-numbers"),
  TI_SORT_ASCENDING_SHAPES("ti-sort-ascending-shapes"),
  TI_SORT_ASCENDING_SMALL_BIG("ti-sort-ascending-small-big"),
  TI_SORT_DEACENDING_SMALL_BIG("ti-sort-deacending-small-big"),
  TI_SORT_DESCENDING("ti-sort-descending"),
  TI_SORT_DESCENDING_2("ti-sort-descending-2"),
  TI_SORT_DESCENDING_LETTERS("ti-sort-descending-letters"),
  TI_SORT_DESCENDING_NUMBERS("ti-sort-descending-numbers"),
  TI_SORT_DESCENDING_SHAPES("ti-sort-descending-shapes"),
  TI_SORT_DESCENDING_SMALL_BIG("ti-sort-descending-small-big"),
  TI_SORT_Z_A("ti-sort-z-a"),
  TI_SOS("ti-sos"),
  TI_SOUP("ti-soup"),
  TI_SOUP_OFF("ti-soup-off"),
  TI_SOURCE_CODE("ti-source-code"),
  TI_SPACE("ti-space"),
  TI_SPACE_OFF("ti-space-off"),
  TI_SPACES("ti-spaces"),
  TI_SPACING_HORIZONTAL("ti-spacing-horizontal"),
  TI_SPACING_VERTICAL("ti-spacing-vertical"),
  TI_SPADE("ti-spade"),
  TI_SPARKLE("ti-sparkle"),
  TI_SPARKLE_2("ti-sparkle-2"),
  TI_SPARKLE_HIGHLIGHT("ti-sparkle-highlight"),
  TI_SPARKLES("ti-sparkles"),
  TI_SPARKLES_2("ti-sparkles-2"),
  TI_SPARKLES_2_OFF("ti-sparkles-2-off"),
  TI_SPEAKERPHONE("ti-speakerphone"),
  TI_SPEEDBOAT("ti-speedboat"),
  TI_SPHERE("ti-sphere"),
  TI_SPHERE_2("ti-sphere-2"),
  TI_SPHERE_OFF("ti-sphere-off"),
  TI_SPHERE_PLUS("ti-sphere-plus"),
  TI_SPIDER("ti-spider"),
  TI_SPIRAL("ti-spiral"),
  TI_SPIRAL_OFF("ti-spiral-off"),
  TI_SPORT_BILLARD("ti-sport-billard"),
  TI_SPORT_BILLIARD("ti-sport-billiard"),
  TI_SPRAY("ti-spray"),
  TI_SPY("ti-spy"),
  TI_SPY_OFF("ti-spy-off"),
  TI_SQL("ti-sql"),
  TI_SQUARE("ti-square"),
  TI_SQUARE_0("ti-square-0"),
  TI_SQUARE_1("ti-square-1"),
  TI_SQUARE_2("ti-square-2"),
  TI_SQUARE_3("ti-square-3"),
  TI_SQUARE_4("ti-square-4"),
  TI_SQUARE_5("ti-square-5"),
  TI_SQUARE_6("ti-square-6"),
  TI_SQUARE_7("ti-square-7"),
  TI_SQUARE_8("ti-square-8"),
  TI_SQUARE_9("ti-square-9"),
  TI_SQUARE_ARROW_DOWN("ti-square-arrow-down"),
  TI_SQUARE_ARROW_LEFT("ti-square-arrow-left"),
  TI_SQUARE_ARROW_RIGHT("ti-square-arrow-right"),
  TI_SQUARE_ARROW_UP("ti-square-arrow-up"),
  TI_SQUARE_ASTERISK("ti-square-asterisk"),
  TI_SQUARE_CHECK("ti-square-check"),
  TI_SQUARE_CHEVRON_DOWN("ti-square-chevron-down"),
  TI_SQUARE_CHEVRON_LEFT("ti-square-chevron-left"),
  TI_SQUARE_CHEVRON_RIGHT("ti-square-chevron-right"),
  TI_SQUARE_CHEVRON_UP("ti-square-chevron-up"),
  TI_SQUARE_CHEVRONS_DOWN("ti-square-chevrons-down"),
  TI_SQUARE_CHEVRONS_LEFT("ti-square-chevrons-left"),
  TI_SQUARE_CHEVRONS_RIGHT("ti-square-chevrons-right"),
  TI_SQUARE_CHEVRONS_UP("ti-square-chevrons-up"),
  TI_SQUARE_DASHED("ti-square-dashed"),
  TI_SQUARE_DOT("ti-square-dot"),
  TI_SQUARE_F0("ti-square-f0"),
  TI_SQUARE_F1("ti-square-f1"),
  TI_SQUARE_F2("ti-square-f2"),
  TI_SQUARE_F3("ti-square-f3"),
  TI_SQUARE_F4("ti-square-f4"),
  TI_SQUARE_F5("ti-square-f5"),
  TI_SQUARE_F6("ti-square-f6"),
  TI_SQUARE_F7("ti-square-f7"),
  TI_SQUARE_F8("ti-square-f8"),
  TI_SQUARE_F9("ti-square-f9"),
  TI_SQUARE_FORBID("ti-square-forbid"),
  TI_SQUARE_FORBID_2("ti-square-forbid-2"),
  TI_SQUARE_HALF("ti-square-half"),
  TI_SQUARE_KEY("ti-square-key"),
  TI_SQUARE_LETTER_A("ti-square-letter-a"),
  TI_SQUARE_LETTER_B("ti-square-letter-b"),
  TI_SQUARE_LETTER_C("ti-square-letter-c"),
  TI_SQUARE_LETTER_D("ti-square-letter-d"),
  TI_SQUARE_LETTER_E("ti-square-letter-e"),
  TI_SQUARE_LETTER_F("ti-square-letter-f"),
  TI_SQUARE_LETTER_G("ti-square-letter-g"),
  TI_SQUARE_LETTER_H("ti-square-letter-h"),
  TI_SQUARE_LETTER_I("ti-square-letter-i"),
  TI_SQUARE_LETTER_J("ti-square-letter-j"),
  TI_SQUARE_LETTER_K("ti-square-letter-k"),
  TI_SQUARE_LETTER_L("ti-square-letter-l"),
  TI_SQUARE_LETTER_M("ti-square-letter-m"),
  TI_SQUARE_LETTER_N("ti-square-letter-n"),
  TI_SQUARE_LETTER_O("ti-square-letter-o"),
  TI_SQUARE_LETTER_P("ti-square-letter-p"),
  TI_SQUARE_LETTER_Q("ti-square-letter-q"),
  TI_SQUARE_LETTER_R("ti-square-letter-r"),
  TI_SQUARE_LETTER_S("ti-square-letter-s"),
  TI_SQUARE_LETTER_T("ti-square-letter-t"),
  TI_SQUARE_LETTER_U("ti-square-letter-u"),
  TI_SQUARE_LETTER_V("ti-square-letter-v"),
  TI_SQUARE_LETTER_W("ti-square-letter-w"),
  TI_SQUARE_LETTER_X("ti-square-letter-x"),
  TI_SQUARE_LETTER_Y("ti-square-letter-y"),
  TI_SQUARE_LETTER_Z("ti-square-letter-z"),
  TI_SQUARE_MINUS("ti-square-minus"),
  TI_SQUARE_MINUS_2("ti-square-minus-2"),
  TI_SQUARE_NUMBER_0("ti-square-number-0"),
  TI_SQUARE_NUMBER_1("ti-square-number-1"),
  TI_SQUARE_NUMBER_2("ti-square-number-2"),
  TI_SQUARE_NUMBER_3("ti-square-number-3"),
  TI_SQUARE_NUMBER_4("ti-square-number-4"),
  TI_SQUARE_NUMBER_5("ti-square-number-5"),
  TI_SQUARE_NUMBER_6("ti-square-number-6"),
  TI_SQUARE_NUMBER_7("ti-square-number-7"),
  TI_SQUARE_NUMBER_8("ti-square-number-8"),
  TI_SQUARE_NUMBER_9("ti-square-number-9"),
  TI_SQUARE_OFF("ti-square-off"),
  TI_SQUARE_PERCENTAGE("ti-square-percentage"),
  TI_SQUARE_PLUS("ti-square-plus"),
  TI_SQUARE_PLUS_2("ti-square-plus-2"),
  TI_SQUARE_ROOT("ti-square-root"),
  TI_SQUARE_ROOT_2("ti-square-root-2"),
  TI_SQUARE_ROTATED("ti-square-rotated"),
  TI_SQUARE_ROTATED_ASTERISK("ti-square-rotated-asterisk"),
  TI_SQUARE_ROTATED_FORBID("ti-square-rotated-forbid"),
  TI_SQUARE_ROTATED_FORBID_2("ti-square-rotated-forbid-2"),
  TI_SQUARE_ROTATED_OFF("ti-square-rotated-off"),
  TI_SQUARE_ROUNDED("ti-square-rounded"),
  TI_SQUARE_ROUNDED_ARROW_DOWN("ti-square-rounded-arrow-down"),
  TI_SQUARE_ROUNDED_ARROW_LEFT("ti-square-rounded-arrow-left"),
  TI_SQUARE_ROUNDED_ARROW_RIGHT("ti-square-rounded-arrow-right"),
  TI_SQUARE_ROUNDED_ARROW_UP("ti-square-rounded-arrow-up"),
  TI_SQUARE_ROUNDED_CHECK("ti-square-rounded-check"),
  TI_SQUARE_ROUNDED_CHEVRON_DOWN("ti-square-rounded-chevron-down"),
  TI_SQUARE_ROUNDED_CHEVRON_LEFT("ti-square-rounded-chevron-left"),
  TI_SQUARE_ROUNDED_CHEVRON_RIGHT("ti-square-rounded-chevron-right"),
  TI_SQUARE_ROUNDED_CHEVRON_UP("ti-square-rounded-chevron-up"),
  TI_SQUARE_ROUNDED_CHEVRONS_DOWN("ti-square-rounded-chevrons-down"),
  TI_SQUARE_ROUNDED_CHEVRONS_LEFT("ti-square-rounded-chevrons-left"),
  TI_SQUARE_ROUNDED_CHEVRONS_RIGHT("ti-square-rounded-chevrons-right"),
  TI_SQUARE_ROUNDED_CHEVRONS_UP("ti-square-rounded-chevrons-up"),
  TI_SQUARE_ROUNDED_LETTER_A("ti-square-rounded-letter-a"),
  TI_SQUARE_ROUNDED_LETTER_B("ti-square-rounded-letter-b"),
  TI_SQUARE_ROUNDED_LETTER_C("ti-square-rounded-letter-c"),
  TI_SQUARE_ROUNDED_LETTER_D("ti-square-rounded-letter-d"),
  TI_SQUARE_ROUNDED_LETTER_E("ti-square-rounded-letter-e"),
  TI_SQUARE_ROUNDED_LETTER_F("ti-square-rounded-letter-f"),
  TI_SQUARE_ROUNDED_LETTER_G("ti-square-rounded-letter-g"),
  TI_SQUARE_ROUNDED_LETTER_H("ti-square-rounded-letter-h"),
  TI_SQUARE_ROUNDED_LETTER_I("ti-square-rounded-letter-i"),
  TI_SQUARE_ROUNDED_LETTER_J("ti-square-rounded-letter-j"),
  TI_SQUARE_ROUNDED_LETTER_K("ti-square-rounded-letter-k"),
  TI_SQUARE_ROUNDED_LETTER_L("ti-square-rounded-letter-l"),
  TI_SQUARE_ROUNDED_LETTER_M("ti-square-rounded-letter-m"),
  TI_SQUARE_ROUNDED_LETTER_N("ti-square-rounded-letter-n"),
  TI_SQUARE_ROUNDED_LETTER_O("ti-square-rounded-letter-o"),
  TI_SQUARE_ROUNDED_LETTER_P("ti-square-rounded-letter-p"),
  TI_SQUARE_ROUNDED_LETTER_Q("ti-square-rounded-letter-q"),
  TI_SQUARE_ROUNDED_LETTER_R("ti-square-rounded-letter-r"),
  TI_SQUARE_ROUNDED_LETTER_S("ti-square-rounded-letter-s"),
  TI_SQUARE_ROUNDED_LETTER_T("ti-square-rounded-letter-t"),
  TI_SQUARE_ROUNDED_LETTER_U("ti-square-rounded-letter-u"),
  TI_SQUARE_ROUNDED_LETTER_V("ti-square-rounded-letter-v"),
  TI_SQUARE_ROUNDED_LETTER_W("ti-square-rounded-letter-w"),
  TI_SQUARE_ROUNDED_LETTER_X("ti-square-rounded-letter-x"),
  TI_SQUARE_ROUNDED_LETTER_Y("ti-square-rounded-letter-y"),
  TI_SQUARE_ROUNDED_LETTER_Z("ti-square-rounded-letter-z"),
  TI_SQUARE_ROUNDED_MINUS("ti-square-rounded-minus"),
  TI_SQUARE_ROUNDED_MINUS_2("ti-square-rounded-minus-2"),
  TI_SQUARE_ROUNDED_NUMBER_0("ti-square-rounded-number-0"),
  TI_SQUARE_ROUNDED_NUMBER_1("ti-square-rounded-number-1"),
  TI_SQUARE_ROUNDED_NUMBER_2("ti-square-rounded-number-2"),
  TI_SQUARE_ROUNDED_NUMBER_3("ti-square-rounded-number-3"),
  TI_SQUARE_ROUNDED_NUMBER_4("ti-square-rounded-number-4"),
  TI_SQUARE_ROUNDED_NUMBER_5("ti-square-rounded-number-5"),
  TI_SQUARE_ROUNDED_NUMBER_6("ti-square-rounded-number-6"),
  TI_SQUARE_ROUNDED_NUMBER_7("ti-square-rounded-number-7"),
  TI_SQUARE_ROUNDED_NUMBER_8("ti-square-rounded-number-8"),
  TI_SQUARE_ROUNDED_NUMBER_9("ti-square-rounded-number-9"),
  TI_SQUARE_ROUNDED_PERCENTAGE("ti-square-rounded-percentage"),
  TI_SQUARE_ROUNDED_PLUS("ti-square-rounded-plus"),
  TI_SQUARE_ROUNDED_PLUS_2("ti-square-rounded-plus-2"),
  TI_SQUARE_ROUNDED_X("ti-square-rounded-x"),
  TI_SQUARE_TOGGLE("ti-square-toggle"),
  TI_SQUARE_TOGGLE_HORIZONTAL("ti-square-toggle-horizontal"),
  TI_SQUARE_X("ti-square-x"),
  TI_SQUARES("ti-squares"),
  TI_SQUARES_DIAGONAL("ti-squares-diagonal"),
  TI_SQUARES_SELECTED("ti-squares-selected"),
  TI_STACK("ti-stack"),
  TI_STACK_2("ti-stack-2"),
  TI_STACK_3("ti-stack-3"),
  TI_STACK_BACK("ti-stack-back"),
  TI_STACK_BACKWARD("ti-stack-backward"),
  TI_STACK_FORWARD("ti-stack-forward"),
  TI_STACK_FRONT("ti-stack-front"),
  TI_STACK_MIDDLE("ti-stack-middle"),
  TI_STACK_POP("ti-stack-pop"),
  TI_STACK_PUSH("ti-stack-push"),
  TI_STAIRS("ti-stairs"),
  TI_STAIRS_DOWN("ti-stairs-down"),
  TI_STAIRS_UP("ti-stairs-up"),
  TI_STAR("ti-star"),
  TI_STAR_HALF("ti-star-half"),
  TI_STAR_OFF("ti-star-off"),
  TI_STARS("ti-stars"),
  TI_STARS_OFF("ti-stars-off"),
  TI_STATUS_CHANGE("ti-status-change"),
  TI_STEAM("ti-steam"),
  TI_STEERING_WHEEL("ti-steering-wheel"),
  TI_STEERING_WHEEL_OFF("ti-steering-wheel-off"),
  TI_STEP_INTO("ti-step-into"),
  TI_STEP_OUT("ti-step-out"),
  TI_STEREO_GLASSES("ti-stereo-glasses"),
  TI_STETHOSCOPE("ti-stethoscope"),
  TI_STETHOSCOPE_OFF("ti-stethoscope-off"),
  TI_STICKER("ti-sticker"),
  TI_STICKER_2("ti-sticker-2"),
  TI_STOPWATCH("ti-stopwatch"),
  TI_STORM("ti-storm"),
  TI_STORM_OFF("ti-storm-off"),
  TI_STRETCHING("ti-stretching"),
  TI_STRETCHING_2("ti-stretching-2"),
  TI_STRIKETHROUGH("ti-strikethrough"),
  TI_STROKE_CURVED("ti-stroke-curved"),
  TI_STROKE_DYNAMIC("ti-stroke-dynamic"),
  TI_STROKE_STRAIGHT("ti-stroke-straight"),
  TI_SUBMARINE("ti-submarine"),
  TI_SUBSCRIPT("ti-subscript"),
  TI_SUBTASK("ti-subtask"),
  TI_SUBTITLES("ti-subtitles"),
  TI_SUBTITLES_AI("ti-subtitles-ai"),
  TI_SUBTITLES_EDIT("ti-subtitles-edit"),
  TI_SUBTITLES_OFF("ti-subtitles-off"),
  TI_SUM("ti-sum"),
  TI_SUM_OFF("ti-sum-off"),
  TI_SUN("ti-sun"),
  TI_SUN_ELECTRICITY("ti-sun-electricity"),
  TI_SUN_HIGH("ti-sun-high"),
  TI_SUN_LOW("ti-sun-low"),
  TI_SUN_MOON("ti-sun-moon"),
  TI_SUN_OFF("ti-sun-off"),
  TI_SUN_WIND("ti-sun-wind"),
  TI_SUNGLASSES("ti-sunglasses"),
  TI_SUNRISE("ti-sunrise"),
  TI_SUNSET("ti-sunset"),
  TI_SUNSET_2("ti-sunset-2"),
  TI_SUPERSCRIPT("ti-superscript"),
  TI_SVG("ti-svg"),
  TI_SWIMMING("ti-swimming"),
  TI_SWIPE("ti-swipe"),
  TI_SWIPE_DOWN("ti-swipe-down"),
  TI_SWIPE_LEFT("ti-swipe-left"),
  TI_SWIPE_RIGHT("ti-swipe-right"),
  TI_SWIPE_UP("ti-swipe-up"),
  TI_SWITCH("ti-switch"),
  TI_SWITCH_2("ti-switch-2"),
  TI_SWITCH_3("ti-switch-3"),
  TI_SWITCH_HORIZONTAL("ti-switch-horizontal"),
  TI_SWITCH_VERTICAL("ti-switch-vertical"),
  TI_SWORD("ti-sword"),
  TI_SWORD_OFF("ti-sword-off"),
  TI_SWORDS("ti-swords"),
  TI_TAB_CLOSE("ti-tab-close"),
  TI_TABLE("ti-table"),
  TI_TABLE_ALIAS("ti-table-alias"),
  TI_TABLE_COLUMN("ti-table-column"),
  TI_TABLE_DASHED("ti-table-dashed"),
  TI_TABLE_DOWN("ti-table-down"),
  TI_TABLE_EXPORT("ti-table-export"),
  TI_TABLE_HEART("ti-table-heart"),
  TI_TABLE_IMPORT("ti-table-import"),
  TI_TABLE_MINUS("ti-table-minus"),
  TI_TABLE_OFF("ti-table-off"),
  TI_TABLE_OPTIONS("ti-table-options"),
  TI_TABLE_PLUS("ti-table-plus"),
  TI_TABLE_ROW("ti-table-row"),
  TI_TABLE_SHARE("ti-table-share"),
  TI_TABLE_SHORTCUT("ti-table-shortcut"),
  TI_TABLE_SPARK("ti-table-spark"),
  TI_TABS("ti-tabs"),
  TI_TAG("ti-tag"),
  TI_TAG_MINUS("ti-tag-minus"),
  TI_TAG_OFF("ti-tag-off"),
  TI_TAG_PLUS("ti-tag-plus"),
  TI_TAG_STARRED("ti-tag-starred"),
  TI_TAGS("ti-tags"),
  TI_TAGS_CHEVRON_DOWN("ti-tags-chevron-down"),
  TI_TAGS_CHEVRON_LEFT("ti-tags-chevron-left"),
  TI_TAGS_CHEVRON_RIGHT("ti-tags-chevron-right"),
  TI_TAGS_CHEVRON_UP("ti-tags-chevron-up"),
  TI_TAGS_OFF("ti-tags-off"),
  TI_TAIWAN_DOLLAR("ti-taiwan-dollar"),
  TI_TALLYMARK_1("ti-tallymark-1"),
  TI_TALLYMARK_2("ti-tallymark-2"),
  TI_TALLYMARK_3("ti-tallymark-3"),
  TI_TALLYMARK_4("ti-tallymark-4"),
  TI_TALLYMARKS("ti-tallymarks"),
  TI_TANK("ti-tank"),
  TI_TARGET("ti-target"),
  TI_TARGET_2("ti-target-2"),
  TI_TARGET_ARROW("ti-target-arrow"),
  TI_TARGET_OFF("ti-target-off"),
  TI_TAX("ti-tax"),
  TI_TAX_EURO("ti-tax-euro"),
  TI_TAX_POUND("ti-tax-pound"),
  TI_TEAPOT("ti-teapot"),
  TI_TELESCOPE("ti-telescope"),
  TI_TELESCOPE_OFF("ti-telescope-off"),
  TI_TEMPERATURE("ti-temperature"),
  TI_TEMPERATURE_CELSIUS("ti-temperature-celsius"),
  TI_TEMPERATURE_FAHRENHEIT("ti-temperature-fahrenheit"),
  TI_TEMPERATURE_MINUS("ti-temperature-minus"),
  TI_TEMPERATURE_OFF("ti-temperature-off"),
  TI_TEMPERATURE_PLUS("ti-temperature-plus"),
  TI_TEMPERATURE_SNOW("ti-temperature-snow"),
  TI_TEMPERATURE_SUN("ti-temperature-sun"),
  TI_TEMPLATE("ti-template"),
  TI_TEMPLATE_OFF("ti-template-off"),
  TI_TENT("ti-tent"),
  TI_TENT_OFF("ti-tent-off"),
  TI_TERMINAL("ti-terminal"),
  TI_TERMINAL_2("ti-terminal-2"),
  TI_TEST_PIPE("ti-test-pipe"),
  TI_TEST_PIPE_2("ti-test-pipe-2"),
  TI_TEST_PIPE_OFF("ti-test-pipe-off"),
  TI_TEX("ti-tex"),
  TI_TEXT_CAPTION("ti-text-caption"),
  TI_TEXT_COLOR("ti-text-color"),
  TI_TEXT_DECREASE("ti-text-decrease"),
  TI_TEXT_DIRECTION_LTR("ti-text-direction-ltr"),
  TI_TEXT_DIRECTION_RTL("ti-text-direction-rtl"),
  TI_TEXT_GRAMMAR("ti-text-grammar"),
  TI_TEXT_INCREASE("ti-text-increase"),
  TI_TEXT_ORIENTATION("ti-text-orientation"),
  TI_TEXT_OUTLINE("ti-text-outline"),
  TI_TEXT_PLUS("ti-text-plus"),
  TI_TEXT_RECOGNITION("ti-text-recognition"),
  TI_TEXT_REGEX_ASTERISK("ti-text-regex-asterisk"),
  TI_TEXT_REGEX_END("ti-text-regex-end"),
  TI_TEXT_REGEX_PLUS("ti-text-regex-plus"),
  TI_TEXT_REGEX_QUESTION("ti-text-regex-question"),
  TI_TEXT_REGEX_START("ti-text-regex-start"),
  TI_TEXT_RESIZE("ti-text-resize"),
  TI_TEXT_SCAN_2("ti-text-scan-2"),
  TI_TEXT_SCAN_AI("ti-text-scan-ai"),
  TI_TEXT_SIZE("ti-text-size"),
  TI_TEXT_SPELLCHECK("ti-text-spellcheck"),
  TI_TEXT_WRAP("ti-text-wrap"),
  TI_TEXT_WRAP_COLUMN("ti-text-wrap-column"),
  TI_TEXT_WRAP_DISABLED("ti-text-wrap-disabled"),
  TI_TEXTURE("ti-texture"),
  TI_THEATER("ti-theater"),
  TI_THERMOMETER("ti-thermometer"),
  TI_THINKING_HIGH("ti-thinking-high"),
  TI_THINKING_LOW("ti-thinking-low"),
  TI_THINKING_MEDIUM("ti-thinking-medium"),
  TI_THUMB_DOWN("ti-thumb-down"),
  TI_THUMB_DOWN_OFF("ti-thumb-down-off"),
  TI_THUMB_UP("ti-thumb-up"),
  TI_THUMB_UP_OFF("ti-thumb-up-off"),
  TI_TIC_TAC("ti-tic-tac"),
  TI_TICKET("ti-ticket"),
  TI_TICKET_OFF("ti-ticket-off"),
  TI_TIE("ti-tie"),
  TI_TILDE("ti-tilde"),
  TI_TILT_SHIFT("ti-tilt-shift"),
  TI_TILT_SHIFT_OFF("ti-tilt-shift-off"),
  TI_TIME_DURATION_0("ti-time-duration-0"),
  TI_TIME_DURATION_10("ti-time-duration-10"),
  TI_TIME_DURATION_15("ti-time-duration-15"),
  TI_TIME_DURATION_30("ti-time-duration-30"),
  TI_TIME_DURATION_45("ti-time-duration-45"),
  TI_TIME_DURATION_5("ti-time-duration-5"),
  TI_TIME_DURATION_60("ti-time-duration-60"),
  TI_TIME_DURATION_90("ti-time-duration-90"),
  TI_TIME_DURATION_OFF("ti-time-duration-off"),
  TI_TIMELINE("ti-timeline"),
  TI_TIMELINE_EVENT("ti-timeline-event"),
  TI_TIMELINE_EVENT_EXCLAMATION("ti-timeline-event-exclamation"),
  TI_TIMELINE_EVENT_MINUS("ti-timeline-event-minus"),
  TI_TIMELINE_EVENT_PLUS("ti-timeline-event-plus"),
  TI_TIMELINE_EVENT_TEXT("ti-timeline-event-text"),
  TI_TIMELINE_EVENT_X("ti-timeline-event-x"),
  TI_TIMEZONE("ti-timezone"),
  TI_TIP_JAR("ti-tip-jar"),
  TI_TIP_JAR_EURO("ti-tip-jar-euro"),
  TI_TIP_JAR_POUND("ti-tip-jar-pound"),
  TI_TIR("ti-tir"),
  TI_TOGGLE_LEFT("ti-toggle-left"),
  TI_TOGGLE_RIGHT("ti-toggle-right"),
  TI_TOILET_PAPER("ti-toilet-paper"),
  TI_TOILET_PAPER_OFF("ti-toilet-paper-off"),
  TI_TOML("ti-toml"),
  TI_TOOL("ti-tool"),
  TI_TOOLS("ti-tools"),
  TI_TOOLS_KITCHEN("ti-tools-kitchen"),
  TI_TOOLS_KITCHEN_2("ti-tools-kitchen-2"),
  TI_TOOLS_KITCHEN_2_OFF("ti-tools-kitchen-2-off"),
  TI_TOOLS_KITCHEN_3("ti-tools-kitchen-3"),
  TI_TOOLS_KITCHEN_OFF("ti-tools-kitchen-off"),
  TI_TOOLS_OFF("ti-tools-off"),
  TI_TOOLTIP("ti-tooltip"),
  TI_TOPOLOGY_BUS("ti-topology-bus"),
  TI_TOPOLOGY_COMPLEX("ti-topology-complex"),
  TI_TOPOLOGY_FULL("ti-topology-full"),
  TI_TOPOLOGY_FULL_HIERARCHY("ti-topology-full-hierarchy"),
  TI_TOPOLOGY_RING("ti-topology-ring"),
  TI_TOPOLOGY_RING_2("ti-topology-ring-2"),
  TI_TOPOLOGY_RING_3("ti-topology-ring-3"),
  TI_TOPOLOGY_STAR("ti-topology-star"),
  TI_TOPOLOGY_STAR_2("ti-topology-star-2"),
  TI_TOPOLOGY_STAR_3("ti-topology-star-3"),
  TI_TOPOLOGY_STAR_RING("ti-topology-star-ring"),
  TI_TOPOLOGY_STAR_RING_2("ti-topology-star-ring-2"),
  TI_TOPOLOGY_STAR_RING_3("ti-topology-star-ring-3"),
  TI_TORII("ti-torii"),
  TI_TORNADO("ti-tornado"),
  TI_TOURNAMENT("ti-tournament"),
  TI_TOWER("ti-tower"),
  TI_TOWER_OFF("ti-tower-off"),
  TI_TRACK("ti-track"),
  TI_TRACTOR("ti-tractor"),
  TI_TRADEMARK("ti-trademark"),
  TI_TRAFFIC_CONE("ti-traffic-cone"),
  TI_TRAFFIC_CONE_OFF("ti-traffic-cone-off"),
  TI_TRAFFIC_LIGHTS("ti-traffic-lights"),
  TI_TRAFFIC_LIGHTS_OFF("ti-traffic-lights-off"),
  TI_TRAIN("ti-train"),
  TI_TRANSACTION_BITCOIN("ti-transaction-bitcoin"),
  TI_TRANSACTION_DOLLAR("ti-transaction-dollar"),
  TI_TRANSACTION_EURO("ti-transaction-euro"),
  TI_TRANSACTION_POUND("ti-transaction-pound"),
  TI_TRANSACTION_RUPEE("ti-transaction-rupee"),
  TI_TRANSACTION_YEN("ti-transaction-yen"),
  TI_TRANSACTION_YUAN("ti-transaction-yuan"),
  TI_TRANSFER("ti-transfer"),
  TI_TRANSFER_IN("ti-transfer-in"),
  TI_TRANSFER_OUT("ti-transfer-out"),
  TI_TRANSFER_VERTICAL("ti-transfer-vertical"),
  TI_TRANSFORM("ti-transform"),
  TI_TRANSFORM_POINT("ti-transform-point"),
  TI_TRANSFORM_POINT_BOTTOM_LEFT("ti-transform-point-bottom-left"),
  TI_TRANSFORM_POINT_BOTTOM_RIGHT("ti-transform-point-bottom-right"),
  TI_TRANSFORM_POINT_TOP_LEFT("ti-transform-point-top-left"),
  TI_TRANSFORM_POINT_TOP_RIGHT("ti-transform-point-top-right"),
  TI_TRANSITION_BOTTOM("ti-transition-bottom"),
  TI_TRANSITION_LEFT("ti-transition-left"),
  TI_TRANSITION_RIGHT("ti-transition-right"),
  TI_TRANSITION_TOP("ti-transition-top"),
  TI_TRASH("ti-trash"),
  TI_TRASH_OFF("ti-trash-off"),
  TI_TRASH_X("ti-trash-x"),
  TI_TREADMILL("ti-treadmill"),
  TI_TREASURE_CHEST("ti-treasure-chest"),
  TI_TREE("ti-tree"),
  TI_TREES("ti-trees"),
  TI_TREKKING("ti-trekking"),
  TI_TRENDING_DOWN("ti-trending-down"),
  TI_TRENDING_DOWN_2("ti-trending-down-2"),
  TI_TRENDING_DOWN_3("ti-trending-down-3"),
  TI_TRENDING_UP("ti-trending-up"),
  TI_TRENDING_UP_2("ti-trending-up-2"),
  TI_TRENDING_UP_3("ti-trending-up-3"),
  TI_TRENDING_UP_DOWN("ti-trending-up-down"),
  TI_TRIANGLE("ti-triangle"),
  TI_TRIANGLE_INVERTED("ti-triangle-inverted"),
  TI_TRIANGLE_MINUS("ti-triangle-minus"),
  TI_TRIANGLE_MINUS_2("ti-triangle-minus-2"),
  TI_TRIANGLE_OFF("ti-triangle-off"),
  TI_TRIANGLE_PLUS("ti-triangle-plus"),
  TI_TRIANGLE_PLUS_2("ti-triangle-plus-2"),
  TI_TRIANGLE_SQUARE_CIRCLE("ti-triangle-square-circle"),
  TI_TRIANGLES("ti-triangles"),
  TI_TRIDENT("ti-trident"),
  TI_TROLLEY("ti-trolley"),
  TI_TROPHY("ti-trophy"),
  TI_TROPHY_OFF("ti-trophy-off"),
  TI_TROWEL("ti-trowel"),
  TI_TRUCK("ti-truck"),
  TI_TRUCK_DELIVERY("ti-truck-delivery"),
  TI_TRUCK_LOADING("ti-truck-loading"),
  TI_TRUCK_OFF("ti-truck-off"),
  TI_TRUCK_RETURN("ti-truck-return"),
  TI_TWIG("ti-twig"),
  TI_TXT("ti-txt"),
  TI_TYPEFACE("ti-typeface"),
  TI_TYPOGRAPHY("ti-typography"),
  TI_TYPOGRAPHY_OFF("ti-typography-off"),
  TI_U_TURN_LEFT("ti-u-turn-left"),
  TI_U_TURN_RIGHT("ti-u-turn-right"),
  TI_UFO("ti-ufo"),
  TI_UFO_OFF("ti-ufo-off"),
  TI_UHD("ti-uhd"),
  TI_UMBRELLA("ti-umbrella"),
  TI_UMBRELLA_2("ti-umbrella-2"),
  TI_UMBRELLA_CLOSED("ti-umbrella-closed"),
  TI_UMBRELLA_CLOSED_2("ti-umbrella-closed-2"),
  TI_UMBRELLA_OFF("ti-umbrella-off"),
  TI_UNDERLINE("ti-underline"),
  TI_UNDERLINE_OFF("ti-underline-off"),
  TI_UNICYCLE("ti-unicycle"),
  TI_UNIVERSE("ti-universe"),
  TI_UNLINK("ti-unlink"),
  TI_UPLOAD("ti-upload"),
  TI_URGENT("ti-urgent"),
  TI_USB("ti-usb"),
  TI_USER("ti-user"),
  TI_USER_BITCOIN("ti-user-bitcoin"),
  TI_USER_BOLT("ti-user-bolt"),
  TI_USER_CANCEL("ti-user-cancel"),
  TI_USER_CHECK("ti-user-check"),
  TI_USER_CIRCLE("ti-user-circle"),
  TI_USER_CODE("ti-user-code"),
  TI_USER_COG("ti-user-cog"),
  TI_USER_DOLLAR("ti-user-dollar"),
  TI_USER_DOWN("ti-user-down"),
  TI_USER_EDIT("ti-user-edit"),
  TI_USER_EXCLAMATION("ti-user-exclamation"),
  TI_USER_HEART("ti-user-heart"),
  TI_USER_HEXAGON("ti-user-hexagon"),
  TI_USER_KEY("ti-user-key"),
  TI_USER_MINUS("ti-user-minus"),
  TI_USER_OFF("ti-user-off"),
  TI_USER_PAUSE("ti-user-pause"),
  TI_USER_PENTAGON("ti-user-pentagon"),
  TI_USER_PIN("ti-user-pin"),
  TI_USER_PLUS("ti-user-plus"),
  TI_USER_QUESTION("ti-user-question"),
  TI_USER_SCAN("ti-user-scan"),
  TI_USER_SCREEN("ti-user-screen"),
  TI_USER_SEARCH("ti-user-search"),
  TI_USER_SHARE("ti-user-share"),
  TI_USER_SHIELD("ti-user-shield"),
  TI_USER_SQUARE("ti-user-square"),
  TI_USER_SQUARE_ROUNDED("ti-user-square-rounded"),
  TI_USER_STAR("ti-user-star"),
  TI_USER_UP("ti-user-up"),
  TI_USER_X("ti-user-x"),
  TI_USERS("ti-users"),
  TI_USERS_GROUP("ti-users-group"),
  TI_USERS_MINUS("ti-users-minus"),
  TI_USERS_PLUS("ti-users-plus"),
  TI_UV_INDEX("ti-uv-index"),
  TI_UX_CIRCLE("ti-ux-circle"),
  TI_VACCINE("ti-vaccine"),
  TI_VACCINE_BOTTLE("ti-vaccine-bottle"),
  TI_VACCINE_BOTTLE_OFF("ti-vaccine-bottle-off"),
  TI_VACCINE_OFF("ti-vaccine-off"),
  TI_VACUUM_CLEANER("ti-vacuum-cleaner"),
  TI_VARIABLE("ti-variable"),
  TI_VARIABLE_MINUS("ti-variable-minus"),
  TI_VARIABLE_OFF("ti-variable-off"),
  TI_VARIABLE_PLUS("ti-variable-plus"),
  TI_VAULT("ti-vault"),
  TI_VECTOR("ti-vector"),
  TI_VECTOR_BEZIER("ti-vector-bezier"),
  TI_VECTOR_BEZIER_2("ti-vector-bezier-2"),
  TI_VECTOR_BEZIER_ARC("ti-vector-bezier-arc"),
  TI_VECTOR_BEZIER_CIRCLE("ti-vector-bezier-circle"),
  TI_VECTOR_OFF("ti-vector-off"),
  TI_VECTOR_SPLINE("ti-vector-spline"),
  TI_VECTOR_TRIANGLE("ti-vector-triangle"),
  TI_VECTOR_TRIANGLE_OFF("ti-vector-triangle-off"),
  TI_VENUS("ti-venus"),
  TI_VERSIONS("ti-versions"),
  TI_VERSIONS_OFF("ti-versions-off"),
  TI_VIDEO("ti-video"),
  TI_VIDEO_MINUS("ti-video-minus"),
  TI_VIDEO_OFF("ti-video-off"),
  TI_VIDEO_PLUS("ti-video-plus"),
  TI_VIEW_360("ti-view-360"),
  TI_VIEW_360_ARROW("ti-view-360-arrow"),
  TI_VIEW_360_NUMBER("ti-view-360-number"),
  TI_VIEW_360_OFF("ti-view-360-off"),
  TI_VIEWFINDER("ti-viewfinder"),
  TI_VIEWFINDER_OFF("ti-viewfinder-off"),
  TI_VIEWPORT_NARROW("ti-viewport-narrow"),
  TI_VIEWPORT_SHORT("ti-viewport-short"),
  TI_VIEWPORT_TALL("ti-viewport-tall"),
  TI_VIEWPORT_WIDE("ti-viewport-wide"),
  TI_VIGNETTE("ti-vignette"),
  TI_VINYL("ti-vinyl"),
  TI_VIP("ti-vip"),
  TI_VIP_2("ti-vip-2"),
  TI_VIP_OFF("ti-vip-off"),
  TI_VIRTUAL_SPACE("ti-virtual-space"),
  TI_VIRUS("ti-virus"),
  TI_VIRUS_OFF("ti-virus-off"),
  TI_VIRUS_SEARCH("ti-virus-search"),
  TI_VOCABULARY("ti-vocabulary"),
  TI_VOCABULARY_OFF("ti-vocabulary-off"),
  TI_VOLCANO("ti-volcano"),
  TI_VOLUME("ti-volume"),
  TI_VOLUME_2("ti-volume-2"),
  TI_VOLUME_3("ti-volume-3"),
  TI_VOLUME_4("ti-volume-4"),
  TI_VOLUME_OFF("ti-volume-off"),
  TI_VS("ti-vs"),
  TI_WALK("ti-walk"),
  TI_WALL("ti-wall"),
  TI_WALL_OFF("ti-wall-off"),
  TI_WALLET("ti-wallet"),
  TI_WALLET_OFF("ti-wallet-off"),
  TI_WALLPAPER("ti-wallpaper"),
  TI_WALLPAPER_OFF("ti-wallpaper-off"),
  TI_WAND("ti-wand"),
  TI_WAND_OFF("ti-wand-off"),
  TI_WASH("ti-wash"),
  TI_WASH_DRY("ti-wash-dry"),
  TI_WASH_DRY_1("ti-wash-dry-1"),
  TI_WASH_DRY_2("ti-wash-dry-2"),
  TI_WASH_DRY_3("ti-wash-dry-3"),
  TI_WASH_DRY_A("ti-wash-dry-a"),
  TI_WASH_DRY_DIP("ti-wash-dry-dip"),
  TI_WASH_DRY_F("ti-wash-dry-f"),
  TI_WASH_DRY_FLAT("ti-wash-dry-flat"),
  TI_WASH_DRY_HANG("ti-wash-dry-hang"),
  TI_WASH_DRY_OFF("ti-wash-dry-off"),
  TI_WASH_DRY_P("ti-wash-dry-p"),
  TI_WASH_DRY_SHADE("ti-wash-dry-shade"),
  TI_WASH_DRY_W("ti-wash-dry-w"),
  TI_WASH_DRYCLEAN("ti-wash-dryclean"),
  TI_WASH_DRYCLEAN_OFF("ti-wash-dryclean-off"),
  TI_WASH_ECO("ti-wash-eco"),
  TI_WASH_GENTLE("ti-wash-gentle"),
  TI_WASH_HAND("ti-wash-hand"),
  TI_WASH_MACHINE("ti-wash-machine"),
  TI_WASH_OFF("ti-wash-off"),
  TI_WASH_PRESS("ti-wash-press"),
  TI_WASH_TEMPERATURE_1("ti-wash-temperature-1"),
  TI_WASH_TEMPERATURE_2("ti-wash-temperature-2"),
  TI_WASH_TEMPERATURE_3("ti-wash-temperature-3"),
  TI_WASH_TEMPERATURE_4("ti-wash-temperature-4"),
  TI_WASH_TEMPERATURE_5("ti-wash-temperature-5"),
  TI_WASH_TEMPERATURE_6("ti-wash-temperature-6"),
  TI_WASH_TUMBLE_DRY("ti-wash-tumble-dry"),
  TI_WASH_TUMBLE_OFF("ti-wash-tumble-off"),
  TI_WATERPOLO("ti-waterpolo"),
  TI_WAVE_SAW_TOOL("ti-wave-saw-tool"),
  TI_WAVE_SINE("ti-wave-sine"),
  TI_WAVE_SQUARE("ti-wave-square"),
  TI_WAVES_ELECTRICITY("ti-waves-electricity"),
  TI_WEBHOOK("ti-webhook"),
  TI_WEBHOOK_OFF("ti-webhook-off"),
  TI_WEIGHT("ti-weight"),
  TI_WHEAT("ti-wheat"),
  TI_WHEAT_OFF("ti-wheat-off"),
  TI_WHEEL("ti-wheel"),
  TI_WHEELCHAIR("ti-wheelchair"),
  TI_WHEELCHAIR_OFF("ti-wheelchair-off"),
  TI_WHIRL("ti-whirl"),
  TI_WHISK("ti-whisk"),
  TI_WIFI("ti-wifi"),
  TI_WIFI_0("ti-wifi-0"),
  TI_WIFI_1("ti-wifi-1"),
  TI_WIFI_2("ti-wifi-2"),
  TI_WIFI_OFF("ti-wifi-off"),
  TI_WIND("ti-wind"),
  TI_WIND_ELECTRICITY("ti-wind-electricity"),
  TI_WIND_OFF("ti-wind-off"),
  TI_WINDMILL("ti-windmill"),
  TI_WINDMILL_OFF("ti-windmill-off"),
  TI_WINDOW("ti-window"),
  TI_WINDOW_MAXIMIZE("ti-window-maximize"),
  TI_WINDOW_MINIMIZE("ti-window-minimize"),
  TI_WINDOW_OFF("ti-window-off"),
  TI_WINDSOCK("ti-windsock"),
  TI_WIPER("ti-wiper"),
  TI_WIPER_WASH("ti-wiper-wash"),
  TI_WOMAN("ti-woman"),
  TI_WOOD("ti-wood"),
  TI_WORLD("ti-world"),
  TI_WORLD_BOLT("ti-world-bolt"),
  TI_WORLD_CANCEL("ti-world-cancel"),
  TI_WORLD_CHECK("ti-world-check"),
  TI_WORLD_CODE("ti-world-code"),
  TI_WORLD_COG("ti-world-cog"),
  TI_WORLD_DOLLAR("ti-world-dollar"),
  TI_WORLD_DOWN("ti-world-down"),
  TI_WORLD_DOWNLOAD("ti-world-download"),
  TI_WORLD_EXCLAMATION("ti-world-exclamation"),
  TI_WORLD_HEART("ti-world-heart"),
  TI_WORLD_LATITUDE("ti-world-latitude"),
  TI_WORLD_LONGITUDE("ti-world-longitude"),
  TI_WORLD_MAP("ti-world-map"),
  TI_WORLD_MINUS("ti-world-minus"),
  TI_WORLD_OFF("ti-world-off"),
  TI_WORLD_PAUSE("ti-world-pause"),
  TI_WORLD_PIN("ti-world-pin"),
  TI_WORLD_PLUS("ti-world-plus"),
  TI_WORLD_QUESTION("ti-world-question"),
  TI_WORLD_SEARCH("ti-world-search"),
  TI_WORLD_SHARE("ti-world-share"),
  TI_WORLD_STAR("ti-world-star"),
  TI_WORLD_UP("ti-world-up"),
  TI_WORLD_UPLOAD("ti-world-upload"),
  TI_WORLD_WWW("ti-world-www"),
  TI_WORLD_X("ti-world-x"),
  TI_WRECKING_BALL("ti-wrecking-ball"),
  TI_WRITING("ti-writing"),
  TI_WRITING_OFF("ti-writing-off"),
  TI_WRITING_SIGN("ti-writing-sign"),
  TI_WRITING_SIGN_OFF("ti-writing-sign-off"),
  TI_X("ti-x"),
  TI_X_MARK("ti-x-mark"),
  TI_X_POWER_Y("ti-x-power-y"),
  TI_XBOX_A("ti-xbox-a"),
  TI_XBOX_B("ti-xbox-b"),
  TI_XBOX_X("ti-xbox-x"),
  TI_XBOX_Y("ti-xbox-y"),
  TI_XD("ti-xd"),
  TI_XXX("ti-xxx"),
  TI_YARN("ti-yarn"),
  TI_YIN_YANG("ti-yin-yang"),
  TI_YOGA("ti-yoga"),
  TI_ZEPPELIN("ti-zeppelin"),
  TI_ZEPPELIN_OFF("ti-zeppelin-off"),
  TI_ZERO_CONFIG("ti-zero-config"),
  TI_ZIP("ti-zip"),
  TI_ZODIAC_AQUARIUS("ti-zodiac-aquarius"),
  TI_ZODIAC_ARIES("ti-zodiac-aries"),
  TI_ZODIAC_CANCER("ti-zodiac-cancer"),
  TI_ZODIAC_CAPRICORN("ti-zodiac-capricorn"),
  TI_ZODIAC_GEMINI("ti-zodiac-gemini"),
  TI_ZODIAC_LEO("ti-zodiac-leo"),
  TI_ZODIAC_LIBRA("ti-zodiac-libra"),
  TI_ZODIAC_PISCES("ti-zodiac-pisces"),
  TI_ZODIAC_SAGITTARIUS("ti-zodiac-sagittarius"),
  TI_ZODIAC_SCORPIO("ti-zodiac-scorpio"),
  TI_ZODIAC_TAURUS("ti-zodiac-taurus"),
  TI_ZODIAC_VIRGO("ti-zodiac-virgo"),
  TI_ZOOM("ti-zoom"),
  TI_ZOOM_CANCEL("ti-zoom-cancel"),
  TI_ZOOM_CHECK("ti-zoom-check"),
  TI_ZOOM_CODE("ti-zoom-code"),
  TI_ZOOM_EXCLAMATION("ti-zoom-exclamation"),
  TI_ZOOM_IN("ti-zoom-in"),
  TI_ZOOM_IN_AREA("ti-zoom-in-area"),
  TI_ZOOM_MONEY("ti-zoom-money"),
  TI_ZOOM_OUT("ti-zoom-out"),
  TI_ZOOM_OUT_AREA("ti-zoom-out-area"),
  TI_ZOOM_PAN("ti-zoom-pan"),
  TI_ZOOM_QUESTION("ti-zoom-question"),
  TI_ZOOM_REPLACE("ti-zoom-replace"),
  TI_ZOOM_RESET("ti-zoom-reset"),
  TI_ZOOM_SCAN("ti-zoom-scan"),
  TI_ZZZ("ti-zzz"),
  TI_ZZZ_OFF("ti-zzz-off"),
  ;


  private val modifier: Modifier by lazy {
    Modifier.classNames("ti", value)
  }

  override fun <R> fold(initial: R, operation: (R, Modifier.Element) -> R): R = modifier.fold(initial, operation)

  override fun then(other: Modifier): Modifier = modifier.then(other)


  @Composable
  override fun invoke(modifier: Modifier) {
    icon(this)(modifier)
  }
}
